import { ActionContext, Store } from "vuex";
import { getStoreAccessors } from "vuex-typescript";
import { State as RootState } from '../state';
import { DataState } from './dataState';
import { dataService } from "../../_services/data-service";
import { UserInfo } from "../../_models/userInfo"
import { ComuniInfo } from "../../_models/comuniInfo"
import { EnterpriseInfo } from '@/_models/enterpriseInfo';
import { StudentInfo } from '@/_models/studentInfo';
import { AtecoInfo } from "@/_models/atecoInfo";
import { IstatInfo } from '@/_models/istatInfo';
import { StudentAuthorization } from '@/_models/studentAuthorization';
import { EnterpriseNominaResp } from '@/_models/enterpriseNominaResp';
import { DocAutorizzazioneInfo } from '@/_models/docAutorizzazioneInfo';
import { InstituteInfo } from '@/_models/instituteInfo';
import { StatesInfo } from '@/_models/statesInfo';
import { DocNominaResponsabileInfo } from '@/_models/docNominaResponsabileInfo';
import { ArticolazioneInfo } from '@/_models/articolazioneInfo';
import { RichiestaAlternanza } from '@/_models/richiestaAlternanza';
import { StudentSettoreInfo } from '@/_models/studentSettore';
import { TutorInfo } from '@/_models/tutorInfo';
import { StudentTutorInfo } from '@/_models/studentTutor';
import { IndirizzoStudioInfo } from '@/_models/indirizzoStudioInfo';
import { StudentAssignmentInfo } from '@/_models/studentAssignment';
import { AreaInfo } from '@/_models/areaInfo';
import { AllievoAreaInfo } from '@/_models/allievoAreaInfo';
import { AziendaAreaInfo } from '@/_models/aziendaAreaInfo';
import { ColloquiInfo } from '@/_models/colloquiInfo';
import { AllievoColloquiIdentifier } from '@/_models/allievoColloquiIdentifier';
import { AziendaColloquioIdentifier } from '@/_models/aziendaColloquioIdentifier';
import { RichiestaTirEstivi } from '@/_models/richiestaTirEstivi';
import { StudentAssignmentTirEstivoInfo } from '@/_models/StudentAssignmentTirEstivo';
import { StudentAssignmentTirFormativoInfo } from '@/_models/studentAssignmentTirFormativo'
import { TutorFormativoInfo } from '@/_models/tutorFormativoInfo';
import { ClasseInfo } from '@/_models/classeInfo';
import { DocConvenzione } from '@/_models/docConvenzione';
import { DocProgettoOrientamento } from '@/_models/docProgettoOrientamento';
import { RichiestaTirFormativi } from '@/_models/richiestaTirFormativi';
import { ReportVisiteInfo } from '@/_models/reportVisiteInfo';
import { DocConsenso } from '@/_models/docConsenso';
import { DocAttestatoFinale } from '@/_models/docAttestatoFinale';
import { readUserInfo } from '../user.module';
import { DomandeQuestionario } from '@/_models/domandeQuestionario';
import { RispostaQuestionario } from '@/_models/rispostaQuestionario';
import { AttivitaIstituto } from '@/_models/attivitaIstituto';
import { StudentAssignmentCompleteTirEstivo } from '@/_models/studentAssigmentCompleteTirEstivo';
import { DocPercorsoFormativo } from '@/_models/docPercorsoFormativo';
import { DocPattoFormativo } from '@/_models/docPattoFormativo';
import { StudentAssignmentCompleteAlternanza } from '@/_models/studentAssignmentCompleteAlternanza';
import { AnnoScolasticoInfo } from '@/_models/annoScolasticoInfo';
import { StoricoInfo } from '@/_models/storicoInfo';
import { RichiestaAttivita } from '@/_models/richiestaAttivita';
import { StudentAssignmentCompleteTirFormativo } from '@/_models/studentAssignmentCompleteTirFormativo';
import { TipoContrattoInfo } from '@/_models/tipoContratto';
import { PropostaLavoroInfo } from '@/_models/propostaLavoroInfo';
import { PropostaLavoroAllievo } from '@/_models/propostaLavoroAllievo';
import { CandidaturaPropostaLavoro } from '@/_models/candidaturaPropostaLavoro';
import { userUtils } from '../../_utils'
import { ContattoAziendaInfo } from "@/_models/contattoAzienda";
import { StudentSubscription } from "@/_models/studentSubscription";
import { NotaAzienda } from "@/_models/notaAzienda";

type DataContext = ActionContext<DataState, RootState>;

export const data = {
    namespaced: true,
    state: {
        statiList: null,
        comuniList: null,
        atecoList: null,
        istatList: null,
        anniScolasticiList: null,
        docNominaResponsabile: null,
        docAutorizzazioneStudente: null,
        tipiContrattoList: null
    },

    getters: {
        getComuniList(state: DataState) {
            return state.comuniList
        },
        getAtecoList(state: DataState) {
            return state.atecoList
        },
        getIstatList(state: DataState) {
            return state.istatList
        },
        getAnniScolasticiList(state: DataState) {
            return state.anniScolasticiList
        },
        getDocNominaResponsabile(state: DataState) {
            return state.docNominaResponsabile
        },
        getDocAutorizzazioneStudente(state: DataState) {
            return state.docAutorizzazioneStudente
        },
        getStatiList(state: DataState) {
            return state.statiList
        },
        getTipiContrattoList(state: DataState) {
            return state.tipiContrattoList
        }
    },

    mutations: {
        setComuniList(state: DataState, comuniList: ComuniInfo[]) {
            state.comuniList = comuniList
        },
        setAtecoList(state: DataState, atecoList: AtecoInfo[]) {
            state.atecoList = atecoList
        },
        setIstatList(state: DataState, istatList: IstatInfo[]) {
            state.istatList = istatList
        },
        setAnniScolasticiList(state: DataState, anniScolasticiList: AnnoScolasticoInfo[]) {
            state.anniScolasticiList = anniScolasticiList
        },
        setDocNominaResp(state: DataState, docNominaResp: DocNominaResponsabileInfo) {
            state.docNominaResponsabile = docNominaResp
        },
        setDocAutorizzazioneStudente(state: DataState, docAutorizzazioneStudente: DocAutorizzazioneInfo) {
            state.docAutorizzazioneStudente = docAutorizzazioneStudente
        },
        setStatiList(state: DataState, statiList: StatesInfo[]) {
            state.statiList = statiList
        },
        setTipiContrattoList(state: DataState, tipiContrattoList: TipoContrattoInfo[]) {
            state.tipiContrattoList = tipiContrattoList
        }
    },
    actions: {
        getUsersList(context: DataContext, payload: { idEntità: number, idTipoSoggetto: number }) {
            return new Promise<UserInfo[]>((resolve, reject) => {
                var usersList: any[];
                var item: UserInfo;
                var roles: number[] = []
                var descRoles: string[] = []
                if (payload.idTipoSoggetto === 2) {
                    dataService.getUsersList(payload.idEntità, payload.idTipoSoggetto)
                        .then(response => {
                            usersList = []
                            response.forEach(function (element: any) {
                                dataService.getUserRole(element.Utente)
                                    .then(resp => {
                                        resp.forEach((element: any) => {
                                            roles.push(element.IdRuolo)
                                            descRoles.push(element.Descrizione + "; ")
                                        });
                                        item = {
                                            tipoSoggetto: element.IdTipoSoggetto,
                                            ruoloUtente: roles,
                                            descrizioneRuolo: descRoles,
                                            nomeUtente: element.Nome,
                                            cognomeUtente: element.Cognome,
                                            indirizzoUtente: element.Indirizzo,
                                            telefono1Utente: element.Telefono1,
                                            telefono2Utente: element.Telefono2,
                                            cod: element.CodiceFiscale,
                                            dataNascita: element.DataNascita,
                                            luogoNascita: element.LuogoNascita,
                                            emailUtente: element.Email,
                                            pecUtente: element.EmailPec,
                                            comuneUtente: element.Localita,
                                            provinciaUtente: element.IdProvincia,
                                            entità: "element.Denominazione",
                                            codEntità: element.IdIstituto,
                                            idCap: element.IdCap,
                                            idUtente: element.Id,
                                            cap: element.Cap,
                                            username: element.Utente
                                        }
                                        usersList.push(item)
                                        roles = []
                                        descRoles = []
                                    }).catch(error => {
                                        reject(error)
                                    })
                            });
                            resolve(usersList)
                        }).catch(error => {
                            reject(error)
                        })
                } else if (payload.idTipoSoggetto === 3) {
                    dataService.getUsersList(payload.idEntità, payload.idTipoSoggetto)
                        .then(response => {
                            usersList = []
                            response.forEach(function (element: any) {
                                dataService.getUserRole(element.Utente)
                                    .then(resp => {
                                        resp.forEach((element: any) => {
                                            roles.push(element.IdRuolo)
                                            descRoles.push(element.Descrizione + "; ")
                                        });
                                        item = {
                                            tipoSoggetto: element.IdTipoSoggetto,
                                            ruoloUtente: roles,
                                            descrizioneRuolo: descRoles,
                                            nomeUtente: element.Nome,
                                            cognomeUtente: element.Cognome,
                                            indirizzoUtente: element.Indirizzo,
                                            telefono1Utente: element.Telefono1,
                                            telefono2Utente: element.Telefono2,
                                            cod: element.CodiceFiscale,
                                            dataNascita: element.DataNascita,
                                            luogoNascita: element.LuogoNascita,
                                            emailUtente: element.Email,
                                            pecUtente: element.EmailPec,
                                            comuneUtente: element.Localita,
                                            provinciaUtente: element.IdProvincia,
                                            entità: "element.Denominazione",
                                            codEntità: element.IdAzienda,
                                            idCap: element.IdCap,
                                            idUtente: element.Id,
                                            cap: element.Cap,
                                            username: element.Utente
                                        }
                                        usersList.push(item)
                                        roles = []
                                        descRoles = []
                                    }).catch(error => {
                                        reject(error)
                                    })
                            });
                            resolve(usersList)
                        }).catch(error => {
                            reject(error)
                        })
                }

            })
        },
        getComuniList(context: DataContext) {
            var comuniList: any[] = [];
            var comune: ComuniInfo;
            var check: ComuniInfo[] | null = readComuniList(context)
            return new Promise<ComuniInfo[]>((resolve, reject) => {
                if (check === null || check === undefined) {
                    dataService.getComuniList()
                        .then(response => {
                            response.forEach(function (element: any) {
                                comune = {
                                    id: element.Id,
                                    località: element.Localita,
                                    idProvincia: element.IdProvincia,
                                    idComune: element.IdComune
                                }
                                comuniList.push(comune)
                            });
                            commitSetComuniList(context, comuniList)
                            resolve(comuniList)
                        }).catch(error => {
                            reject(error)
                        })
                } else {
                    resolve(check)
                }
            })

        },
        getStatiList(context: DataContext) {
            var statiList: any[] = [];
            var stato: StatesInfo;
            var check: StatesInfo[] | null = readStatiList(context)
            return new Promise<StatesInfo[]>((resolve, reject) => {
                if (check === null || check === undefined) {
                    dataService.getStatiList()
                        .then(response => {
                            response.forEach(function (element: any) {
                                stato = {
                                    idStato: element.Id,
                                    nomeStato: element.Nome
                                }
                                statiList.push(stato)
                            });
                            commitSetStatiList(context, statiList)
                            resolve(statiList)
                        }).catch(error => {
                            reject(error)
                        })
                } else {
                    resolve(check)
                }
            })
        },
        getEnterprisesList(context: DataContext, payload: { idIstituto: number }) {
            return new Promise<EnterpriseNominaResp[]>((resolve, reject) => {
                var enterprisesList: any[];
                var item: EnterpriseNominaResp;
                dataService.getEnterprisesList(payload.idIstituto)
                    .then(response => {
                        enterprisesList = []
                        response.forEach(function (element: any) {
                            item = {
                                idAzienda: element.Id,
                                denominazioneAzienda: element.Denominazione,
                                titolo: element.Titolo,
                                cognomeRappresentanteAzienda: element.CognomeRappresentante,
                                nomeRappresentanteAzienda: element.NomeRappresentante,
                                dataNascitaRappresentante: element.DataNascitaRappresentante,
                                statoNascitaRappresentante: element.PaeseNascitaRappresentante,
                                luogoNascitaRappresentante: element.LuogoNascitaRappresentante,
                                comuneAzienda: element.Localita,
                                idCapComuneAzienda: element.IdCap,
                                provinciaAzienda: element.IdProvincia,
                                indirizzoAzienda: element.Indirizzo,
                                telefono1Azienda: element.Telefono1,
                                telefono2Azienda: element.Telefono2,
                                faxAzienda: element.Fax,
                                emailAzienda: element.EMail,
                                pecAzienda: element.EMailPec,
                                sitoAzienda: element.SitoWeb,
                                attivitàAzienda: element.AttivitàSvolta,
                                dipendentiAzienda: element.NumeroDipendenti,
                                committenzaAzienda: element.Committenza,
                                associata: element.Associata,
                                artigiana: element.AziendaArtigiana,
                                pIva: element.PIva,
                                codAzienda: element.CodiceFiscale,
                                idAteco: element.IdAteco,
                                // idIstat: element.IdIstat,
                                descrizioneAteco: element.CodAteco + "-" + element.DescrizioneAteco,
                                descrizioneIstat: element.CodIstat + "-" + element.DescrizioneIstat,
                                cap: element.Cap,
                                idDocNominaResp: element.IdDocNominaResp,
                                idStatoDoc: element.IdStatoDoc,
                                idNazioneAzienda: element.IdNazioneAzienda,
                                nazioneAzienda: element.NazioneAzienda,
                                idStatoUtente: element.IdStato,
                                codRappresentate: element.CFRappresentante,
                                confCommercio: element.ConfCommercio,
                                altraAssociazione: element.HasAltraAssociazione,
                                obsoleto: element.Obsoleto,
                                mediaRating: element.MediaRating,
                                numRating: element.NumRating
                            }
                            enterprisesList.push(item)
                        })
                        resolve(enterprisesList)
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        getStudentsList(context: DataContext, payload: { idIstituto: number, annoScolastico: number, annoCorso?: string, isDiplomato?: boolean }) {
            return new Promise<StudentAuthorization[]>((resolve, reject) => {
                var studentsList: any[];
                var item: StudentAuthorization;
                dataService.getStudentsList(payload.idIstituto, payload.annoScolastico, payload.annoCorso, payload.isDiplomato)
                    .then(response => {
                        studentsList = []
                        response.forEach(function (element: any) {
                            item = {
                                tipoSoggetto: element.IdTipoSoggetto,
                                ruoloUtente: [4],
                                descrizioneRuolo: ['Allievo'],
                                nomeUtente: element.Nome,
                                cognomeUtente: element.Cognome,
                                indirizzoUtente: element.Indirizzo,
                                telefono1Utente: element.Telefono1,
                                telefono2Utente: element.Telefono2,
                                cod: element.CodiceFiscale,
                                dataNascita: element.DataNascita,
                                luogoNascita: element.LuogoNascita,
                                emailUtente: element.Email,
                                pecUtente: element.EmailPec,
                                comuneUtente: element.Localita,
                                provinciaUtente: element.IdProvincia,
                                entità: "element.Denominazione",
                                codEntità: element.IdIstituto,
                                idCap: element.IdCap,
                                idUtente: element.Id,
                                cap: element.Cap,
                                username: element.Utente,
                                matricola: element.Matricola,
                                classe: element.AnnoCorso + ' ' + element.Sezione,
                                idClasse: element.IdClasse,
                                idNazioneNascita: element.IdNazione,
                                idDocAutorizzazione: element.IdDocAutorizzazione,
                                idStatoDoc: element.IdStatoDoc,
                                idIstitutoAnnoScolastico: element.IdIstitutoAnnoScolastico,
                                idArticolazione: element.IdArticolazione,
                                gestioneAlternanza: element.GestioneAlternanza,
                                gestioneTirocinioEstivo: element.GestioneTirocinioEstivo,
                                gestioneTirocinioFormativo: element.GestioneTirocinioFormativo,
                                diplomato: false,
                                dataDiploma: '',
                                urlCV: ""
                            }
                            studentsList.push(item)
                        })
                        resolve(studentsList)
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        getStudentsSettore(context: DataContext, payload: { idIstituto: number, annoScolastico: number, idSettore: number }) {
            return new Promise<StudentSettoreInfo[]>((resolve, reject) => {
                var studentsList: any[];
                var item: StudentSettoreInfo;
                var tutor: string = "";
                var blocco: boolean;
                dataService.getStudentsSettore(payload.idIstituto, payload.annoScolastico, payload.idSettore)
                    .then(response => {
                        studentsList = []
                        response.forEach(function (element: any) {
                            tutor = ""
                            if (element.CognomeTutor !== null) {
                                tutor = element.CognomeTutor + " " + element.NomeTutor
                            }
                            item = {
                                tipoSoggetto: element.IdTipoSoggetto,
                                ruoloUtente: [4],
                                descrizioneRuolo: ['Allievo'],
                                nomeUtente: element.Nome,
                                cognomeUtente: element.Cognome,
                                indirizzoUtente: element.Indirizzo,
                                telefono1Utente: element.Telefono1,
                                telefono2Utente: element.Telefono2,
                                cod: element.CodiceFiscale,
                                dataNascita: element.DataNascita,
                                luogoNascita: element.LuogoNascita,
                                emailUtente: element.Email,
                                pecUtente: element.EmailPec,
                                comuneUtente: element.Localita,
                                provinciaUtente: element.IdProvincia,
                                entità: "element.Denominazione",
                                codEntità: element.IdIstituto,
                                idCap: element.IdCap,
                                idUtente: element.Id,
                                cap: element.Cap,
                                username: element.Utente,
                                matricola: element.Matricola,
                                classe: element.AnnoCorso + ' ' + element.Sezione,
                                idClasse: element.IdClasse,
                                idNazioneNascita: element.IdNazione,
                                // idDocAutorizzazione: 0,
                                // idStatoDoc: 0,
                                // idIstitutoAnnoScolastico: 0,
                                idArticolazione: element.IdArticolazione,
                                allievo: element.Cognome + " " + element.Nome,
                                tutor: tutor,
                                idTutor: element.IdTutor,
                                gestioneAlternanza: element.GestioneAlternanza,
                                gestioneTirocinioEstivo: element.GestioneTirocinioEstivo,
                                gestioneTirocinioFormativo: element.GestioneTirocinioFormativo,
                                idDocAutorizzazione: element.IdDocAutorizzazione,
                                idStatoDoc: element.IdStatoDoc,
                                idIstitutoAnnoScolastico: element.IdIstitutoAnnoScolastico,
                                iscritto: element.Iscritto,
                                bloccato: !element.GestioneAlternanza,
                                diplomato: false,
                                dataDiploma: '',
                                urlCV: "",
                                corsoSicurezza: element.Sicurezza
                            }
                            studentsList.push(item)
                        })
                        resolve(studentsList)
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        getAtecoList(context: DataContext) {
            var atecoList: any[] = [];
            var ateco: AtecoInfo;
            var check: AtecoInfo[] | null = readAtecoList(context)
            return new Promise<AtecoInfo[]>((resolve, reject) => {
                if (check === null || check === undefined) {
                    dataService.getAtecoList()
                        .then(response => {
                            response.forEach(function (element: any) {
                                ateco = {
                                    id: element.Id,
                                    codice: element.Codice,
                                    descrizione: element.Descrizione
                                }
                                atecoList.push(ateco)
                            });
                            commitSetAtecoList(context, atecoList)
                            resolve(atecoList)
                        }).catch(error => {
                            reject(error)
                        })
                } else {
                    resolve(check)
                }
            })
        },
        getIstatList(context: DataContext) {
            var istatList: any[] = [];
            var istat: IstatInfo;
            var check: IstatInfo[] | null = readIstatList(context)
            return new Promise<IstatInfo[]>((resolve, reject) => {
                if (check === null || check === undefined) {
                    dataService.getIstatList()
                        .then(response => {
                            response.forEach(function (element: any) {
                                istat = {
                                    id: element.Id,
                                    codice: element.Codice,
                                    descrizione: element.Descrizione
                                }
                                istatList.push(istat)
                            });
                            commitSetIstatList(context, istatList)
                            resolve(istatList)
                        }).catch(error => {
                            reject(error)
                        })
                } else {
                    resolve(check)
                }
            })
        },
        getDocAutorizzazioneInfo(context: DataContext, payload: { idDoc: number }) {
            var result: DocAutorizzazioneInfo;
            return new Promise<DocAutorizzazioneInfo>((resolve, reject) => {
                dataService.getDocAutorizzazioneInfo(payload.idDoc)
                    .then(response => {
                        result = {
                            cognomeAllievo: response.data.CognomeAllievo,
                            nomeAllievo: response.data.NomeAllievo,
                            luogoNascitaAllievo: response.data.LuogoNascitaAllievo,
                            dataNascitaAllievo: response.data.DataNascitaAllievo,
                            indirizzoAllievo: response.data.IndirizzoAllievo,
                            comuneAllievo: response.data.ComuneAllievo,
                            provinciaAllievo: response.data.ProvinciaAllievo,
                            capAllievo: response.data.CapAllievo,
                            telefonoAllievo: response.data.TelefonoAllievo,
                            emailAllievo: response.data.EmailAllievo,
                            classeAllievo: response.data.Classe,
                            cognomeTutore: response.data.CognomeTutore,
                            nomeTutore: response.data.NomeTutore,
                            relazioneParentale: response.data.RelazioneParentale,
                            telefonoTutore: response.data.TelefonoTutore,
                            indirizzoTutore: response.data.IndirizzoTutore,
                            comuneTutore: response.data.ComuneTutore,
                            provinciaTutore: response.data.ProvinciaTutore,
                            capTutore: response.data.CapTutore,
                            firmaAllievo: response.data.FirmaAllievo,
                            firmaTutore: response.data.FirmaTutore,
                            statoAutorizzazione: response.data.StatoDocumento,
                            idDoc: response.data.Id,
                            dataDocumento: response.data.DataDocumento,
                            codiceFiscaleAllievo: response.data.CodiceFiscaleAllievo,
                            statoNascitaAllievo: response.data.PaeseNascitaAllievo
                        }
                        commitDocAutorizzazioneStudente(context, result)
                        resolve(result)
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        getDocNominaRespInfo(context: DataContext, payload: { idDoc: number }) {
            var result: DocNominaResponsabileInfo;
            return new Promise<DocNominaResponsabileInfo>((resolve, reject) => {
                dataService.getDocNominaRespInfo(payload.idDoc)
                    .then(response => {
                        result = {
                            nomeAzienda: response.data.NomeAzienda,
                            nomeIstituto: response.data.NomeIstituto,
                            dataDocumento: response.data.DataDocumento,
                            firmaUno: response.data.FirmaUno,
                            firmaDue: response.data.FirmaDue,
                            idAzienda: 0,
                            idIstituto: 0,
                            idDoc: 0
                        }
                        commitDocNominaResp(context, result)
                        resolve(result)
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        getInstituteInfo(context: DataContext, idIstituto: string) {
            var id: number = +idIstituto //cast from string to number
            var result: InstituteInfo;
            return new Promise<InstituteInfo>((resolve, reject) => {
                dataService.getInstituteInfo(id)
                    .then(response => {
                        result = {
                            id: response.data.Id,
                            ragioneSocialeIstituto: response.data.Denominazione,
                            indirizzoIstituto: response.data.Indirizzo,
                            capComuneIstituto: response.data.IdCap,
                            provinciaIstituto: response.data.IdProvincia,
                            nazioneIstituto: response.data.IdNazione,
                            comuneIstituto: response.data.Localita,
                            telefono1Istituto: response.data.Telefono1,
                            telefono2Istituto: response.data.Telefono2,
                            emailIstituto: response.data.EMail,
                            pecIstituto: response.data.EMailPec,
                            codIstituto: response.data.CodiceFiscale,
                            codMinisterialeIstituto: response.data.CodiceMinisteriale,
                            dirigenteIstituto: response.data.Dirigente
                        }
                        resolve(result)
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        getCollaborationInstitutes(context: DataContext, idAzienda: number) {
            return new Promise<any[]>((resolve, reject) => {
                dataService.getCollaborationInstitutes(idAzienda)
                    .then(response => {
                        resolve(response)
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        getEnterpriseDoc(context: DataContext, payload: { idAzienda: number, idIstituto: number }) {
            return new Promise<any>((resolve, reject) => {
                dataService.getEnterpriseDoc(payload.idAzienda, payload.idIstituto)
                    .then(response => {
                        resolve(response)
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        getStudentDoc(context: DataContext, payload: { idStudente: number, idAnnoScolastico: number }) {
            return new Promise<any>((resolve, reject) => {
                dataService.getStudentDoc(payload.idStudente, payload.idAnnoScolastico)
                    .then(response => {
                        resolve(response)
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        getListaIndirizziStudi(context: DataContext, idIstituto: number) {
            return new Promise<any>((resolve, reject) => {
                dataService.getListaIndirizziStudio(idIstituto)
                    .then(response => {
                        resolve(response)
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        getRichiesteAlternanza(context: DataContext, idIscrizioneAttivita: number) {
            var listaInformazioni: RichiestaAlternanza[] = [];
            var informazione: RichiestaAlternanza;
            return new Promise<RichiestaAlternanza[]>((resolve, reject) => {
                dataService.getRichiesteAlternanza(idIscrizioneAttivita)
                    .then(response => {
                        response.forEach((element: any) => {
                            informazione = {
                                idAzienda: element.IdAzienda,
                                denominazioneAzienda: element.Denominazione,
                                titolo: element.Titolo,
                                cognomeRappresentanteAzienda: element.CognomeRappresentante,
                                nomeRappresentanteAzienda: element.NomeRappresentante,
                                dataNascitaRappresentante: element.DataNascitaRappresentante,
                                statoNascitaRappresentante: element.PaeseNascitaRappresentante,
                                luogoNascitaRappresentante: element.LuogoNascitaRappresentante,
                                comuneAzienda: element.ComuneAzienda,
                                idCapComuneAzienda: element.IdCap,
                                provinciaAzienda: element.ProvinciaAzienda,
                                indirizzoAzienda: element.Indirizzo,
                                telefono1Azienda: element.Telefono1,
                                telefono2Azienda: element.Telefono2,
                                faxAzienda: element.Fax,
                                emailAzienda: element.EMail,
                                pecAzienda: element.EMailPec,
                                sitoAzienda: element.SitoWeb,
                                attivitàAzienda: element.AttivitàSvolta,
                                dipendentiAzienda: element.NumeroDipendenti,
                                committenzaAzienda: element.Committenza,
                                associata: element.Associata,
                                artigiana: element.AziendaArtigiana,
                                pIva: element.PIva,
                                codAzienda: element.CodiceFiscale,
                                idAteco: element.IdAteco,
                                // idIstat: element.IdIstat,
                                descrizioneAteco: element.CodAteco + "-" + element.DescrizioneAteco,
                                descrizioneIstat: element.CodIstat + "-" + element.DescrizioneIstat,
                                cap: element.Cap,
                                idNazioneAzienda: element.IdNazioneAzienda,
                                nazioneAzienda: element.NazioneAzienda,
                                lavoratoriSede: element.LavoratoriSede,
                                tirociniSede: element.TirociniSede,
                                tirociniDisabiliSede: element.TirociniDisabiliSede,
                                consulente: element.Consulente,
                                provinciaTirocinio: element.ProvinciaTirocinio,
                                comuneTirocinio: element.ComuneTirocinio,
                                capTirocinio: element.CapTirocinio,
                                indirizzoTirocinio: element.IndirizzoTirocinio,
                                denominazioneConsulente: element.DenominazioneConsulente,
                                referenteConsulente: element.ReferenteConsulente,
                                telefonoConsulente: element.TelefonoConsulente,
                                emailConsulente: element.EmailConsulente,
                                attivitàTirocinio: element.AttivitaTirocinio,
                                indirizzoStudio: element.IndirizzoStudio,
                                cognomeTirocinante: element.CognomeTirocinante,
                                nomeTirocinante: element.NomeTirocinante,
                                classeTirocinante: element.ClasseTirocinante,
                                usoFuoriSede: element.UsoFuoriSede,
                                firmaDigitale: element.FirmaDigitale,
                                ruolo: element.Ruolo,
                                idAziendaIstitutoAnno: element.idAziendaIstitutoAnno,
                                nomeIndirizzoStudio: element.NomeIndirizzoStudio,
                                nomeSettore: element.NomeSettore,
                                idRichiesta: element.IdInformazioneAlternanza,
                                idIscrizioneAttivita: element.IdIscrizioneAttivita,
                                idCPIstat: 0,
                                descrizioneCPIstat: "",
                                utilizzata: element.Utilizzata,
                                idStatoUtente: element.IdStato,
                                idStatoAccettazione: element.IdStatoAccettazione,
                                idTirocinante: element.IdAllievo,
                                note: element.Note,
                                usoUfficio: element.UsoUfficio,
                                usoProduzione: element.UsoProduzione,
                                usoCantiere: element.UsoCantiere,
                                usoAltro: element.UsoAltro,
                                sorveglianzaSanitaria: element.SorveglianzaSanitaria,
                                formazione: element.Formazione,
                                colloquio: element.Colloquio,
                                formazioneTutorSicurezza: element.FormazioneTutorSicurezza,
                                tutorFormato: element.TutorFormato,
                                dvr: element.Dvr,
                                dpi: element.Dpi,
                                consensoSopralluogo: element.ConsensoSopralluogo,
                                idIspezione: element.IdIspezione,
                                dataIspezione: element.DataIspezione,
                                idStatoAccettazioneIspezione: element.IdStatoAccettazioneIspezione,
                                codRappresentate: element.CFRappresentante,
                                confCommercio: element.ConfCommercio,
                                altraAssociazione: element.HasAltraAssociazione,
                                mansione: element.Mansione,
                                reparto: element.Reparto,
                                attrezzatura: element.Attrezzatura,
                                dispositiviProtezioneIndividuale: element.DispositiviProtezioneIndividuale
                            }
                            listaInformazioni.push(informazione)
                        });
                        resolve(listaInformazioni)
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        getEmailFromIdDoc(context: DataContext, payload: { docType: string, idDoc: number }) {
            return new Promise<any>((resolve, reject) => {
                dataService.getEmailFromIdDoc(payload.docType, payload.idDoc)
                    .then(response => {
                        resolve(response)
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        getRespDoc(context: DataContext, payload: { idAzienda: number, idIstituto: any }) {
            return new Promise<any>((resolve, reject) => {
                dataService.getRespDoc(payload.idAzienda, payload.idIstituto)
                    .then(response => {
                        resolve(response)
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        getArticolazioni(context: DataContext, idIstituto: number) {
            var articolazioniList: ArticolazioneInfo[] = [];
            var result: ArticolazioneInfo;
            return new Promise<ArticolazioneInfo[]>((resolve, reject) => {
                dataService.getArticolazioni(idIstituto)
                    .then(response => {
                        response.forEach((element: any) => {
                            result = {
                                idArticolazione: element.Id,
                                nomeArticolazione: element.Nome
                            }
                            articolazioniList.push(result)
                        });
                        resolve(articolazioniList)
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        getArticolazioniSettore(context: DataContext, payload: { idIstituto: number, idSettore: number }) {
            var articolazioniList: ArticolazioneInfo[] = [];
            var result: ArticolazioneInfo;
            return new Promise<ArticolazioneInfo[]>((resolve, reject) => {
                dataService.getArticolazioniSettore(payload.idIstituto, payload.idSettore)
                    .then(response => {
                        response.forEach((element: any) => {
                            result = {
                                idArticolazione: element.Id,
                                nomeArticolazione: element.Nome
                            }
                            articolazioniList.push(result)
                        });
                        resolve(articolazioniList)
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        getInformazioniAlternanza(context: DataContext, payload: { idIstituto: number, idAnnoScolastico: number }) {
            var listaInformazioni: RichiestaAlternanza[] = [];
            var informazione: RichiestaAlternanza;
            var dataIspezione: any;
            return new Promise<RichiestaAlternanza[]>((resolve, reject) => {
                dataService.getInformazioniAlternanza(payload.idIstituto, payload.idAnnoScolastico)
                    .then(response => {
                        response.forEach((element: any) => {
                            dataIspezione = new Date(element.DataIspezione)
                            informazione = {
                                idAzienda: element.IdAzienda,
                                denominazioneAzienda: element.Denominazione,
                                titolo: element.Titolo,
                                cognomeRappresentanteAzienda: element.CognomeRappresentante,
                                nomeRappresentanteAzienda: element.NomeRappresentante,
                                dataNascitaRappresentante: element.DataNascitaRappresentante,
                                statoNascitaRappresentante: element.PaeseNascitaRappresentante,
                                luogoNascitaRappresentante: element.LuogoNascitaRappresentante,
                                comuneAzienda: element.ComuneAzienda,
                                idCapComuneAzienda: element.IdCap,
                                provinciaAzienda: element.ProvinciaAzienda,
                                indirizzoAzienda: element.Indirizzo,
                                telefono1Azienda: element.Telefono1,
                                telefono2Azienda: element.Telefono2,
                                faxAzienda: element.Fax,
                                emailAzienda: element.EMail,
                                pecAzienda: element.EMailPec,
                                sitoAzienda: element.SitoWeb,
                                attivitàAzienda: element.AttivitàSvolta,
                                dipendentiAzienda: element.NumeroDipendenti,
                                committenzaAzienda: element.Committenza,
                                associata: element.Associata,
                                artigiana: element.AziendaArtigiana,
                                pIva: element.PIva,
                                codAzienda: element.CodiceFiscale,
                                idAteco: element.IdAteco,
                                // idIstat: element.IdIstat,
                                descrizioneAteco: element.CodAteco + "-" + element.DescrizioneAteco,
                                descrizioneIstat: element.CodIstat + "-" + element.DescrizioneIstat,
                                cap: element.Cap,
                                idNazioneAzienda: element.IdNazioneAzienda,
                                nazioneAzienda: element.NazioneAzienda,
                                lavoratoriSede: element.LavoratoriSede,
                                tirociniSede: element.TirociniSede,
                                tirociniDisabiliSede: element.TirociniDisabiliSede,
                                consulente: element.Consulente,
                                provinciaTirocinio: element.ProvinciaTirocinio,
                                comuneTirocinio: element.ComuneTirocinio,
                                capTirocinio: element.CapTirocinio,
                                indirizzoTirocinio: element.IndirizzoTirocinio,
                                denominazioneConsulente: element.DenominazioneConsulente,
                                referenteConsulente: element.ReferenteConsulente,
                                telefonoConsulente: element.TelefonoConsulente,
                                emailConsulente: element.EmailConsulente,
                                attivitàTirocinio: element.AttivitaTirocinio,
                                indirizzoStudio: element.IndirizzoStudio,
                                cognomeTirocinante: element.CognomeTirocinante,
                                nomeTirocinante: element.NomeTirocinante,
                                classeTirocinante: element.ClasseTirocinante,
                                usoFuoriSede: element.UsoFuoriSede,
                                firmaDigitale: element.FirmaDigitale,
                                ruolo: element.Ruolo,
                                idAziendaIstitutoAnno: element.idAziendaIstitutoAnno,
                                nomeIndirizzoStudio: element.NomeIndirizzoStudio,
                                nomeSettore: element.NomeSettore,
                                idRichiesta: element.IdInformazioneAlternanza,
                                idIscrizioneAttivita: element.IdIscrizioneAttivita,
                                idCPIstat: element.IdCPIstat,
                                descrizioneCPIstat: "",
                                utilizzata: element.Utilizzata,
                                idStatoUtente: element.IdStato,
                                idStatoAccettazione: element.IdStatoAccettazione,
                                idTirocinante: element.IdAllievo,
                                note: element.Note,
                                usoUfficio: element.UsoUfficio,
                                usoProduzione: element.UsoProduzione,
                                usoCantiere: element.UsoCantiere,
                                usoAltro: element.UsoAltro,
                                sorveglianzaSanitaria: element.SorveglianzaSanitaria,
                                formazione: element.Formazione,
                                colloquio: element.Colloquio,
                                formazioneTutorSicurezza: element.FormazioneTutorSicurezza,
                                tutorFormato: element.TutorFormato,
                                dvr: element.Dvr,
                                dpi: element.Dpi,
                                consensoSopralluogo: element.ConsensoSopralluogo,
                                idIspezione: element.IdIspezione,
                                dataIspezione: dataIspezione.getDate() + "/" + (dataIspezione.getMonth() + 1) + "/" + dataIspezione.getFullYear(),
                                idStatoAccettazioneIspezione: element.IdStatoAccettazioneIspezione,
                                codRappresentate: element.CFRappresentante,
                                confCommercio: element.ConfCommercio,
                                altraAssociazione: element.HasAltraAssociazione
                            }
                            listaInformazioni.push(informazione)
                        });
                        resolve(listaInformazioni)
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        getAssegnazioneIndirizzoStudio(context: DataContext, idUtente: number) {
            var indirizzoStudio: number
            return new Promise<number>((resolve, reject) => {
                dataService.getAssegnazioneIndirizzoStudio(idUtente)
                    .then(response => {

                        if (response === "") {
                            indirizzoStudio = 0
                        } else {
                            indirizzoStudio = response.IdIndirizzoStudio
                        }

                        resolve(indirizzoStudio)
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        getAssegnazioneArticolazione(context: DataContext, idUtente: number) {
            var articolazioni: ArticolazioneInfo[] = []
            var articolazione: ArticolazioneInfo
            return new Promise<ArticolazioneInfo[]>((resolve, reject) => {
                dataService.getAssegnazioneArticolazione(idUtente)
                    .then(response => {

                        if (response === "") {
                            articolazioni = []
                        } else {
                            response.forEach((element: any) => {
                                articolazione = {
                                    idArticolazione: element.Id,
                                    nomeArticolazione: element.Nome
                                }

                                articolazioni.push(articolazione)
                                // articolazioni.push(element.IdArticolazione)
                            });
                            // articolazione = response.IdArticolazione
                        }

                        resolve(articolazioni)
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        getTutorSettore(context: DataContext, payload: { idIstituto: number, idSettore: number }) {
            return new Promise<TutorInfo[]>((resolve, reject) => {
                var tutorList: any[] = []
                var item: TutorInfo;
                dataService.getTutorSettore(payload.idIstituto, payload.idSettore)
                    .then(response => {
                        response.forEach((element: any) => {
                            item = {
                                tipoSoggetto: element.IdTipoSoggetto,
                                ruoloUtente: [6],
                                descrizioneRuolo: ["Tutor Articolazione Istituto"],
                                nomeUtente: element.Nome,
                                cognomeUtente: element.Cognome,
                                indirizzoUtente: element.Indirizzo,
                                telefono1Utente: element.Telefono1,
                                telefono2Utente: element.Telefono2,
                                cod: element.CodiceFiscale,
                                dataNascita: element.DataNascita,
                                luogoNascita: element.LuogoNascita,
                                emailUtente: element.Email,
                                pecUtente: element.EmailPec,
                                comuneUtente: element.Localita,
                                provinciaUtente: element.IdProvincia,
                                entità: "Istituto",
                                codEntità: element.IdIstituto,
                                idCap: element.IdCap,
                                idUtente: element.Id,
                                cap: element.Cap,
                                username: element.Utente,
                                idArticolazione: element.IdArticolazione
                            }
                            tutorList.push(item)
                        });
                        resolve(tutorList)
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        getStudentsTutor(context: DataContext, payload: { idIstituto: number, idAnnoScolastico: number, idTutor: number }) {
            return new Promise<StudentTutorInfo[]>((resolve, reject) => {
                var studentsList: any[];
                var item: StudentTutorInfo
                var tutorFormativo: string;
                dataService.getStudentsTutor(payload.idIstituto, payload.idAnnoScolastico, payload.idTutor)
                    .then(response => {
                        studentsList = []
                        response.forEach((element: any) => {
                            if (element.CognomeTutorForm === null && element.NomeTutorForm === null) {
                                tutorFormativo = ''
                            } else {
                                tutorFormativo = element.CognomeTutorForm + " " + element.NomeTutorForm
                            }
                            item = {
                                tipoSoggetto: element.IdTipoSoggetto,
                                ruoloUtente: [4],
                                descrizioneRuolo: ['Allievo'],
                                nomeUtente: element.Nome,
                                cognomeUtente: element.Cognome,
                                indirizzoUtente: element.Indirizzo,
                                telefono1Utente: element.Telefono1,
                                telefono2Utente: element.Telefono2,
                                cod: element.CodiceFiscale,
                                dataNascita: element.DataNascita,
                                luogoNascita: element.LuogoNascita,
                                emailUtente: element.Email,
                                pecUtente: element.EmailPec,
                                comuneUtente: element.Localita,
                                provinciaUtente: element.IdProvincia,
                                entità: "element.Denominazione",
                                codEntità: element.IdIstituto,
                                idCap: element.IdCap,
                                idUtente: element.IdAllievo,
                                cap: element.Cap,
                                username: element.Utente,
                                matricola: element.Matricola,
                                classe: element.AnnoCorso + ' ' + element.Sezione,
                                idClasse: element.IdClasse,
                                idNazioneNascita: element.IdNazione,
                                idArticolazione: element.IdArticolazione,
                                allievo: element.Cognome + " " + element.Nome,
                                gestioneAlternanza: element.GestioneAlternanza,
                                gestioneTirocinioEstivo: element.GestioneTirocinioEstivo,
                                gestioneTirocinioFormativo: element.GestioneTirocinioFormativo,
                                idDocAutorizzazione: element.IdDocAutorizzazione,
                                idStatoDoc: element.IdStatoDoc,
                                idIstitutoAnnoScolastico: element.IdIstitutoAnnoScolastico,
                                idAzienda: element.IdAzienda,
                                azienda: element.Denominazione,
                                tutorFormativo: tutorFormativo,
                                idRichiesta: element.IdInformazioneAlternanza,
                                comuneTirocinio: element.ComuneTirocinio,
                                provinciaTirocinio: element.ProvinciaTirocinio,
                                idStatoAccettazione: element.IdStatoAccettazione,
                                idIscrizioneAllievo: element.IdIscrizioneAllievo,
                                diplomato: false,
                                dataDiploma: '',
                                urlCV: "",
                                tutorArticolazione: ''
                            }
                            studentsList.push(item)
                        })
                        resolve(studentsList)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        getIndirizziStudioTutorArticolazione(context: DataContext, idUtente: number) {
            var indirizzoStudio: IndirizzoStudioInfo
            var indirizziStudioList: IndirizzoStudioInfo[] = []
            return new Promise<IndirizzoStudioInfo[]>((resolve, reject) => {
                dataService.getIndirizziStudioTutorArticolazione(idUtente)
                    .then(response => {
                        response.forEach((element: any) => {
                            indirizzoStudio = {
                                idIndirizzoStudio: element.Id,
                                nomeIndirizzoStudio: element.Nome
                            }
                            indirizziStudioList.push(indirizzoStudio)
                        });
                        resolve(indirizziStudioList)
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        getRichiesteAlternanzaIndirizzoStudio(context: DataContext, payload: { idIndirizzoStudio: number, idAnnoScolastico: number, idIstituto: number }) {
            var listaInformazioni: RichiestaAlternanza[] = [];
            var informazione: RichiestaAlternanza;
            return new Promise<RichiestaAlternanza[]>((resolve, reject) => {
                dataService.getRichiesteAlternanzaIndirizzoStudio(payload.idIndirizzoStudio, payload.idAnnoScolastico, payload.idIstituto)
                    .then(response => {
                        response.forEach((element: any) => {
                            informazione = {
                                idAzienda: element.IdAzienda,
                                denominazioneAzienda: element.Denominazione,
                                titolo: element.Titolo,
                                cognomeRappresentanteAzienda: element.CognomeRappresentante,
                                nomeRappresentanteAzienda: element.NomeRappresentante,
                                dataNascitaRappresentante: element.DataNascitaRappresentante,
                                statoNascitaRappresentante: element.PaeseNascitaRappresentante,
                                luogoNascitaRappresentante: element.LuogoNascitaRappresentante,
                                comuneAzienda: element.ComuneAzienda,
                                idCapComuneAzienda: element.IdCap,
                                provinciaAzienda: element.ProvinciaAzienda,
                                indirizzoAzienda: element.Indirizzo,
                                telefono1Azienda: element.Telefono1,
                                telefono2Azienda: element.Telefono2,
                                faxAzienda: element.Fax,
                                emailAzienda: element.EMail,
                                pecAzienda: element.EMailPec,
                                sitoAzienda: element.SitoWeb,
                                attivitàAzienda: element.AttivitàSvolta,
                                dipendentiAzienda: element.NumeroDipendenti,
                                committenzaAzienda: element.Committenza,
                                associata: element.Associata,
                                artigiana: element.AziendaArtigiana,
                                pIva: element.PIva,
                                codAzienda: element.CodiceFiscale,
                                idAteco: element.IdAteco,
                                // idIstat: element.IdIstat,
                                descrizioneAteco: element.CodAteco + "-" + element.DescrizioneAteco,
                                descrizioneIstat: element.CodIstat + "-" + element.DescrizioneIstat,
                                cap: element.Cap,
                                idNazioneAzienda: element.IdNazioneAzienda,
                                nazioneAzienda: element.NazioneAzienda,
                                lavoratoriSede: element.LavoratoriSede,
                                tirociniSede: element.TirociniSede,
                                tirociniDisabiliSede: element.TirociniDisabiliSede,
                                consulente: element.Consulente,
                                provinciaTirocinio: element.ProvinciaTirocinio,
                                comuneTirocinio: element.ComuneTirocinio,
                                capTirocinio: element.CapTirocinio,
                                indirizzoTirocinio: element.IndirizzoTirocinio,
                                denominazioneConsulente: element.DenominazioneConsulente,
                                referenteConsulente: element.ReferenteConsulente,
                                telefonoConsulente: element.TelefonoConsulente,
                                emailConsulente: element.EmailConsulente,
                                attivitàTirocinio: element.AttivitaTirocinio,
                                indirizzoStudio: element.IndirizzoStudio,
                                cognomeTirocinante: element.CognomeTirocinante,
                                nomeTirocinante: element.NomeTirocinante,
                                classeTirocinante: element.ClasseTirocinante,
                                usoFuoriSede: element.UsoFuoriSede,
                                firmaDigitale: element.FirmaDigitale,
                                ruolo: element.Ruolo,
                                idAziendaIstitutoAnno: element.idAziendaIstitutoAnno,
                                nomeIndirizzoStudio: element.NomeIndirizzoStudio,
                                nomeSettore: element.NomeSettore,
                                idRichiesta: element.IdInformazioneAlternanza,
                                idIscrizioneAttivita: element.IdIscrizioneAttivita,
                                idCPIstat: element.IdCPIstat,
                                descrizioneCPIstat: "",
                                utilizzata: element.Utilizzata,
                                idStatoUtente: element.IdStato,
                                idStatoAccettazione: element.IdStatoAccettazione,
                                idTirocinante: element.IdAllievo,
                                note: element.Note,
                                usoUfficio: element.UsoUfficio,
                                usoProduzione: element.UsoProduzione,
                                usoCantiere: element.UsoCantiere,
                                usoAltro: element.UsoAltro,
                                sorveglianzaSanitaria: element.SorveglianzaSanitaria,
                                formazione: element.Formazione,
                                colloquio: element.Colloquio,
                                formazioneTutorSicurezza: element.FormazioneTutorSicurezza,
                                tutorFormato: element.TutorFormato,
                                dvr: element.Dvr,
                                dpi: element.Dpi,
                                consensoSopralluogo: element.ConsensoSopralluogo,
                                idIspezione: element.IdIspezione,
                                dataIspezione: element.DataIspezione,
                                idStatoAccettazioneIspezione: element.IdStatoAccettazioneIspezione,
                                codRappresentate: element.CFRappresentante,
                                confCommercio: element.ConfCommercio,
                                altraAssociazione: element.HasAltraAssociazione
                            }
                            listaInformazioni.push(informazione)
                        });
                        resolve(listaInformazioni)
                    }).catch(error => {
                        reject(error)
                    })
            })

        },
        getAllieviPreAssegnati(context: DataContext, payload: { idIstituto: number, idAnnoScolastico: number, idTutor: number }) {
            var studentsList: StudentAssignmentCompleteAlternanza[] = []
            var student: StudentAssignmentCompleteAlternanza
            var usoFuori: string;
            var dataInizio: any
            var dataFine: any
            var dataProtocollo: any;
            var dataAttestato: any;
            var dataInizioSecondoPeriodo: any
            var dataFineSecondoPeriodo: any
            return new Promise<StudentAssignmentCompleteAlternanza[]>((resolve, reject) => {
                dataService.getAllieviPreAssegnati(payload.idIstituto, payload.idAnnoScolastico, payload.idTutor)
                    .then(response => {
                        response.forEach((element: any) => {
                            dataProtocollo = "";
                            dataAttestato = "";
                            if (element.UsoFuoriSede === false) {
                                usoFuori = "No"
                            } else {
                                usoFuori = "Si"
                            }
                            dataInizio = new Date(element.DataInizioPeriodo)
                            dataFine = new Date(element.DataFinePeriodo)
                            // dataProtocollo = new Date(element.DataProtocollo)
                            if (element.DataProtocollo !== null) {
                                dataProtocollo = new Date(element.DataProtocollo)
                                dataProtocollo = dataProtocollo.getFullYear() + "-" + (dataProtocollo.getMonth() + 1) + "-" + dataProtocollo.getDate()
                            }
                            if (element.DataAttestato !== "" && element.DataAttestato !== null) {
                                dataAttestato = new Date(element.DataAttestato)
                                dataAttestato = dataAttestato.getDate() + "/" + (dataAttestato.getMonth() + 1) + "/" + dataAttestato.getFullYear()
                            }
                            dataInizioSecondoPeriodo = new Date(element.DataInizioPeriodoDue)
                            dataFineSecondoPeriodo = new Date(element.DataFinePeriodoDue)
                            student = {
                                tipoSoggetto: element.IdTipoSoggetto,
                                ruoloUtente: [4],
                                descrizioneRuolo: ['Allievo'],
                                nomeUtente: element.Nome,
                                cognomeUtente: element.Cognome,
                                indirizzoUtente: element.IndirizzoAllievo,
                                telefono1Utente: element.Telefono1Allievo,
                                telefono2Utente: element.Telefono2Allievo,
                                cod: element.CodAllievo,
                                dataNascita: element.DataNascita,
                                luogoNascita: element.LuogoNascita,
                                emailUtente: element.Email,
                                pecUtente: element.EmailPec,
                                comuneUtente: element.LocalitaAllievo,
                                provinciaUtente: element.IdProvinciaAllievo,
                                entità: "element.Denominazione",
                                codEntità: element.IdIstituto,
                                idCap: element.IdCap,
                                idUtente: element.Id,
                                cap: element.CapAllievo,
                                username: element.Utente,
                                matricola: element.Matricola,
                                classe: element.AnnoCorso + ' ' + element.Sezione,
                                idClasse: element.IdClasse,
                                idNazioneNascita: element.IdNazione,
                                idArticolazione: element.IdArticolazione,
                                allievo: element.Cognome + " " + element.Nome,
                                gestioneAlternanza: element.GestioneAlternanza,
                                idDocAutorizzazione: element.IdDocAutorizzazione,
                                idStatoDoc: element.IdStatoDoc,
                                idIstitutoAnnoScolastico: element.IdIstitutoAnnoScolastico,
                                idAzienda: element.IdAzienda,
                                azienda: "",
                                idInfoAlternanza: element.IdInformazioneAlternanza,
                                idTutorAzienda: element.IdTutorAzienda,
                                tutorAzienda: element.CognomeTutorAzienda + " " + element.NomeTutorAzienda,
                                telefonoTutor: element.TelefonoTutorAziendale,
                                emailTutor: element.EmailTutorAziendale,
                                emailTutorFormativo: element.EmailTutorFormativo,
                                telefonoTutorFormativo: element.TelefonoTutorFormativo,
                                dataInizioPeriodo: dataInizio.getDate() + "/" + (dataInizio.getMonth() + 1) + "/" + dataInizio.getFullYear(),
                                dataFinePeriodo: dataFine.getDate() + "/" + (dataFine.getMonth() + 1) + "/" + dataFine.getFullYear(),
                                orarioInizioMattino: element.OrarioInizioMattino,
                                orarioFineMattino: element.OrarioFineMattino,
                                orarioInizioPomeriggio: element.OrarioInizioPomeriggio,
                                orarioFinePomeriggio: element.OrarioFinePomeriggio,
                                dataInizioSecondoPeriodo: dataInizioSecondoPeriodo ? dataInizioSecondoPeriodo.getDate() + "/" + (dataInizioSecondoPeriodo.getMonth() + 1) + "/" + dataInizioSecondoPeriodo.getFullYear() : "",
                                dataFineSecondoPeriodo: dataFineSecondoPeriodo ? dataFineSecondoPeriodo.getDate() + "/" + (dataFineSecondoPeriodo.getMonth() + 1) + "/" + dataFineSecondoPeriodo.getFullYear() : "",
                                orarioInizioMattinoSecondoPeriodo: element.OrarioInizioMattinoDue,
                                orarioFineMattinoSecondoPeriodo: element.OrarioFineMattinoDue,
                                orarioInizioPomeriggioSecondoPeriodo: element.OrarioInizioPomeriggioDue,
                                orarioFinePomeriggioSecondoPeriodo: element.OrarioFinePomeriggioDue,
                                mansioni: "",
                                idStatoAccettazione: element.IdStatoAccettazione,
                                idStatoAccettazioneAllievo: element.IdStatoAccettazioneAllievo,
                                rating: element.Rating,
                                notaRating: element.NotaRating,
                                idTutorFormativo: element.IdTutorFormativo,
                                idTipoAttivita: element.IdTipoAttivita,
                                // idAzienda: element.IdAzienda,
                                denominazioneAzienda: element.NomeAzienda,
                                titolo: element.Titolo,
                                cognomeRappresentanteAzienda: element.CognomeRappresentante,
                                nomeRappresentanteAzienda: element.NomeRappresentante,
                                dataNascitaRappresentante: element.DataNascitaRappresentante,
                                statoNascitaRappresentante: element.PaeseNascitaRappresentante,
                                luogoNascitaRappresentante: element.LuogoNascitaRappresentante,
                                comuneAzienda: element.LocalitaAzienda,
                                idCapComuneAzienda: element.IdCap,
                                provinciaAzienda: element.IdProvinciaAzienda,
                                indirizzoAzienda: element.IndirizzoAzienda,
                                telefono1Azienda: element.Telefono1Azienda,
                                telefono2Azienda: element.Telefono2Azienda,
                                faxAzienda: element.Fax,
                                emailAzienda: element.EMail,
                                pecAzienda: element.EMailPec,
                                sitoAzienda: element.SitoWeb,
                                attivitàAzienda: element.AttivitàSvolta,
                                dipendentiAzienda: element.NumeroDipendenti,
                                committenzaAzienda: element.Committenza,
                                associata: element.Associata,
                                artigiana: element.AziendaArtigiana,
                                pIva: element.PIva,
                                codAzienda: element.CodAzienda,
                                idAteco: element.IdAteco,
                                // idIstat: element.IdIstat,
                                descrizioneAteco: element.CodAteco + "-" + element.DescrizioneAteco,
                                descrizioneIstat: element.CodIstat + "-" + element.DescrizioneIstat,
                                // capAzienda: element.CapAzienda,
                                idNazioneAzienda: element.IdNazioneAzienda,
                                nazioneAzienda: element.NazioneAzienda,

                                lavoratoriSede: element.LavoratoriSede,
                                tirociniSede: element.TirociniSede,
                                tirociniDisabiliSede: element.TirociniDisabiliSede,
                                consulente: element.Consulente,
                                provinciaTirocinio: element.ProvinciaTirocinio,
                                comuneTirocinio: element.ComuneTirocinio,
                                capTirocinio: element.CapTirocinio,
                                indirizzoTirocinio: element.IndirizzoTirocinio,
                                denominazioneConsulente: element.DenominazioneConsulente,
                                referenteConsulente: element.ReferenteConsulente,
                                telefonoConsulente: element.TelefonoConsulente,
                                emailConsulente: element.EmailConsulente,
                                attivitàTirocinio: element.AttivitaTirocinio,
                                indirizzoStudio: element.IndirizzoStudio,
                                cognomeTirocinante: "",
                                nomeTirocinante: "",
                                classeTirocinante: "",
                                usoFuoriSede: usoFuori,
                                firmaDigitale: element.FirmaDigitale,
                                ruolo: element.Ruolo,
                                idAziendaIstitutoAnno: element.idAziendaIstitutoAnno,
                                nomeIndirizzoStudio: element.NomeIndirizzoStudio,
                                nomeSettore: element.NomeSettore,
                                idRichiesta: element.IdInformazioneAlternanza,
                                gestioneTirocinioEstivo: element.GestioneTirocinioEstivo,
                                gestioneTirocinioFormativo: element.GestioneTirocinioFormativo,
                                tutorFormativo: element.CognomeTutorFormativo + " " + element.NomeTutorFormativo,
                                tutorArticolazione: element.CognomeTutorArt + " " + element.NomeTutorArt,
                                idCPIstat: 0,
                                descrizioneCPIstat: "",
                                idConvenzione: element.IdConvenzione,
                                numeroProtocollazione: element.NumeroProtocollo,
                                dataProtocollazione: dataProtocollo,
                                idIscrizioneAttivita: element.IdIscrizioneAttivita,
                                idPattoFormativo: element.IdPattoFormativo,
                                idPercorsoFormativo: element.IdPercorsoFormativo,
                                idAttestatoFinale: element.IdAttestatoFinale,
                                idFoglioFirme: 0,
                                idQuestTirocinante: element.IdQuestionarioTir,
                                idQuestAzienda: element.IdQuestionarioAzienda,
                                firmaConvenzioneAz: element.FirmaConvenzioneAzienda,
                                firmaConvenzioneIs: element.FirmaConvenzioneIstituto,
                                firmaPercorsoAz: element.FirmaPercorsoAzienda,
                                firmaPercorsoTir: element.FirmaPercorsoTirocinante,
                                firmaPercorsoIs: element.FirmaPercorsoIstituto,
                                firmaFoglioFirmeAz: "",
                                idStatoFirmaAzienda: element.IdStatoFirmaAzienda,
                                idStatoFirmaTutorArticolazione: element.IdStatoFirmaTutorArticolazione,
                                idStatoFirmaTirocinante: element.IdStatoFirmaTirocinante,
                                statoDocConvenzione: element.IdStatoDocConvenzione,
                                statoDocPercorso: element.IdStatoDocPercorso,
                                statoDocPercorsoDigitale: element.IdStatoPercorsoAzDigitale,
                                idIscrizioneAllievo: 0,
                                reportVisite: element.ReportVisite,
                                utilizzata: element.Utilizzata,
                                idStatoUtente: element.IdStato,
                                diplomato: false,
                                dataDiploma: '',
                                urlCV: "",
                                dataAttestatoFinale: dataAttestato,
                                totOre: element.TotaleOre,
                                idTirocinante: element.IdAllievo,
                                note: element.Note,
                                usoUfficio: element.UsoUfficio,
                                usoProduzione: element.UsoProduzione,
                                usoCantiere: element.UsoCantiere,
                                usoAltro: element.UsoAltro,
                                sorveglianzaSanitaria: element.SorveglianzaSanitaria,
                                formazione: element.Formazione,
                                colloquio: element.Colloquio,
                                formazioneTutorSicurezza: element.FormazioneTutorSicurezza,
                                tutorFormato: element.TutorFormato,
                                dvr: element.Dvr,
                                dpi: element.Dpi,
                                consensoSopralluogo: element.ConsensoSopralluogo,
                                idIspezione: element.IdIspezione,
                                dataIspezione: element.DataIspezione,
                                idStatoAccettazioneIspezione: element.IdStatoAccettazioneIspezione,
                                codRappresentate: element.CFRappresentante,
                                confCommercio: element.ConfCommercio,
                                altraAssociazione: element.HasAltraAssociazione,
                                idStatoDocumentoDVR: element.IdStatoDocumentoDVR

                            }
                            studentsList.push(student)
                        })
                        resolve(studentsList)
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        getAllieviAssegnatiAzienda(context: DataContext, payload: { idAnnoScolastico: number, idAzienda: number }) {
            var studentsList: StudentAssignmentInfo[] = []
            var student: StudentAssignmentInfo
            var usoFuori: string;
            var dataInizio: any
            var dataFine: any
            var dataInizioSecondoPeriodo: any
            var dataFineSecondoPeriodo: any
            var dataProtocollo: any;
            return new Promise<StudentAssignmentInfo[]>((resolve, reject) => {
                dataService.getAllieviAssegnatiAzienda(payload.idAnnoScolastico, payload.idAzienda)
                    .then(response => {
                        response.forEach((element: any) => {
                            if (element.UsoFuoriSede === false) {
                                usoFuori = "No"
                            } else {
                                usoFuori = "Si"
                            }
                            dataInizio = element.DataInizioPeriodo ? new Date(element.DataInizioPeriodo) : null
                            dataFine = element.DataFinePeriodo ? new Date(element.DataFinePeriodo) : null
                            dataInizioSecondoPeriodo = element.DataInizioPeriodoDue ? new Date(element.DataInizioPeriodoDue) : null
                            dataFineSecondoPeriodo = element.DataFinePeriodoDue ? new Date(element.DataFinePeriodoDue) : null
                            dataProtocollo = element.DataProtocollo ? new Date(element.DataProtocollo) : null
                            student = {
                                tipoSoggetto: element.IdTipoSoggetto,
                                ruoloUtente: [4],
                                descrizioneRuolo: ['Allievo'],
                                nomeUtente: element.Nome,
                                cognomeUtente: element.Cognome,
                                indirizzoUtente: element.IndirizzoAllievo,
                                telefono1Utente: element.Telefono1Allievo,
                                telefono2Utente: element.Telefono2Allievo,
                                cod: element.CodAllievo,
                                dataNascita: element.DataNascita,
                                luogoNascita: element.LuogoNascita,
                                emailUtente: element.Email,
                                pecUtente: element.EmailPec,
                                comuneUtente: element.LocalitaAllievo,
                                provinciaUtente: element.IdProvinciaAllievo,
                                entità: "element.Denominazione",
                                codEntità: element.IdIstituto,
                                idCap: element.IdCap,
                                idUtente: element.Id,
                                cap: element.CapAllievo,
                                username: element.Utente,
                                matricola: element.Matricola,
                                classe: element.AnnoCorso + ' ' + element.Sezione,
                                idClasse: element.IdClasse,
                                idNazioneNascita: element.IdNazione,
                                idArticolazione: element.IdArticolazione,
                                allievo: element.Cognome + " " + element.Nome,
                                gestioneAlternanza: element.GestioneAlternanza,
                                idDocAutorizzazione: element.IdDocAutorizzazione,
                                idStatoDoc: element.IdStatoDoc,
                                idIstitutoAnnoScolastico: element.IdIstitutoAnnoScolastico,
                                idAzienda: element.IdAzienda,
                                azienda: "",
                                idInfoAlternanza: element.IdInformazioneAlternanza,
                                idTutorAzienda: element.IdTutorAzienda,
                                tutorAzienda: element.CognomeTutorAzienda + " " + element.NomeTutorAzienda,
                                telefonoTutor: element.TelefonoTutorAziendale,
                                emailTutor: element.EmailTutorAziendale,
                                dataInizioPeriodo: dataInizio ? dataInizio.getDate() + "/" + (dataInizio.getMonth() + 1) + "/" + dataInizio.getFullYear() : "",
                                dataFinePeriodo: dataFine ? dataFine.getDate() + "/" + (dataFine.getMonth() + 1) + "/" + dataFine.getFullYear() : "",
                                orarioInizioMattino: element.OrarioInizioMattino,
                                orarioFineMattino: element.OrarioFineMattino,
                                orarioInizioPomeriggio: element.OrarioInizioPomeriggio,
                                orarioFinePomeriggio: element.OrarioFinePomeriggio,
                                dataInizioSecondoPeriodo: dataInizioSecondoPeriodo ? dataInizioSecondoPeriodo.getDate() + "/" + (dataInizioSecondoPeriodo.getMonth() + 1) + "/" + dataInizioSecondoPeriodo.getFullYear() : "",
                                dataFineSecondoPeriodo: dataFineSecondoPeriodo ? dataFineSecondoPeriodo.getDate() + "/" + (dataFineSecondoPeriodo.getMonth() + 1) + "/" + dataFineSecondoPeriodo.getFullYear() : "",
                                orarioInizioMattinoSecondoPeriodo: element.OrarioInizioMattinoDue,
                                orarioFineMattinoSecondoPeriodo: element.OrarioFineMattinoDue,
                                orarioInizioPomeriggioSecondoPeriodo: element.OrarioInizioPomeriggioDue,
                                orarioFinePomeriggioSecondoPeriodo: element.OrarioFinePomeriggioDue,
                                mansioni: "",
                                idStatoAccettazione: element.IdStatoAccettazione,
                                idStatoAccettazioneAllievo: element.IdStatoAccettazioneAllievo,
                                rating: element.Rating,
                                notaRating: element.NotaRating,

                                // idAzienda: element.IdAzienda,
                                denominazioneAzienda: element.NomeAzienda,
                                titolo: element.Titolo,
                                cognomeRappresentanteAzienda: element.CognomeRappresentante,
                                nomeRappresentanteAzienda: element.NomeRappresentante,
                                dataNascitaRappresentante: element.DataNascitaRappresentante,
                                statoNascitaRappresentante: element.PaeseNascitaRappresentante,
                                luogoNascitaRappresentante: element.LuogoNascitaRappresentante,
                                comuneAzienda: element.LocalitaAzienda,
                                idCapComuneAzienda: element.IdCap,
                                provinciaAzienda: element.IdProvinciaAzienda,
                                indirizzoAzienda: element.IndirizzoAzienda,
                                telefono1Azienda: element.Telefono1Azienda,
                                telefono2Azienda: element.Telefono2Azienda,
                                faxAzienda: element.Fax,
                                emailAzienda: element.EMail,
                                pecAzienda: element.EMailPec,
                                sitoAzienda: element.SitoWeb,
                                attivitàAzienda: element.AttivitàSvolta,
                                dipendentiAzienda: element.NumeroDipendenti,
                                committenzaAzienda: element.Committenza,
                                associata: element.Associata,
                                artigiana: element.AziendaArtigiana,
                                pIva: element.PIva,
                                codAzienda: element.CodAzienda,
                                idAteco: element.IdAteco,
                                // idIstat: element.IdIstat,
                                descrizioneAteco: element.CodAteco + "-" + element.DescrizioneAteco,
                                descrizioneIstat: element.CodIstat + "-" + element.DescrizioneIstat,
                                // capAzienda: element.CapAzienda,
                                idNazioneAzienda: element.IdNazioneAzienda,
                                nazioneAzienda: element.NazioneAzienda,

                                lavoratoriSede: element.LavoratoriSede,
                                tirociniSede: element.TirociniSede,
                                tirociniDisabiliSede: element.TirociniDisabiliSede,
                                consulente: element.Consulente,
                                provinciaTirocinio: element.ProvinciaTirocinio,
                                comuneTirocinio: element.ComuneTirocinio,
                                capTirocinio: element.CapTirocinio,
                                indirizzoTirocinio: element.IndirizzoTirocinio,
                                denominazioneConsulente: element.DenominazioneConsulente,
                                referenteConsulente: element.ReferenteConsulente,
                                telefonoConsulente: element.TelefonoConsulente,
                                emailConsulente: element.EmailConsulente,
                                attivitàTirocinio: element.AttivitaTirocinio,
                                indirizzoStudio: element.IndirizzoStudio,
                                cognomeTirocinante: "",
                                nomeTirocinante: "",
                                classeTirocinante: "",
                                usoFuoriSede: usoFuori,
                                firmaDigitale: element.FirmaDigitale,
                                ruolo: element.Ruolo,
                                idAziendaIstitutoAnno: element.idAziendaIstitutoAnno,
                                nomeIndirizzoStudio: element.NomeIndirizzoStudio,
                                nomeSettore: element.NomeSettore,
                                idRichiesta: element.IdInformazioneAlternanza,
                                gestioneTirocinioEstivo: element.GestioneTirocinioEstivo,
                                gestioneTirocinioFormativo: element.GestioneTirocinioFormativo,
                                tutorFormativo: element.CognomeTutorFormativo + " " + element.NomeTutorFormativo,
                                idCPIstat: 0,
                                descrizioneCPIstat: "",
                                idConvenzione: element.IdConvenzione,
                                numeroProtocollazione: element.NumeroProtocollo,
                                dataProtocollazione: dataProtocollo ? dataProtocollo.getDate() + "/" + (dataProtocollo.getMonth() + 1) + "/" + dataProtocollo.getFullYear() : "",
                                idIscrizioneAttivita: element.IdIscrizioneAttivita,
                                idIscrizioneAllievo: 0,
                                reportVisite: element.ReportVisite,
                                utilizzata: element.Utilizzata,
                                idStatoUtente: element.IdStato,
                                diplomato: false,
                                dataDiploma: '',
                                urlCV: "",
                                tutorArticolazione: "",
                                idTirocinante: element.IdAllievo,
                                note: element.Note,
                                usoUfficio: element.UsoUfficio,
                                usoProduzione: element.UsoProduzione,
                                usoCantiere: element.UsoCantiere,
                                usoAltro: element.UsoAltro,
                                sorveglianzaSanitaria: element.SorveglianzaSanitaria,
                                formazione: element.Formazione,
                                colloquio: element.Colloquio,
                                formazioneTutorSicurezza: element.FormazioneTutorSicurezza,
                                tutorFormato: element.TutorFormato,
                                dvr: element.Dvr,
                                dpi: element.Dpi,
                                consensoSopralluogo: element.ConsensoSopralluogo,
                                idIspezione: element.IdIspezione,
                                dataIspezione: element.DataIspezione,
                                idStatoAccettazioneIspezione: element.IdStatoAccettazioneIspezione,
                                codRappresentate: element.CFRappresentante,
                                confCommercio: element.ConfCommercio,
                                altraAssociazione: element.HasAltraAssociazione,
                                emailTutorFormativo: element.EmailTutorFormativo,
                                telefonoTutorFormativo: element.TelefonoTutorFormativo
                            }
                            studentsList.push(student)
                        })
                        resolve(studentsList)
                    }).catch(error => {
                        reject(error)
                    })
            })
        },

        getTutorAzienda(context: DataContext, payload: { idAzienda: number }) {
            var tutorAzienda: UserInfo;
            var tutorList: UserInfo[] = [];
            return new Promise<UserInfo[]>((resolve, reject) => {
                dataService.getTutorAzienda(payload.idAzienda).then(response => {
                    response.forEach((element: any) => {
                        tutorAzienda = {
                            tipoSoggetto: element.IdTipoSoggetto,
                            ruoloUtente: [7],
                            descrizioneRuolo: ['Tutor Settore Azienda'],
                            nomeUtente: element.Nome,
                            cognomeUtente: element.Cognome,
                            indirizzoUtente: element.Indirizzo,
                            telefono1Utente: element.Telefono1,
                            telefono2Utente: element.Telefono2,
                            cod: element.CodiceFiscale,
                            dataNascita: element.DataNascita,
                            luogoNascita: element.LuogoNascita,
                            emailUtente: element.Email,
                            pecUtente: element.EmailPec,
                            comuneUtente: element.Localita,
                            provinciaUtente: element.IdProvincia,
                            entità: "element.Denominazione",
                            codEntità: element.IdAzienda,
                            idCap: element.IdCap,
                            idUtente: element.Id,
                            cap: element.Cap,
                            username: element.Utente
                        }
                        tutorList.push(tutorAzienda)
                    });
                    resolve(tutorList)
                }).catch(error => {
                    reject(error)
                })
            })
        },

        getAreeIstituto(context: DataContext, payload: { idIstituto: number }) {
            var area: AreaInfo;
            var areaList: AreaInfo[] = []
            return new Promise<AreaInfo[]>((resolve, reject) => {
                dataService.getAreeIstituto(payload.idIstituto)
                    .then(response => {
                        response.forEach((element: any) => {
                            area = {
                                idArea: element.Id,
                                descrizioneArea: element.Descrizione,
                                studentiArea: [],
                                aziendeArea: [],
                                nMinTurni: 0,
                                nIdealTurni: 0
                            }
                            areaList.push(area)
                        });
                        resolve(areaList)
                    }).catch(error => {
                        reject(error)
                    })
            })
        },

        getAllieviArea(context: DataContext, payload: { idArea: number, idArticolazione: string, idAnnoScolastico: number }) {
            var allievoArea: AllievoAreaInfo
            var allieviAreaList: AllievoAreaInfo[] = []
            return new Promise<AllievoAreaInfo[]>((resolve, reject) => {
                dataService.getAllieviArea(payload.idArea, payload.idArticolazione, payload.idAnnoScolastico)
                    .then(response => {
                        response.forEach((element: any) => {
                            allievoArea = {
                                idAllievo: element.IdAllievo
                            }
                            allieviAreaList.push(allievoArea)
                        });
                        resolve(allieviAreaList)
                    }).catch(error => {
                        reject(error)
                    })
            })
        },

        getAziendeArea(context: DataContext, payload: { idArea: number, idArticolazione: string, idAnnoScolastico: number }) {
            var aziendaArea: AziendaAreaInfo
            var aziendeAreaList: AziendaAreaInfo[] = []
            return new Promise<AziendaAreaInfo[]>((resolve, reject) => {
                dataService.getAziendeArea(payload.idArea, payload.idArticolazione, payload.idAnnoScolastico)
                    .then(response => {
                        response.forEach((element: any) => {
                            aziendaArea = {
                                idAzienda: element.IdAzienda
                            }
                            aziendeAreaList.push(aziendaArea)
                        });
                        resolve(aziendeAreaList)
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        getColloquiAzienda(context: DataContext, payload: { idAnnoScolastico: number, idAzienda: number }) {
            var colloquiList: ColloquiInfo[] = []
            var colloquio: ColloquiInfo
            return new Promise<ColloquiInfo[]>((resolve, reject) => {
                dataService.getColloquiAzienda(payload.idAnnoScolastico, payload.idAzienda)
                    .then(response => {
                        response.forEach((element: any) => {
                            colloquio = {
                                idColloquio: element.IdColloquio,
                                linkStanza: element.LinkStanza,
                                denominazione: element.Denominazione,
                                sede: element.IndirizzoAzienda,
                                telefono: element.TelefonoAzienda,
                                emailAzienda: element.EmailAzienda,
                                articolazione: element.IdArticolazione,
                                dsArticolazione: element.NomeArticolazione,
                                turno: element.Turno,
                                area: "",
                                giorno: element.DataColloquio,
                                nomeSelezionatore: element.NomeSelezionatore,
                                cognomeSelezionatore: element.CognomeSelezionatore,
                                posizioneRichiesta: element.PosizioneRichiesta,
                                valutazione: element.Esito,
                                note: element.Note,

                                tipoSoggetto: element.IdTipoSoggetto,
                                matricola: element.Matricola,
                                ruoloUtente: [4],
                                descrizioneRuolo: ["Allievo"],
                                nomeUtente: element.Nome,
                                cognomeUtente: element.Cognome,
                                indirizzoUtente: element.Indirizzo,
                                telefono1Utente: element.Telefono1,
                                telefono2Utente: element.Telefono2,
                                cod: element.CodiceFiscale,
                                dataNascita: element.DataNascita,
                                luogoNascita: element.LuogoNascita,
                                emailUtente: element.Email,
                                pecUtente: element.EmailPec,
                                comuneUtente: element.Localita,
                                provinciaUtente: element.IdProvincia,
                                entità: element.Denominazione,
                                codEntità: element.Id,
                                idCap: element.IdCap,
                                idUtente: element.Id,
                                cap: element.Cap,
                                username: element.Nome + ' ' + element.Cognome,
                                classe: element.AnnoCorso + ' ' + element.Sezione,
                                idClasse: element.IdClasse,
                                idNazioneNascita: element.IdNazioneNascita,
                                allievoPresente: element.AllievoPresente,
                                aziendaPresente: element.AziendaPresente,
                                statoPubblicazione: element.StatoPubblicazione,
                                idArea: element.IdArea,
                                idTurno: element.IdTurno,
                                diplomato: false,
                                dataDiploma: '',
                                urlCV: ""
                            }
                            colloquiList.push(colloquio)
                        });
                        resolve(colloquiList)
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        getColloquiIstituto(context: DataContext, payload: { idArticolazione: string, idIstituto: number, idAnnoScolastico: number }) {
            var colloquiList: ColloquiInfo[] = []
            var colloquio: ColloquiInfo
            return new Promise<ColloquiInfo[]>((resolve, reject) => {
                dataService.getColloquiIstituto(payload.idArticolazione, payload.idIstituto, payload.idAnnoScolastico)
                    .then(response => {
                        response.forEach((element: any) => {
                            colloquio = {
                                idColloquio: element.IdColloquio,
                                linkStanza: element.LinkStanza,
                                denominazione: element.Denominazione,
                                sede: element.IndirizzoAzienda,
                                telefono: element.TelefonoAzienda,
                                emailAzienda: element.EmailAzienda,
                                articolazione: element.IdArticolazione,
                                dsArticolazione: element.NomeArticolazione,
                                turno: element.Turno,
                                area: element.DescrizioneArea,
                                giorno: element.DataColloquio,
                                nomeSelezionatore: element.NomeSelezionatore,
                                cognomeSelezionatore: element.CognomeSelezionatore,
                                posizioneRichiesta: element.PosizioneRichiesta,
                                valutazione: element.Esito,
                                note: element.Note,

                                tipoSoggetto: element.IdTipoSoggetto,
                                matricola: element.Matricola,
                                ruoloUtente: [4],
                                descrizioneRuolo: ["Allievo"],
                                nomeUtente: element.Nome,
                                cognomeUtente: element.Cognome,
                                indirizzoUtente: element.Indirizzo,
                                telefono1Utente: element.Telefono1,
                                telefono2Utente: element.Telefono2,
                                cod: element.CodiceFiscale,
                                dataNascita: element.DataNascita,
                                luogoNascita: element.LuogoNascita,
                                emailUtente: element.Email,
                                pecUtente: element.EmailPec,
                                comuneUtente: element.Localita,
                                provinciaUtente: element.IdProvincia,
                                entità: element.Denominazione,
                                codEntità: element.IdIstituto,
                                idCap: element.IdCap,
                                idUtente: element.Id,
                                cap: element.Cap,
                                username: element.Nome + ' ' + element.Cognome,
                                classe: element.AnnoCorso + ' ' + element.Sezione,
                                idClasse: element.IdClasse,
                                idNazioneNascita: element.IdNazioneNascita,
                                allievoPresente: element.AllievoPresente,
                                aziendaPresente: element.AziendaPresente,
                                statoPubblicazione: element.StatoPubblicazione,
                                idArea: element.IdArea,
                                idTurno: element.IdTurno,
                                diplomato: false,
                                dataDiploma: '',
                                urlCV: ""
                            }
                            colloquiList.push(colloquio)
                        });
                        resolve(colloquiList)
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        getAllieviColloquiCV(context: DataContext, payload: { idIstituto: number, idAnnoScolastico: number }) {
            var allievoColloquio: AllievoColloquiIdentifier;
            var allieviColloquiList: AllievoColloquiIdentifier[] = []
            return new Promise<AllievoColloquiIdentifier[]>((resolve, reject) => {
                dataService.getAllieviColloquiCV(payload.idIstituto, payload.idAnnoScolastico)
                    .then(result => {
                        result.forEach((element: any) => {
                            allievoColloquio = {
                                idAllievo: element.IdAllievo,
                                allievo: element.Nome + " " + element.Cognome,
                                idArticolazioneAllievo: element.IdArticolazione,
                                idArea: element.IdArea
                            }
                            allieviColloquiList.push(allievoColloquio)
                        });
                        resolve(allieviColloquiList)
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        getRichiesteTirEstivi(context: DataContext, idAziendaIstitutoAnno: number) {
            var listaInformazioni: RichiestaTirEstivi[] = [];
            var informazione: RichiestaTirEstivi;
            return new Promise<RichiestaTirEstivi[]>((resolve, reject) => {
                dataService.getRichiesteTirEstivi(idAziendaIstitutoAnno)
                    .then(response => {
                        response.forEach((element: any) => {
                            informazione = {
                                idAzienda: element.IdAzienda,
                                denominazioneAzienda: element.Denominazione,
                                titolo: element.Titolo,
                                cognomeRappresentanteAzienda: element.CognomeRappresentante,
                                nomeRappresentanteAzienda: element.NomeRappresentante,
                                dataNascitaRappresentante: element.DataNascitaRappresentante,
                                statoNascitaRappresentante: element.PaeseNascitaRappresentante,
                                luogoNascitaRappresentante: element.LuogoNascitaRappresentante,
                                comuneAzienda: element.ComuneAzienda,
                                idCapComuneAzienda: element.IdCap,
                                provinciaAzienda: element.ProvinciaAzienda,
                                indirizzoAzienda: element.Indirizzo,
                                telefono1Azienda: element.Telefono1,
                                telefono2Azienda: element.Telefono2,
                                faxAzienda: element.Fax,
                                emailAzienda: element.EMail,
                                pecAzienda: element.EMailPec,
                                sitoAzienda: element.SitoWeb,
                                attivitàAzienda: element.AttivitàSvolta,
                                dipendentiAzienda: element.NumeroDipendenti,
                                committenzaAzienda: element.Committenza,
                                associata: element.Associata,
                                artigiana: element.AziendaArtigiana,
                                pIva: element.PIva,
                                codAzienda: element.CodiceFiscale,
                                idAteco: element.IdAteco,
                                // idIstat: element.IdIstat,
                                descrizioneAteco: element.CodAteco + "-" + element.DescrizioneAteco,
                                descrizioneIstat: element.CodIstat + "-" + element.DescrizioneIstat,
                                cap: element.Cap,
                                idNazioneAzienda: element.IdNazioneAzienda,
                                nazioneAzienda: element.NazioneAzienda,
                                lavoratoriSede: element.LavoratoriSede,
                                tirociniSede: element.TirociniSede,
                                tirociniDisabiliSede: element.TirociniDisabiliSede,
                                consulente: element.Consulente,
                                provinciaTirocinio: element.ProvinciaTirocinio,
                                comuneTirocinio: element.ComuneTirocinio,
                                capTirocinio: element.CapTirocinio,
                                indirizzoTirocinio: element.IndirizzoTirocinio,
                                denominazioneConsulente: element.DenominazioneConsulente,
                                referenteConsulente: element.ReferenteConsulente,
                                telefonoConsulente: element.TelefonoConsulente,
                                emailConsulente: element.EmailConsulente,
                                attivitàTirocinio: element.AttivitaTirocinio,
                                indirizzoStudio: element.IndirizzoStudio,
                                cognomeTirocinante: element.CognomeTirocinante,
                                nomeTirocinante: element.NomeTirocinante,
                                classeTirocinante: element.ClasseTirocinante,
                                usoFuoriSede: element.UsoFuoriSede,
                                ruolo: element.Ruolo,
                                idAziendaIstitutoAnno: element.idAziendaIstitutoAnno,
                                nomeIndirizzoStudio: element.NomeIndirizzoStudio,
                                nomeSettore: element.NomeSettore,
                                idRichiesta: element.IdInformazioneAlternanza,
                                idCPIstat: 0,
                                idIscrizioneAttivita: element.IdIscrizioneAttivita,
                                descrizioneCPIstat: "",
                                idStatoUtente: element.IdStato,
                                codRappresentate: element.CFRappresentante,
                                confCommercio: element.ConfCommercio,
                                altraAssociazione: element.HasAltraAssociazione
                            }
                            listaInformazioni.push(informazione)
                        });
                        resolve(listaInformazioni)
                    }).catch(error => {
                        reject(error)
                    })
            })
        },

        getTirEstiviIstituto(context: DataContext, payload: { idIstituto: number, idAnnoScolastico: number }) {
            var listaInformazioni: RichiestaTirEstivi[] = [];
            var informazione: RichiestaTirEstivi;
            return new Promise<RichiestaTirEstivi[]>((resolve, reject) => {
                dataService.getTirEstiviIstituto(payload.idIstituto, payload.idAnnoScolastico)
                    .then(response => {
                        response.forEach((element: any) => {
                            informazione = {
                                idAzienda: element.IdAzienda,
                                denominazioneAzienda: element.Denominazione,
                                titolo: element.Titolo,
                                cognomeRappresentanteAzienda: element.CognomeRappresentante,
                                nomeRappresentanteAzienda: element.NomeRappresentante,
                                dataNascitaRappresentante: element.DataNascitaRappresentante,
                                statoNascitaRappresentante: element.PaeseNascitaRappresentante,
                                luogoNascitaRappresentante: element.LuogoNascitaRappresentante,
                                comuneAzienda: element.ComuneAzienda,
                                idCapComuneAzienda: element.IdCap,
                                provinciaAzienda: element.ProvinciaAzienda,
                                indirizzoAzienda: element.Indirizzo,
                                telefono1Azienda: element.Telefono1,
                                telefono2Azienda: element.Telefono2,
                                faxAzienda: element.Fax,
                                emailAzienda: element.EMail,
                                pecAzienda: element.EMailPec,
                                sitoAzienda: element.SitoWeb,
                                attivitàAzienda: element.AttivitàSvolta,
                                dipendentiAzienda: element.NumeroDipendenti,
                                committenzaAzienda: element.Committenza,
                                associata: element.Associata,
                                artigiana: element.AziendaArtigiana,
                                pIva: element.PIva,
                                codAzienda: element.CodiceFiscale,
                                idAteco: element.IdAteco,
                                // idIstat: element.IdIstat,
                                descrizioneAteco: element.CodAteco + "-" + element.DescrizioneAteco,
                                descrizioneIstat: element.CodIstat + "-" + element.DescrizioneIstat,
                                cap: element.Cap,
                                idNazioneAzienda: element.IdNazioneAzienda,
                                nazioneAzienda: element.NazioneAzienda,
                                lavoratoriSede: element.LavoratoriSede,
                                tirociniSede: element.TirociniSede,
                                tirociniDisabiliSede: element.TirociniDisabiliSede,
                                consulente: element.Consulente,
                                provinciaTirocinio: element.ProvinciaTirocinio,
                                comuneTirocinio: element.ComuneTirocinio,
                                capTirocinio: element.CapTirocinio,
                                indirizzoTirocinio: element.IndirizzoTirocinio,
                                denominazioneConsulente: element.DenominazioneConsulente,
                                referenteConsulente: element.ReferenteConsulente,
                                telefonoConsulente: element.TelefonoConsulente,
                                emailConsulente: element.EmailConsulente,
                                attivitàTirocinio: element.AttivitaTirocinio,
                                indirizzoStudio: element.IndirizzoStudio,
                                cognomeTirocinante: element.CognomeTirocinante,
                                nomeTirocinante: element.NomeTirocinante,
                                classeTirocinante: element.ClasseTirocinante,
                                usoFuoriSede: element.UsoFuoriSede,
                                ruolo: element.Ruolo,
                                idAziendaIstitutoAnno: element.idAziendaIstitutoAnno,
                                nomeIndirizzoStudio: element.NomeIndirizzoStudio,
                                nomeSettore: element.NomeSettore,
                                idRichiesta: element.IdRichiestaTirocinioEstivo,
                                idCPIstat: element.IdCPIstat,
                                idIscrizioneAttivita: element.IdIscrizioneAttivita,
                                descrizioneCPIstat: "",
                                idStatoUtente: element.IdStato,
                                codRappresentate: element.CFRappresentante,
                                confCommercio: element.ConfCommercio,
                                altraAssociazione: element.HasAltraAssociazione
                            }
                            listaInformazioni.push(informazione)
                        });
                        resolve(listaInformazioni)
                    }).catch(error => {
                        reject(error)
                    })
            })
        },

        getAziendeColloquiCV(context: DataContext, payload: { idIstituto: number, idAnnoScolastico: number }) {
            var aziendaColloquio: AziendaColloquioIdentifier
            var aziendeColloquiList: AziendaColloquioIdentifier[] = []
            return new Promise<AziendaColloquioIdentifier[]>((resolve, reject) => {
                dataService.getAziendeColloquiCV(payload.idIstituto, payload.idAnnoScolastico)
                    .then(result => {
                        result.forEach((element: any) => {
                            aziendaColloquio = {
                                idAzienda: element.IdAzienda,
                                azienda: element.Denominazione,
                                idArticolazioneAzienda: element.IdArticolazione,
                                idArea: element.IdArea
                            }
                            aziendeColloquiList.push(aziendaColloquio)
                        });
                        resolve(aziendeColloquiList)
                    }).catch(error => {
                        reject(error)
                    })
            })
        },

        getAllieviAssegnatiAziendaTirEstivo(context: DataContext, payload: { idAnnoScolastico: number, idAzienda: number }) {
            var studentsList: StudentAssignmentTirEstivoInfo[] = []
            var student: StudentAssignmentTirEstivoInfo
            var dataInizio: any
            var dataFine: any
            var usoFuori: string;
            return new Promise<StudentAssignmentTirEstivoInfo[]>((resolve, reject) => {
                dataService.getAllieviAssegnatiAziendaTirEstivo(payload.idAnnoScolastico, payload.idAzienda)
                    .then(response => {
                        response.forEach((element: any) => {
                            if (element.UsoFuoriSede === false) {
                                usoFuori = "No"
                            } else {
                                usoFuori = "Si"
                            }
                            dataInizio = new Date(element.DataInizioPeriodo)
                            dataFine = new Date(element.DataFinePeriodo)
                            student = {
                                tipoSoggetto: element.IdTipoSoggetto,
                                ruoloUtente: [4],
                                descrizioneRuolo: ['Allievo'],
                                nomeUtente: element.Nome,
                                cognomeUtente: element.Cognome,
                                indirizzoUtente: element.IndirizzoAllievo,
                                telefono1Utente: element.Telefono1Allievo,
                                telefono2Utente: element.Telefono2Allievo,
                                cod: element.CodAllievo,
                                dataNascita: element.DataNascita,
                                luogoNascita: element.LuogoNascita,
                                emailUtente: element.Email,
                                pecUtente: element.EmailPec,
                                comuneUtente: element.LocalitaAllievo,
                                provinciaUtente: element.IdProvinciaAllievo,
                                entità: "element.Denominazione",
                                codEntità: element.IdIstituto,
                                idCap: element.IdCap,
                                idUtente: element.Id,
                                cap: element.CapAllievo,
                                username: element.Utente,
                                matricola: element.Matricola,
                                classe: element.AnnoCorso + ' ' + element.Sezione,
                                idClasse: element.IdClasse,
                                idNazioneNascita: element.IdNazione,
                                idArticolazione: element.IdArticolazione,
                                allievo: element.Cognome + " " + element.Nome,
                                gestioneAlternanza: element.GestioneAlternanza,
                                idDocAutorizzazione: element.IdDocAutorizzazione,
                                idStatoDoc: element.IdStatoDoc,
                                idIstitutoAnnoScolastico: element.IdIstitutoAnnoScolastico,
                                idAzienda: element.IdAzienda,
                                azienda: "",
                                idInfoRichiestaTirEstivo: element.IdRichiestaTirocinioEstivo,
                                idTutorAzienda: element.IdTutorAzienda,
                                tutorAzienda: element.CognomeTutorAzienda + " " + element.NomeTutorAzienda,
                                telefonoTutor: element.TelefonoTutorAziendale,
                                emailTutor: element.EmailTutorAziendale,
                                dataInizioPeriodo: dataInizio.getDate() + "/" + (dataInizio.getMonth() + 1) + "/" + dataInizio.getFullYear(),
                                dataFinePeriodo: dataFine.getDate() + "/" + (dataFine.getMonth() + 1) + "/" + dataFine.getFullYear(),
                                orarioInizioMattino: element.OrarioInizioMattino,
                                orarioFineMattino: element.OrarioFineMattino,
                                orarioInizioPomeriggio: element.OrarioInizioPomeriggio,
                                orarioFinePomeriggio: element.OrarioFinePomeriggio,
                                mansioni: "",
                                idStatoAccettazione: element.IdStatoAccettazione,

                                // idAzienda: element.IdAzienda,
                                denominazioneAzienda: element.NomeAzienda,
                                titolo: element.Titolo,
                                cognomeRappresentanteAzienda: element.CognomeRappresentante,
                                nomeRappresentanteAzienda: element.NomeRappresentante,
                                dataNascitaRappresentante: element.DataNascitaRappresentante,
                                statoNascitaRappresentante: element.PaeseNascitaRappresentante,
                                luogoNascitaRappresentante: element.LuogoNascitaRappresentante,
                                comuneAzienda: element.LocalitaAzienda,
                                idCapComuneAzienda: element.IdCap,
                                provinciaAzienda: element.IdProvinciaAzienda,
                                indirizzoAzienda: element.IndirizzoAzienda,
                                telefono1Azienda: element.Telefono1Azienda,
                                telefono2Azienda: element.Telefono2Azienda,
                                faxAzienda: element.Fax,
                                emailAzienda: element.EMail,
                                pecAzienda: element.EMailPec,
                                sitoAzienda: element.SitoWeb,
                                attivitàAzienda: element.AttivitàSvolta,
                                dipendentiAzienda: element.NumeroDipendenti,
                                committenzaAzienda: element.Committenza,
                                associata: element.Associata,
                                artigiana: element.AziendaArtigiana,
                                pIva: element.PIva,
                                codAzienda: element.CodAzienda,
                                idAteco: element.IdAteco,
                                // idIstat: element.IdIstat,
                                descrizioneAteco: element.CodAteco + "-" + element.DescrizioneAteco,
                                descrizioneIstat: element.CodIstat + "-" + element.DescrizioneIstat,
                                // capAzienda: element.CapAzienda,
                                idNazioneAzienda: element.IdNazioneAzienda,
                                nazioneAzienda: element.NazioneAzienda,

                                lavoratoriSede: element.LavoratoriSede,
                                tirociniSede: element.TirociniSede,
                                tirociniDisabiliSede: element.TirociniDisabiliSede,
                                consulente: element.Consulente,
                                provinciaTirocinio: element.ProvinciaTirocinio,
                                comuneTirocinio: element.ComuneTirocinio,
                                capTirocinio: element.CapTirocinio,
                                indirizzoTirocinio: element.IndirizzoTirocinio,
                                denominazioneConsulente: element.DenominazioneConsulente,
                                referenteConsulente: element.ReferenteConsulente,
                                telefonoConsulente: element.TelefonoConsulente,
                                emailConsulente: element.EmailConsulente,
                                attivitàTirocinio: element.AttivitaTirocinio,
                                indirizzoStudio: element.IndirizzoStudio,
                                cognomeTirocinante: "",
                                nomeTirocinante: "",
                                classeTirocinante: "",
                                usoFuoriSede: usoFuori,
                                ruolo: element.Ruolo,
                                idAziendaIstitutoAnno: element.idAziendaIstitutoAnno,
                                nomeIndirizzoStudio: element.NomeIndirizzoStudio,
                                nomeSettore: element.NomeSettore,
                                idRichiesta: element.IdRichiestaTirocinioEstivo,
                                gestioneTirocinioEstivo: element.GestioneTirocinioEstivo,
                                gestioneTirocinioFormativo: element.GestioneTirocinioFormativo,
                                tutorFormativo: element.CognomeTutorFormativo + " " + element.NomeTutorFormativo,
                                idCPIstat: 0,
                                descrizioneCPIstat: "",
                                idConvenzione: element.IdConvenzione,
                                idProgettoOrientamento: element.IdProgettoOrientamento,
                                numeroProtocollazione: element.NumeroProtocollo,
                                dataProtocollazione: element.DataProtocollo,
                                idIscrizioneAllievo: 0,
                                idIscrizioneAttivita: element.IdIscrizioneAttivita,
                                reportVisite: element.ReportVisite,
                                idStatoUtente: element.IdStato,
                                diplomato: false,
                                dataDiploma: '',
                                urlCV: "",
                                tutorArticolazione: "",
                                codRappresentate: element.CFRappresentante,
                                confCommercio: element.ConfCommercio,
                                altraAssociazione: element.HasAltraAssociazione
                            }
                            studentsList.push(student)
                        })
                        resolve(studentsList)
                    }).catch(error => {
                        reject(error)
                    })
            })
        },

        getAllieviPreAssegnatiTirEstivi(context: DataContext, payload: { idIstituto: number, idAnnoScolastico: number, idTutor: number }) {
            var studentsList: StudentAssignmentCompleteTirEstivo[] = []
            var student: StudentAssignmentCompleteTirEstivo
            var dataInizio: any
            var dataFine: any
            var dataProtocollazione: any;
            var usoFuori: string;
            return new Promise<StudentAssignmentCompleteTirEstivo[]>((resolve, reject) => {
                dataService.getAllieviPreAssegnatiTirEstivi(payload.idIstituto, payload.idAnnoScolastico, payload.idTutor)
                    .then(response => {
                        response.forEach((element: any) => {
                            dataProtocollazione = "";
                            if (element.UsoFuoriSede === false) {
                                usoFuori = "No"
                            } else {
                                usoFuori = "Si"
                            }
                            dataInizio = new Date(element.DataInizioPeriodo)
                            dataFine = new Date(element.DataFinePeriodo)
                            if (element.DataProtocollazione !== null) {
                                dataProtocollazione = new Date(element.DataProtocollazione)
                                dataProtocollazione = dataProtocollazione.getFullYear() + "-" + (dataProtocollazione.getMonth() + 1) + "-" + dataProtocollazione.getDate()
                            }
                            student = {
                                tipoSoggetto: element.IdTipoSoggetto,
                                ruoloUtente: [4],
                                descrizioneRuolo: ['Allievo'],
                                nomeUtente: element.Nome,
                                cognomeUtente: element.Cognome,
                                indirizzoUtente: element.IndirizzoAllievo,
                                telefono1Utente: element.Telefono1Allievo,
                                telefono2Utente: element.Telefono2Allievo,
                                cod: element.CodAllievo,
                                dataNascita: element.DataNascita,
                                luogoNascita: element.LuogoNascita,
                                emailUtente: element.Email,
                                pecUtente: element.EmailPec,
                                comuneUtente: element.LocalitaAllievo,
                                provinciaUtente: element.IdProvinciaAllievo,
                                entità: "element.Denominazione",
                                codEntità: element.IdIstituto,
                                idCap: element.IdCap,
                                idUtente: element.Id,
                                cap: element.CapAllievo,
                                username: element.Utente,
                                matricola: element.Matricola,
                                classe: element.AnnoCorso + ' ' + element.Sezione,
                                idClasse: element.IdClasse,
                                idNazioneNascita: element.IdNazione,
                                idArticolazione: element.IdArticolazione,
                                allievo: element.Cognome + " " + element.Nome,
                                gestioneAlternanza: element.GestioneAlternanza,
                                idDocAutorizzazione: element.IdDocAutorizzazione,
                                idStatoDoc: element.IdStatoDoc,
                                idIstitutoAnnoScolastico: element.IdIstitutoAnnoScolastico,
                                idAzienda: element.IdAzienda,
                                azienda: "",
                                idInfoRichiestaTirEstivo: element.IdRichiestaTirocinioEstivo,
                                idTutorAzienda: element.IdTutorAzienda,
                                tutorAzienda: element.CognomeTutorAzienda + " " + element.NomeTutorAzienda,
                                telefonoTutor: element.TelefonoTutorAziendale,
                                emailTutor: element.EmailTutorAziendale,
                                dataInizioPeriodo: dataInizio.getDate() + "/" + (dataInizio.getMonth() + 1) + "/" + dataInizio.getFullYear(),
                                dataFinePeriodo: dataFine.getDate() + "/" + (dataFine.getMonth() + 1) + "/" + dataFine.getFullYear(),
                                orarioInizioMattino: element.OrarioInizioMattino,
                                orarioFineMattino: element.OrarioFineMattino,
                                orarioInizioPomeriggio: element.OrarioInizioPomeriggio,
                                orarioFinePomeriggio: element.OrarioFinePomeriggio,
                                mansioni: "",
                                idStatoAccettazione: element.IdStatoAccettazione,

                                // idAzienda: element.IdAzienda,
                                denominazioneAzienda: element.NomeAzienda,
                                titolo: element.Titolo,
                                cognomeRappresentanteAzienda: element.CognomeRappresentante,
                                nomeRappresentanteAzienda: element.NomeRappresentante,
                                dataNascitaRappresentante: element.DataNascitaRappresentante,
                                statoNascitaRappresentante: element.PaeseNascitaRappresentante,
                                luogoNascitaRappresentante: element.LuogoNascitaRappresentante,
                                comuneAzienda: element.LocalitaAzienda,
                                idCapComuneAzienda: element.IdCap,
                                provinciaAzienda: element.IdProvinciaAzienda,
                                indirizzoAzienda: element.IndirizzoAzienda,
                                telefono1Azienda: element.Telefono1Azienda,
                                telefono2Azienda: element.Telefono2Azienda,
                                faxAzienda: element.Fax,
                                emailAzienda: element.EMail,
                                pecAzienda: element.EMailPec,
                                sitoAzienda: element.SitoWeb,
                                attivitàAzienda: element.AttivitàSvolta,
                                dipendentiAzienda: element.NumeroDipendenti,
                                committenzaAzienda: element.Committenza,
                                associata: element.Associata,
                                artigiana: element.AziendaArtigiana,
                                pIva: element.PIva,
                                codAzienda: element.CodAzienda,
                                idAteco: element.IdAteco,
                                // idIstat: element.IdIstat,
                                descrizioneAteco: element.CodAteco + "-" + element.DescrizioneAteco,
                                descrizioneIstat: element.CodIstat + "-" + element.DescrizioneIstat,
                                // capAzienda: element.CapAzienda,
                                idNazioneAzienda: element.IdNazioneAzienda,
                                nazioneAzienda: element.NazioneAzienda,

                                lavoratoriSede: element.LavoratoriSede,
                                tirociniSede: element.TirociniSede,
                                tirociniDisabiliSede: element.TirociniDisabiliSede,
                                consulente: element.Consulente,
                                provinciaTirocinio: element.ProvinciaTirocinio,
                                comuneTirocinio: element.ComuneTirocinio,
                                capTirocinio: element.CapTirocinio,
                                indirizzoTirocinio: element.IndirizzoTirocinio,
                                denominazioneConsulente: element.DenominazioneConsulente,
                                referenteConsulente: element.ReferenteConsulente,
                                telefonoConsulente: element.TelefonoConsulente,
                                emailConsulente: element.EmailConsulente,
                                attivitàTirocinio: element.AttivitaTirocinio,
                                indirizzoStudio: element.IndirizzoStudio,
                                cognomeTirocinante: "",
                                nomeTirocinante: "",
                                classeTirocinante: "",
                                usoFuoriSede: usoFuori,
                                ruolo: element.Ruolo,
                                idAziendaIstitutoAnno: element.idAziendaIstitutoAnno,
                                nomeIndirizzoStudio: element.NomeIndirizzoStudio,
                                nomeSettore: element.NomeSettore,
                                idRichiesta: element.IdRichiestaTirocinioEstivo,
                                gestioneTirocinioEstivo: element.GestioneTirocinioEstivo,
                                gestioneTirocinioFormativo: element.GestioneTirocinioFormativo,
                                tutorFormativo: "",
                                idCPIstat: element.CodIstat,
                                descrizioneCPIstat: "",
                                idConvenzione: element.IdConvenzione,
                                idProgettoOrientamento: element.IdProgettoOrientamento,
                                numeroProtocollazione: element.NumeroProtocollo,
                                dataProtocollazione: dataProtocollazione,
                                idAttestatoFinale: element.IdAttestatoFinale,
                                idFoglioFirme: 0,
                                idQuestAzienda: element.IdQuestionarioAzienda,
                                idQuestTirocinante: element.IdQuestionarioTir,
                                firmaConvenzioneAz: element.FirmaConvenzioneAzienda,
                                firmaProgettoAz: element.FirmaProgettoAzienda,
                                firmaProgettoTir: element.FirmaProgettoTir,
                                firmaFoglioFirmeAz: "",
                                statoDocConvenzione: element.IdStatoDocConvenzione,
                                statoDocProgetto: element.IdStatoDocProgetto,
                                idIscrizioneAllievo: 0,
                                idIscrizioneAttivita: element.IdIscrizioneAttivita,
                                reportVisite: element.ReportVisite,
                                idStatoUtente: element.IdStato,
                                diplomato: false,
                                dataDiploma: '',
                                urlCV: "",
                                tutorArticolazione: "",
                                codRappresentate: element.CFRappresentante,
                                confCommercio: element.ConfCommercio,
                                altraAssociazione: element.HasAltraAssociazione
                            }
                            studentsList.push(student)
                        })
                        resolve(studentsList)
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        getStudentsTutorTirEstivi(context: DataContext, payload: { idIstituto: number, idAnnoScolastico: number, idTutor: number }) {
            return new Promise<StudentTutorInfo[]>((resolve, reject) => {
                var studentsList: any[];
                var item: StudentTutorInfo
                var tutorFormativo: string;
                dataService.getStudentsTutorTirEstivi(payload.idIstituto, payload.idAnnoScolastico, payload.idTutor)
                    .then(response => {
                        studentsList = []
                        response.forEach((element: any) => {
                            if (element.CognomeTutorForm === null && element.NomeTutorForm === null) {
                                tutorFormativo = ''
                            } else {
                                tutorFormativo = element.CognomeTutorForm + " " + element.NomeTutorForm
                            }
                            item = {
                                tipoSoggetto: element.IdTipoSoggetto,
                                ruoloUtente: [4],
                                descrizioneRuolo: ['Allievo'],
                                nomeUtente: element.Nome,
                                cognomeUtente: element.Cognome,
                                indirizzoUtente: element.Indirizzo,
                                telefono1Utente: element.Telefono1,
                                telefono2Utente: element.Telefono2,
                                cod: element.CodiceFiscale,
                                dataNascita: element.DataNascita,
                                luogoNascita: element.LuogoNascita,
                                emailUtente: element.Email,
                                pecUtente: element.EmailPec,
                                comuneUtente: element.Localita,
                                provinciaUtente: element.IdProvincia,
                                entità: "element.Denominazione",
                                codEntità: element.IdIstituto,
                                idCap: element.IdCap,
                                idUtente: element.IdUtenteAllievo,
                                cap: element.Cap,
                                username: element.Utente,
                                matricola: element.Matricola,
                                classe: element.AnnoCorso + ' ' + element.Sezione,
                                idClasse: element.IdClasse,
                                idNazioneNascita: element.IdNazione,
                                idArticolazione: element.IdArticolazione,
                                allievo: element.Cognome + " " + element.Nome,
                                gestioneAlternanza: element.GestioneAlternanza,
                                idDocAutorizzazione: element.IdDocAutorizzazione,
                                idStatoDoc: element.IdStatoDoc,
                                idIstitutoAnnoScolastico: element.IdIstitutoAnnoScolastico,
                                idAzienda: element.IdAzienda,
                                azienda: element.Denominazione,
                                gestioneTirocinioEstivo: element.GestioneTirocinioEstivo,
                                gestioneTirocinioFormativo: element.GestioneTirocinioFormativo,
                                tutorFormativo: tutorFormativo,
                                idRichiesta: element.IdRichiestaTirocinioEstivo,
                                comuneTirocinio: element.ComuneTirocinio,
                                provinciaTirocinio: element.ProvinciaTirocinio,
                                idStatoAccettazione: element.IdStatoAccettazione,
                                idIscrizioneAllievo: element.IdIscrizioneAllievo,
                                diplomato: false,
                                dataDiploma: '',
                                urlCV: "",
                                tutorArticolazione: ""
                            }
                            studentsList.push(item)
                        })
                        resolve(studentsList)

                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        getRichiesteTirEstiviIndirizzoStudio(context: DataContext, payload: { idIndirizzoStudio: number, idAnnoScolastico: number, idIstituto: number }) {
            var listaInformazioni: RichiestaTirEstivi[] = [];
            var informazione: RichiestaTirEstivi;
            return new Promise<RichiestaTirEstivi[]>((resolve, reject) => {
                dataService.getRichiesteTirEstiviIndirizzoStudio(payload.idIndirizzoStudio, payload.idAnnoScolastico, payload.idIstituto)
                    .then(response => {
                        response.forEach((element: any) => {
                            informazione = {
                                idAzienda: element.IdAzienda,
                                denominazioneAzienda: element.Denominazione,
                                titolo: element.Titolo,
                                cognomeRappresentanteAzienda: element.CognomeRappresentante,
                                nomeRappresentanteAzienda: element.NomeRappresentante,
                                dataNascitaRappresentante: element.DataNascitaRappresentante,
                                statoNascitaRappresentante: element.PaeseNascitaRappresentante,
                                luogoNascitaRappresentante: element.LuogoNascitaRappresentante,
                                comuneAzienda: element.ComuneAzienda,
                                idCapComuneAzienda: element.IdCap,
                                provinciaAzienda: element.ProvinciaAzienda,
                                indirizzoAzienda: element.Indirizzo,
                                telefono1Azienda: element.Telefono1,
                                telefono2Azienda: element.Telefono2,
                                faxAzienda: element.Fax,
                                emailAzienda: element.EMail,
                                pecAzienda: element.EMailPec,
                                sitoAzienda: element.SitoWeb,
                                attivitàAzienda: element.AttivitàSvolta,
                                dipendentiAzienda: element.NumeroDipendenti,
                                committenzaAzienda: element.Committenza,
                                associata: element.Associata,
                                artigiana: element.AziendaArtigiana,
                                pIva: element.PIva,
                                codAzienda: element.CodiceFiscale,
                                idAteco: element.IdAteco,
                                // idIstat: element.IdIstat,
                                descrizioneAteco: element.CodAteco + "-" + element.DescrizioneAteco,
                                descrizioneIstat: element.CodIstat + "-" + element.DescrizioneIstat,
                                cap: element.Cap,
                                idNazioneAzienda: element.IdNazioneAzienda,
                                nazioneAzienda: element.NazioneAzienda,
                                lavoratoriSede: element.LavoratoriSede,
                                tirociniSede: element.TirociniSede,
                                tirociniDisabiliSede: element.TirociniDisabiliSede,
                                consulente: element.Consulente,
                                provinciaTirocinio: element.ProvinciaTirocinio,
                                comuneTirocinio: element.ComuneTirocinio,
                                capTirocinio: element.CapTirocinio,
                                indirizzoTirocinio: element.IndirizzoTirocinio,
                                denominazioneConsulente: element.DenominazioneConsulente,
                                referenteConsulente: element.ReferenteConsulente,
                                telefonoConsulente: element.TelefonoConsulente,
                                emailConsulente: element.EmailConsulente,
                                attivitàTirocinio: element.AttivitaTirocinio,
                                indirizzoStudio: element.IndirizzoStudio,
                                cognomeTirocinante: element.CognomeTirocinante,
                                nomeTirocinante: element.NomeTirocinante,
                                classeTirocinante: element.ClasseTirocinante,
                                usoFuoriSede: element.UsoFuoriSede,
                                ruolo: element.Ruolo,
                                idAziendaIstitutoAnno: element.idAziendaIstitutoAnno,
                                nomeIndirizzoStudio: element.NomeIndirizzoStudio,
                                nomeSettore: element.NomeSettore,
                                idRichiesta: element.IdRichiestaTirocinioEstivo,
                                idCPIstat: 0,
                                descrizioneCPIstat: "",
                                idIscrizioneAttivita: element.IdIscrizioneAttivita,
                                idStatoUtente: element.IdStato,
                                codRappresentate: element.CFRappresentante,
                                confCommercio: element.ConfCommercio,
                                altraAssociazione: element.HasAltraAssociazione
                            }
                            listaInformazioni.push(informazione)
                        });
                        resolve(listaInformazioni)
                    }).catch(error => {
                        reject(error)
                    })
            })

        },
        // getSubscriptions(context: DataContext, payload: { idAzienda: number }) {
        //     return new Promise<>
        // }
        getEnterpriseTutors(context: DataContext, payload: { idAzienda: number }) {
            var tutor: UserInfo;
            var tutorList: UserInfo[] = []
            return new Promise<UserInfo[]>((resolve, reject) => {
                dataService.getEnterpriseTutors(payload.idAzienda)
                    .then(response => {
                        response.forEach((element: any) => {
                            tutor = {
                                tipoSoggetto: element.IdTipoSoggetto,
                                ruoloUtente: [7],
                                descrizioneRuolo: ['Tutor settore azienda'],
                                nomeUtente: element.Nome,
                                cognomeUtente: element.Cognome,
                                indirizzoUtente: element.Indirizzo,
                                telefono1Utente: element.Telefono1,
                                telefono2Utente: element.Telefono2,
                                cod: element.CodiceFiscale,
                                dataNascita: element.DataNascita,
                                luogoNascita: element.LuogoNascita,
                                emailUtente: element.Email,
                                pecUtente: element.EmailPec,
                                comuneUtente: element.Localita,
                                provinciaUtente: element.IdProvincia,
                                entità: "element.Denominazione",
                                codEntità: element.IdIstituto,
                                idCap: element.IdCap,
                                idUtente: element.Id,
                                cap: element.Cap,
                                username: element.Utente
                            }
                            tutorList.push(tutor)
                        });
                        resolve(tutorList)
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        getTutorFormativi(context: DataContext, payload: { idIstituto: number }) {
            var tutorFormativo: TutorFormativoInfo;
            var tutorFormativiList: TutorFormativoInfo[] = []
            return new Promise<TutorFormativoInfo[]>((resolve, reject) => {
                dataService.getTutorFormativi(payload.idIstituto)
                    .then(result => {
                        result.forEach((element: any) => {
                            tutorFormativo = {
                                tipoSoggetto: element.IdTipoSoggetto,
                                ruoloUtente: [10],
                                descrizioneRuolo: ['Tutor Formativo Istituto'],
                                nomeUtente: element.Nome,
                                cognomeUtente: element.Cognome,
                                indirizzoUtente: element.Indirizzo,
                                telefono1Utente: element.Telefono1,
                                telefono2Utente: element.Telefono2,
                                cod: element.CodiceFiscale,
                                dataNascita: element.DataNascita,
                                luogoNascita: element.LuogoNascita,
                                emailUtente: element.Email,
                                pecUtente: element.EmailPec,
                                comuneUtente: element.Localita,
                                provinciaUtente: element.IdProvincia,
                                entità: "element.Denominazione",
                                codEntità: element.IdIstituto,
                                idCap: element.IdCap,
                                idUtente: element.Id,
                                cap: element.Cap,
                                username: element.Utente,
                                tutorFormativo: element.Cognome + " " + element.Nome
                            }
                            tutorFormativiList.push(tutorFormativo)
                        });
                        resolve(tutorFormativiList)
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        getAssociazioniTutorFormativoTirEstivi(context: DataContext, payload: { idTutorForm: number, idIstituto: number, idAnnoScolastico: number }) {
            var studentsList: StudentAssignmentTirEstivoInfo[] = []
            var student: StudentAssignmentTirEstivoInfo
            var usoFuori: string;
            var dataInizio: any
            var dataFine: any
            return new Promise<StudentAssignmentTirEstivoInfo[]>((resolve, reject) => {
                dataService.getAssociazioniTutorFormativoTirEstivi(payload.idTutorForm, payload.idIstituto, payload.idAnnoScolastico)
                    .then(result => {
                        result.forEach((element: any) => {
                            if (element.UsoFuoriSede === false) {
                                usoFuori = "No"
                            } else {
                                usoFuori = "Si"
                            }
                            dataInizio = new Date(element.DataInizioPeriodo)
                            dataFine = new Date(element.DataFinePeriodo)
                            student = {
                                tipoSoggetto: element.IdTipoSoggetto,
                                ruoloUtente: [4],
                                descrizioneRuolo: ['Allievo'],
                                nomeUtente: element.Nome,
                                cognomeUtente: element.Cognome,
                                indirizzoUtente: element.IndirizzoAllievo,
                                telefono1Utente: element.Telefono1Allievo,
                                telefono2Utente: element.Telefono2Allievo,
                                cod: element.CodAllievo,
                                dataNascita: element.DataNascita,
                                luogoNascita: element.LuogoNascita,
                                emailUtente: element.Email,
                                pecUtente: element.EmailPec,
                                comuneUtente: element.LocalitaAllievo,
                                provinciaUtente: element.IdProvinciaAllievo,
                                entità: "element.Denominazione",
                                codEntità: element.IdIstituto,
                                idCap: element.IdCap,
                                idUtente: element.Id,
                                cap: element.CapAllievo,
                                username: element.Utente,
                                matricola: element.Matricola,
                                classe: element.AnnoCorso + ' ' + element.Sezione,
                                idClasse: element.IdClasse,
                                idNazioneNascita: element.IdNazione,
                                idArticolazione: element.IdArticolazione,
                                allievo: element.Cognome + " " + element.Nome,
                                gestioneAlternanza: element.GestioneAlternanza,
                                idDocAutorizzazione: element.IdDocAutorizzazione,
                                idStatoDoc: element.IdStatoDoc,
                                idIstitutoAnnoScolastico: element.IdIstitutoAnnoScolastico,
                                idAzienda: element.IdAzienda,
                                azienda: "",
                                idInfoRichiestaTirEstivo: element.IdRichiestaTirocinioEstivo,
                                idTutorAzienda: element.IdTutorAzienda,
                                tutorAzienda: element.CognomeTutorAzienda + " " + element.NomeTutorAzienda,
                                telefonoTutor: element.TelefonoTutorAziendale,
                                emailTutor: element.EmailTutorAziendale,
                                dataInizioPeriodo: dataInizio.getDate() + "/" + (dataInizio.getMonth() + 1) + "/" + dataInizio.getFullYear(),
                                dataFinePeriodo: dataFine.getDate() + "/" + (dataFine.getMonth() + 1) + "/" + dataFine.getFullYear(),
                                orarioInizioMattino: element.OrarioInizioMattino,
                                orarioFineMattino: element.OrarioFineMattino,
                                orarioInizioPomeriggio: element.OrarioInizioPomeriggio,
                                orarioFinePomeriggio: element.OrarioFinePomeriggio,
                                mansioni: "",
                                idStatoAccettazione: element.IdStatoAccettazione,

                                // idAzienda: element.IdAzienda,
                                denominazioneAzienda: element.NomeAzienda,
                                titolo: element.Titolo,
                                cognomeRappresentanteAzienda: element.CognomeRappresentante,
                                nomeRappresentanteAzienda: element.NomeRappresentante,
                                dataNascitaRappresentante: element.DataNascitaRappresentante,
                                statoNascitaRappresentante: element.PaeseNascitaRappresentante,
                                luogoNascitaRappresentante: element.LuogoNascitaRappresentante,
                                comuneAzienda: element.LocalitaAzienda,
                                idCapComuneAzienda: element.IdCap,
                                provinciaAzienda: element.IdProvinciaAzienda,
                                indirizzoAzienda: element.IndirizzoAzienda,
                                telefono1Azienda: element.Telefono1Azienda,
                                telefono2Azienda: element.Telefono2Azienda,
                                faxAzienda: element.Fax,
                                emailAzienda: element.EMail,
                                pecAzienda: element.EMailPec,
                                sitoAzienda: element.SitoWeb,
                                attivitàAzienda: element.AttivitàSvolta,
                                dipendentiAzienda: element.NumeroDipendenti,
                                committenzaAzienda: element.Committenza,
                                associata: element.Associata,
                                artigiana: element.AziendaArtigiana,
                                pIva: element.PIva,
                                codAzienda: element.CodAzienda,
                                idAteco: element.IdAteco,
                                // idIstat: element.IdIstat,
                                descrizioneAteco: element.CodAteco + "-" + element.DescrizioneAteco,
                                descrizioneIstat: element.CodIstat + "-" + element.DescrizioneIstat,
                                // capAzienda: element.CapAzienda,
                                idNazioneAzienda: element.IdNazioneAzienda,
                                nazioneAzienda: element.NazioneAzienda,

                                lavoratoriSede: element.LavoratoriSede,
                                tirociniSede: element.TirociniSede,
                                tirociniDisabiliSede: element.TirociniDisabiliSede,
                                consulente: element.Consulente,
                                provinciaTirocinio: element.ProvinciaTirocinio,
                                comuneTirocinio: element.ComuneTirocinio,
                                capTirocinio: element.CapTirocinio,
                                indirizzoTirocinio: element.IndirizzoTirocinio,
                                denominazioneConsulente: element.DenominazioneConsulente,
                                referenteConsulente: element.ReferenteConsulente,
                                telefonoConsulente: element.TelefonoConsulente,
                                emailConsulente: element.EmailConsulente,
                                attivitàTirocinio: element.AttivitaTirocinio,
                                indirizzoStudio: element.IndirizzoStudio,
                                cognomeTirocinante: "",
                                nomeTirocinante: "",
                                classeTirocinante: "",
                                usoFuoriSede: usoFuori,
                                ruolo: element.Ruolo,
                                idAziendaIstitutoAnno: element.idAziendaIstitutoAnno,
                                nomeIndirizzoStudio: element.NomeIndirizzoStudio,
                                nomeSettore: element.NomeSettore,
                                idRichiesta: element.IdRichiestaTirocinioEstivo,
                                gestioneTirocinioEstivo: element.GestioneTirocinioEstivo,
                                gestioneTirocinioFormativo: element.GestioneTirocinioFormativo,
                                tutorFormativo: "",
                                idCPIstat: element.CodIstat,
                                descrizioneCPIstat: "",
                                idConvenzione: element.IdConvenzione,
                                idProgettoOrientamento: element.IdProgettoOrientamento,
                                numeroProtocollazione: element.NumeroProtocollo,
                                dataProtocollazione: element.DataProtocollo,
                                idIscrizioneAllievo: 0,
                                idIscrizioneAttivita: element.IdIscrizioneAttivita,
                                reportVisite: element.ReportVisite,
                                idStatoUtente: element.IdStato,
                                diplomato: false,
                                dataDiploma: '',
                                urlCV: "",
                                tutorArticolazione: "",
                                codRappresentate: element.CFRappresentante,
                                confCommercio: element.ConfCommercio,
                                altraAssociazione: element.HasAltraAssociazione
                            }
                            studentsList.push(student)

                        });
                        resolve(studentsList)
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        getAssociazioniTutorFormativoAlternanza(context: DataContext, payload: { idTutorForm: number, idIstituto: number, idAnnoScolastico: number }) {
            var studentsList: StudentAssignmentInfo[] = []
            var student: StudentAssignmentInfo
            var usoFuori: string;
            var dataInizio: any
            var dataFine: any
            var dataInizioSecondoPeriodo: any
            var dataFineSecondoPeriodo: any
            return new Promise<StudentAssignmentInfo[]>((resolve, reject) => {
                dataService.getAssociazioniTutorFormativoAlternanza(payload.idTutorForm, payload.idIstituto, payload.idAnnoScolastico)
                    .then(result => {
                        result.forEach((element: any) => {
                            if (element.UsoFuoriSede === false) {
                                usoFuori = "No"
                            } else {
                                usoFuori = "Si"
                            }
                            dataInizio = new Date(element.DataInizioPeriodo)
                            dataFine = new Date(element.DataFinePeriodo)
                            dataInizioSecondoPeriodo = new Date(element.DataInizioPeriodoDue)
                            dataFineSecondoPeriodo = new Date(element.DataFinePeriodoDue)
                            student = {
                                tipoSoggetto: element.IdTipoSoggetto,
                                ruoloUtente: [4],
                                descrizioneRuolo: ['Allievo'],
                                nomeUtente: element.Nome,
                                cognomeUtente: element.Cognome,
                                indirizzoUtente: element.IndirizzoAllievo,
                                telefono1Utente: element.Telefono1Allievo,
                                telefono2Utente: element.Telefono2Allievo,
                                cod: element.CodAllievo,
                                dataNascita: element.DataNascita,
                                luogoNascita: element.LuogoNascita,
                                emailUtente: element.Email,
                                pecUtente: element.EmailPec,
                                comuneUtente: element.LocalitaAllievo,
                                provinciaUtente: element.IdProvinciaAllievo,
                                entità: "element.Denominazione",
                                codEntità: element.IdIstituto,
                                idCap: element.IdCap,
                                idUtente: element.Id,
                                cap: element.CapAllievo,
                                username: element.Utente,
                                matricola: element.Matricola,
                                classe: element.AnnoCorso + ' ' + element.Sezione,
                                idClasse: element.IdClasse,
                                idNazioneNascita: element.IdNazione,
                                idArticolazione: element.IdArticolazione,
                                allievo: element.Cognome + " " + element.Nome,
                                gestioneAlternanza: element.GestioneAlternanza,
                                idDocAutorizzazione: element.IdDocAutorizzazione,
                                idStatoDoc: element.IdStatoDoc,
                                idIstitutoAnnoScolastico: element.IdIstitutoAnnoScolastico,
                                idAzienda: element.IdAzienda,
                                azienda: "",
                                idInfoAlternanza: element.IdInformazioneAlternanza,
                                idTutorAzienda: element.IdTutorAzienda,
                                tutorAzienda: element.CognomeTutorAzienda + " " + element.NomeTutorAzienda,
                                telefonoTutor: element.TelefonoTutorAziendale,
                                emailTutor: element.EmailTutorAziendale,
                                dataInizioPeriodo: dataInizio.getDate() + "/" + (dataInizio.getMonth() + 1) + "/" + dataInizio.getFullYear(),
                                dataFinePeriodo: dataFine.getDate() + "/" + (dataFine.getMonth() + 1) + "/" + dataFine.getFullYear(),
                                orarioInizioMattino: element.OrarioInizioMattino,
                                orarioFineMattino: element.OrarioFineMattino,
                                orarioInizioPomeriggio: element.OrarioInizioPomeriggio,
                                orarioFinePomeriggio: element.OrarioFinePomeriggio,
                                dataInizioSecondoPeriodo: dataInizioSecondoPeriodo ? dataInizioSecondoPeriodo.getDate() + "/" + (dataInizioSecondoPeriodo.getMonth() + 1) + "/" + dataInizioSecondoPeriodo.getFullYear() : "",
                                dataFineSecondoPeriodo: dataFineSecondoPeriodo ? dataFineSecondoPeriodo.getDate() + "/" + (dataFineSecondoPeriodo.getMonth() + 1) + "/" + dataFineSecondoPeriodo.getFullYear() : "",
                                orarioInizioMattinoSecondoPeriodo: element.OrarioInizioMattinoDue,
                                orarioFineMattinoSecondoPeriodo: element.OrarioFineMattinoDue,
                                orarioInizioPomeriggioSecondoPeriodo: element.OrarioInizioPomeriggioDue,
                                orarioFinePomeriggioSecondoPeriodo: element.OrarioFinePomeriggioDue,
                                mansioni: "",
                                idStatoAccettazione: element.IdStatoAccettazione,
                                idStatoAccettazioneAllievo: element.IdStatoAccettazioneAllievo,
                                rating: element.Rating,
                                notaRating: element.NotaRating,

                                // idAzienda: element.IdAzienda,
                                denominazioneAzienda: element.NomeAzienda,
                                titolo: element.Titolo,
                                cognomeRappresentanteAzienda: element.CognomeRappresentante,
                                nomeRappresentanteAzienda: element.NomeRappresentante,
                                dataNascitaRappresentante: element.DataNascitaRappresentante,
                                statoNascitaRappresentante: element.PaeseNascitaRappresentante,
                                luogoNascitaRappresentante: element.LuogoNascitaRappresentante,
                                comuneAzienda: element.LocalitaAzienda,
                                idCapComuneAzienda: element.IdCap,
                                provinciaAzienda: element.IdProvinciaAzienda,
                                indirizzoAzienda: element.IndirizzoAzienda,
                                telefono1Azienda: element.Telefono1Azienda,
                                telefono2Azienda: element.Telefono2Azienda,
                                faxAzienda: element.Fax,
                                emailAzienda: element.EMail,
                                pecAzienda: element.EMailPec,
                                sitoAzienda: element.SitoWeb,
                                attivitàAzienda: element.AttivitàSvolta,
                                dipendentiAzienda: element.NumeroDipendenti,
                                committenzaAzienda: element.Committenza,
                                associata: element.Associata,
                                artigiana: element.AziendaArtigiana,
                                pIva: element.PIva,
                                codAzienda: element.CodAzienda,
                                idAteco: element.IdAteco,
                                // idIstat: element.IdIstat,
                                descrizioneAteco: element.CodAteco + "-" + element.DescrizioneAteco,
                                descrizioneIstat: element.CodIstat + "-" + element.DescrizioneIstat,
                                // capAzienda: element.CapAzienda,
                                idNazioneAzienda: element.IdNazioneAzienda,
                                nazioneAzienda: element.NazioneAzienda,

                                lavoratoriSede: element.LavoratoriSede,
                                tirociniSede: element.TirociniSede,
                                tirociniDisabiliSede: element.TirociniDisabiliSede,
                                consulente: element.Consulente,
                                provinciaTirocinio: element.ProvinciaTirocinio,
                                comuneTirocinio: element.ComuneTirocinio,
                                capTirocinio: element.CapTirocinio,
                                indirizzoTirocinio: element.IndirizzoTirocinio,
                                denominazioneConsulente: element.DenominazioneConsulente,
                                referenteConsulente: element.ReferenteConsulente,
                                telefonoConsulente: element.TelefonoConsulente,
                                emailConsulente: element.EmailConsulente,
                                attivitàTirocinio: element.AttivitaTirocinio,
                                indirizzoStudio: element.IndirizzoStudio,
                                cognomeTirocinante: "",
                                nomeTirocinante: "",
                                classeTirocinante: "",
                                usoFuoriSede: usoFuori,
                                firmaDigitale: element.FirmaDigitale,
                                ruolo: element.Ruolo,
                                idAziendaIstitutoAnno: element.idAziendaIstitutoAnno,
                                nomeIndirizzoStudio: element.NomeIndirizzoStudio,
                                nomeSettore: element.NomeSettore,
                                idRichiesta: element.IdInformazioneAlternanza,
                                gestioneTirocinioEstivo: element.GestioneTirocinioEstivo,
                                gestioneTirocinioFormativo: element.GestioneTirocinioFormativo,
                                tutorFormativo: element.CognomeTutorFormativo + " " + element.NomeTutorFormativo,
                                idCPIstat: element.CodIstat,
                                descrizioneCPIstat: "",
                                idConvenzione: element.IdConvenzione,
                                numeroProtocollazione: element.NumeroProtocollo,
                                dataProtocollazione: element.DataProtocollo,
                                idIscrizioneAttivita: element.IdIscrizioneAttivita,
                                idIscrizioneAllievo: 0,
                                reportVisite: element.ReportVisite,
                                utilizzata: element.Utilizzata,
                                idStatoUtente: element.IdStato,
                                diplomato: false,
                                dataDiploma: '',
                                urlCV: "",
                                tutorArticolazione: "",
                                idTirocinante: element.IdAllievo,
                                note: element.Note,
                                usoUfficio: element.UsoUfficio,
                                usoProduzione: element.UsoProduzione,
                                usoCantiere: element.UsoCantiere,
                                usoAltro: element.UsoAltro,
                                sorveglianzaSanitaria: element.SorveglianzaSanitaria,
                                formazione: element.Formazione,
                                colloquio: element.Colloquio,
                                formazioneTutorSicurezza: element.FormazioneTutorSicurezza,
                                tutorFormato: element.TutorFormato,
                                dvr: element.Dvr,
                                dpi: element.Dpi,
                                consensoSopralluogo: element.ConsensoSopralluogo,
                                idIspezione: element.IdIspezione,
                                dataIspezione: element.DataIspezione,
                                idStatoAccettazioneIspezione: element.IdStatoAccettazioneIspezione,
                                codRappresentate: element.CFRappresentante,
                                confCommercio: element.ConfCommercio,
                                altraAssociazione: element.HasAltraAssociazione,
                                emailTutorFormativo: element.EmailTutorFormativo,
                                telefonoTutorFormativo: element.TelefonoTutorFormativo
                            }
                            studentsList.push(student)

                        });
                        resolve(studentsList)
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        getClassiIstitutoAnno(context: DataContext, payload: { idIstituto: number, idAnnoScolastico: number }) {
            var classe: ClasseInfo
            var classiList: ClasseInfo[] = []
            return new Promise<ClasseInfo[]>((resolve, reject) => {
                dataService.getClassiIstitutoAnno(payload.idIstituto, payload.idAnnoScolastico)
                    .then(result => {
                        result.forEach((element: any) => {
                            classe = {
                                idClasse: element.IdClasse,
                                classe: element.AnnoCorso + " " + element.Sezione,
                                annoCorso: element.AnnoCorso,
                                sezioneClasse: element.Sezione
                            }
                            classiList.push(classe)
                        });
                        resolve(classiList)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        getConvenzioneAttivita(context: DataContext, payload: { idRichiesta: number, activityType: string }) {
            var convenzione: DocConvenzione;
            return new Promise<DocConvenzione>((resolve, reject) => {
                dataService.getConvenzioneAttivita(payload.idRichiesta, payload.activityType)
                    .then(result => {
                        var dataDoc: any
                        dataDoc = new Date(result.DataDocumento)
                        convenzione = {
                            idConvenzione: result.Id,
                            denominazioneIstituto: result.DenominazioneIstituto,
                            indirizzoIstituto: result.IndirizzoIstituto,
                            capIstituto: result.CapIstituto,
                            comuneIstituto: result.ComuneIstituto,
                            provinciaIstituto: result.ProvinciaIstituto,
                            telefonoIstituto: result.TelefonoIstituto,
                            emailIstituto: result.EmailIstituto,
                            codiceFiscaleIstituto: result.CodiceFiscaleIstituto,
                            dirigenteIstituto: result.DirigenteIstituto,
                            luogoNascitaDirigenteIstituto: result.LuogoNascitaDirigenteIstituto,
                            dataNascitaDirigenteIstituto: result.DataNascitaDirigenteIstituto,
                            denominazioneAzienda: result.DenominazioneAzienda,
                            indirizzoAzienda: result.IndirizzoAzienda,
                            capAzienda: result.CapAzienda,
                            comuneAzienda: result.ComuneAzienda,
                            provinciaAzienda: result.ProvinciaAzienda,
                            telefonoAzienda: result.TelefonoAzienda,
                            emailAzienda: result.EmailAzienda,
                            pecAzienda: result.EmailPecAzienda,
                            pIvaAzienda: result.PIvaAzienda,
                            rappresentanteAzienda: result.RappresentanteAzienda,
                            luogoNascitaRappresentanteAzienda: result.LuogoNascitaRappresentante,
                            dataNascitaRappresentante: result.DataNascitaRappresentante,
                            dataDocumento: dataDoc.getDate() + "/" + (dataDoc.getMonth() + 1) + "/" + dataDoc.getFullYear(),
                            idStatoDoc: result.IdStatoDocumento,
                            firmaAzienda: result.FirmaAzienda,
                            firmaIstituto: result.FirmaIstituto,
                            tipoAttivita: payload.activityType,
                            numeroProtocollo: result.NumeroProtocollo,
                            idTemplate: result.IdTemplateDocumento,
                            codAteco: result.CodAteco + ' - ' + result.DescrizioneAteco,
                            codIstat: result.CodIstat + ' - ' + result.DescrizioneIstat,
                            indirizzoTirocinio: result.IndirizzoTirocinio,
                            comuneTirocinio: result.ComuneTirocinio,
                            provinciaTirocinio: result.ProvinciaTirocinio,
                            tutorAziendale: result.TutorAziendale,
                            tutorFormativo: result.TutorFormativo
                        }
                        resolve(convenzione)
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        getConvenzioneDigitale(context: DataContext, payload: { idRichiesta: number, activityType: string }) {
            var convenzione: any;
            return new Promise<any>((resolve, reject) => {
                dataService.getConvenzioneDigitale(payload.idRichiesta, payload.activityType)
                    .then(result => {
                        result.forEach((element: any) => {
                            convenzione = {
                                id: element.Id,
                                dataCreazione: element.DataCreazione,
                                firma: element.Firma,
                                idLinkDocumento: element.IdLinkDocumento,
                                idRichiesta: element.IdRichiesta,
                                idTipoDocumento: element.IdTipoDocumento,
                                idTipoSoggetto: element.IdTipoSoggetto,
                                idTipologiaAttivita: element.IdTipologiaAttivita,
                                idStatoDocumento: element.IdStatoDocumento
                            }
                        });
                        resolve(convenzione)
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        getConvenzioneAttivitaFromId(context: DataContext, payload: { idDoc: number }) {
            var convenzione: DocConvenzione;
            return new Promise<DocConvenzione>((resolve, reject) => {
                dataService.getConvenzioneAttivitaFromId(payload.idDoc)
                    .then(result => {
                        var dataDoc: any
                        dataDoc = new Date(result.DataDocumento)
                        convenzione = {
                            idConvenzione: result.Id,
                            denominazioneIstituto: result.DenominazioneIstituto,
                            indirizzoIstituto: result.IndirizzoIstituto,
                            capIstituto: result.CapIstituto,
                            comuneIstituto: result.ComuneIstituto,
                            provinciaIstituto: result.ProvinciaIstituto,
                            telefonoIstituto: result.TelefonoIstituto,
                            emailIstituto: result.EmailIstituto,
                            codiceFiscaleIstituto: result.CodiceFiscaleIstituto,
                            dirigenteIstituto: result.DirigenteIstituto,
                            luogoNascitaDirigenteIstituto: result.LuogoNascitaDirigenteIstituto,
                            dataNascitaDirigenteIstituto: result.DataNascitaDirigenteIstituto,
                            denominazioneAzienda: result.DenominazioneAzienda,
                            indirizzoAzienda: result.IndirizzoAzienda,
                            capAzienda: result.CapAzienda,
                            comuneAzienda: result.ComuneAzienda,
                            provinciaAzienda: result.ProvinciaAzienda,
                            telefonoAzienda: result.TelefonoAzienda,
                            emailAzienda: result.EmailAzienda,
                            pecAzienda: result.EmailPecAzienda,
                            pIvaAzienda: result.PIvaAzienda,
                            rappresentanteAzienda: result.RappresentanteAzienda,
                            luogoNascitaRappresentanteAzienda: result.LuogoNascitaRappresentante,
                            dataNascitaRappresentante: result.DataNascitaRappresentante,
                            dataDocumento: dataDoc.getDate() + "/" + (dataDoc.getMonth() + 1) + "/" + dataDoc.getFullYear(),
                            idStatoDoc: result.IdStatoDocumento,
                            firmaAzienda: result.FirmaAzienda,
                            firmaIstituto: result.FirmaIstituto,
                            tipoAttivita: "tirocinioEstivo",
                            numeroProtocollo: result.NumeroProtocollo,
                            idTemplate: result.IdTemplateDocumento,
                            codAteco: result.CodAteco + ' - ' + result.DescrizioneAteco,
                            codIstat: result.CodIstat + ' - ' + result.DescrizioneIstat,
                            indirizzoTirocinio: result.IndirizzoTirocinio,
                            comuneTirocinio: result.ComuneTirocinio,
                            provinciaTirocinio: result.ProvinciaTirocinio,
                            tutorAziendale: result.TutorAziendale,
                            tutorFormativo: result.TutorFormativo
                        }
                        resolve(convenzione)
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        getDocDigitaleById(context: DataContext, payload: { idDocumento: number }) {
            var base64: string;
            return new Promise<any>((resolve, reject) => {
                dataService.getDocDigitaleById(payload.idDocumento)
                    .then((result: any) => {
                        let docDigitale = {
                            base64: result.Allegato
                        }
                        resolve(docDigitale)
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        getProgettoOrientamento(context: DataContext, payload: { idRichiesta: number, activityType: string }) {
            var progettoOrientamento: DocProgettoOrientamento;
            return new Promise<DocProgettoOrientamento>((resolve, reject) => {
                dataService.getProgettoOrientamento(payload.idRichiesta, payload.activityType)
                    .then(result => {
                        var usoFuori: string
                        var dataInizio: any
                        var dataFine: any
                        var dataDoc: any
                        if (result.UsoFuoriSede === false) {
                            usoFuori = "No"
                        } else {
                            usoFuori = "Si"
                        }
                        dataInizio = new Date(result.DataInizioPeriodo)
                        dataFine = new Date(result.DataFinePeriodo)
                        dataDoc = new Date(result.DataDocumento)

                        progettoOrientamento = {
                            idProgettoOrientamento: result.Id,
                            denominazioneIstituto: result.DenominazioneIstituto,
                            indirizzoIstituto: result.IndirizzoIstituto,
                            capIstituto: result.CapIstituto,
                            comuneIstituto: result.ComuneIstituto,
                            provinciaIstituto: result.ProvinciaIstituto,
                            telefonoIstituto: result.TelefonoIstituto,
                            emailIstituto: result.EmailIstituto,
                            pecIstituto: result.EmailPecIstituto,
                            codiceFiscaleIstituto: result.CodiceFiscaleIstituto,
                            dirigenteIstituto: result.DirigenteIstituto,
                            luogoNascitaDirigenteIstituto: result.LuogoNascitaDirigenteIstituto,
                            dataNascitaDirigenteIstituto: result.DataNascitaDirigenteIstituto,
                            tutorFormativo: result.TutorFormativo,
                            denominazioneAzienda: result.DenominazioneAzienda,
                            indirizzoAzienda: result.IndirizzoAzienda,
                            capAzienda: result.CapAzienda,
                            comuneAzienda: result.ComuneAzienda,
                            provinciaAzienda: result.ProvinciaAzienda,
                            emailAzienda: result.EmailAzienda,
                            pecAzienda: result.EmailPecAzienda,
                            telefonoAzienda: result.TelefonoAzienda,
                            pIvaAzienda: result.PIvaAzienda,
                            indirizzoTirocinio: result.IndirizzoTirocinio,
                            comuneTirocinio: result.ComuneTirocinio,
                            provinciaTirocinio: result.ProvinciaTirocinio,
                            codAteco: result.CodAteco,
                            descrizioneAteco: result.DescrizioneAteco,
                            codIstat: result.CodIstat,
                            descrizioneIstat: result.DescrizioneIstat,
                            rappresentanteAzienda: result.RappresentanteAzienda,
                            luogoNascitaRappresentante: result.LuogoNascitaRappresentante,
                            dataNascitaRappresentante: result.DataNascitaRappresentante,
                            tutorAziendale: result.TutorAziendale,
                            tirocinante: result.Tirocinante,
                            dataNascitaTirocinante: result.DataNascitaTirocinante,
                            luogoNascitaTirocinante: result.LuogoNascitaTirocinante,
                            indirizzoTirocinante: result.IndirizzoTirocinante,
                            comuneTirocinante: result.ComuneTirocinante,
                            provinciaTirocinante: result.ProvinciaTirocinante,
                            telefonoTirocinante: result.TelefonoTirocinante,
                            emailTirocinante: result.EmailTirocinante,
                            codiceFiscaleTirocinante: result.CodiceFiscaleTirocinante,
                            classeTirocinante: result.ClasseTirocinante,
                            durataTirocinio: result.DurataTirocinio,
                            dataInizioPeriodo: dataInizio.getDate() + "/" + (dataInizio.getMonth() + 1) + "/" + dataInizio.getFullYear(),
                            dataFinePeriodo: dataFine.getDate() + "/" + (dataFine.getMonth() + 1) + "/" + dataFine.getFullYear(),
                            orarioInizioMattino: result.OrarioInizioMattino,
                            orarioFineMattino: result.OrarioFineMattino,
                            orarioInizioPomeriggio: result.OrarioInizioPomeriggio,
                            orarioFinePomeriggio: result.OrarioFinePomeriggio,
                            usoFuoriSede: usoFuori,
                            posizioneINAIL: result.PosizioneINAIL,
                            numeroPolizzaAssicurativa: result.NumeroPolizzaAssicurativa,
                            assicurazione: result.Assicurazione,
                            facilitazione: result.Facilitazione,
                            attivitaTirocinio: result.AttivitaTirocinio,
                            dataDocumento: dataDoc.getDate() + "/" + (dataDoc.getMonth() + 1) + "/" + dataDoc.getFullYear(),
                            idStatoDoc: result.IdStatoDocumento,
                            firmaAzienda: result.FirmaAzienda,
                            firmaTirocinante: result.FirmaTirocinante,
                            firmaAziendaDue: result.FirmaAziendaDue,
                            firmaTirocinanteDue: result.FirmaTirocinanteDue,
                            firmaEsercentePatriaPotesta: result.FirmaEsercentePatriaPotesta,
                            firmaIstituto: result.FirmaIstituto,
                            capTirocinio: result.CapTirocinio,
                            tipoAttivita: payload.activityType,
                            numeroProtocollo: result.NumeroProtocollo,
                            idTemplate: result.IdTemplateDocumento
                        }
                        resolve(progettoOrientamento)
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        getRichiesteTirEstiviAllievo(context: DataContext, payload: { idAllievo: number, idAnnoScolastico: number }) {
            var richiesta: any;
            var richiesteList: any[] = []
            return new Promise<any[]>((resolve, reject) => {
                dataService.getRichiesteTirEstiviAllievo(payload.idAllievo, payload.idAnnoScolastico)
                    .then(result => {
                        result.forEach((element: any) => {
                            richiesta = element
                            richiesteList.push(richiesta)
                        });
                        resolve(richiesteList)
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        getRichiesteAlternanzaAllievo(context: DataContext, payload: { idAllievo: number, idAnnoScolastico: number }) {
            var richiesta: any;
            var richiesteList: any[] = []
            return new Promise<any[]>((resolve, reject) => {
                dataService.getRichiesteAlternanzaAllievo(payload.idAllievo, payload.idAnnoScolastico)
                    .then(result => {
                        result.forEach((element: any) => {
                            richiesta = element
                            richiesteList.push(richiesta)
                        });
                        resolve(richiesteList)
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        getAllieviAssegnatiAziendaTirFormativo(context: DataContext, payload: { idAnnoScolastico: number, idAzienda: number }) {
            var studentsList: StudentAssignmentTirFormativoInfo[] = []
            var student: StudentAssignmentTirFormativoInfo
            var dataInizio: any
            var dataFine: any
            var dataInizioSospUno: any = ""
            var dataFineSospUno: any = ""
            var dataInizioSospDue: any = ""
            var dataFineSospDue: any = ""
            var usoFuori: string;
            return new Promise<StudentAssignmentTirFormativoInfo[]>((resolve, reject) => {
                dataService.getAllieviAssegnatiAziendaTirFormativo(payload.idAnnoScolastico, payload.idAzienda)
                    .then(response => {
                        response.forEach((element: any) => {
                            dataInizioSospUno = ""
                            dataFineSospUno = ""
                            dataInizioSospDue = ""
                            dataFineSospDue = ""
                            if (element.UsoFuoriSede === false) {
                                usoFuori = "No"
                            } else {
                                usoFuori = "Si"
                            }
                            dataInizio = new Date(element.DataInizioPeriodo)
                            dataFine = new Date(element.DataFinePeriodo)
                            if (element.DataInizioSospensioneUno !== null && element.DataFineSospensioneUno !== null) {
                                dataInizioSospUno = new Date(element.DataInizioSospensioneUno)
                                dataFineSospUno = new Date(element.DataFineSospensioneUno)
                                dataInizioSospUno = dataInizioSospUno.getDate() + "/" + (dataInizioSospUno.getMonth() + 1) + "/" + dataInizioSospUno.getFullYear()
                                dataFineSospUno = dataFineSospUno.getDate() + "/" + (dataFineSospUno.getMonth() + 1) + "/" + dataFineSospUno.getFullYear()
                            }
                            if (element.DataInizioSospensioneDue !== null && element.DataFineSospensioneDue !== null) {
                                dataInizioSospDue = new Date(element.DataInizioSospensioneDue)
                                dataFineSospDue = new Date(element.DataFineSospensioneDue)
                                dataInizioSospDue = dataFineSospDue.getDate() + "/" + (dataFineSospDue.getMonth() + 1) + "/" + dataFineSospDue.getFullYear()
                                dataFineSospDue = dataFineSospDue.getDate() + "/" + (dataFineSospDue.getMonth() + 1) + "/" + dataFineSospDue.getFullYear()
                            }

                            student = {
                                tipoSoggetto: element.IdTipoSoggetto,
                                ruoloUtente: [4],
                                descrizioneRuolo: ['Allievo'],
                                nomeUtente: element.Nome,
                                cognomeUtente: element.Cognome,
                                indirizzoUtente: element.IndirizzoAllievo,
                                telefono1Utente: element.Telefono1Allievo,
                                telefono2Utente: element.Telefono2Allievo,
                                cod: element.CodAllievo,
                                dataNascita: element.DataNascita,
                                luogoNascita: element.LuogoNascita,
                                emailUtente: element.Email,
                                pecUtente: element.EmailPec,
                                comuneUtente: element.LocalitaAllievo,
                                provinciaUtente: element.IdProvinciaAllievo,
                                entità: "element.Denominazione",
                                codEntità: element.IdIstituto,
                                idCap: element.IdCap,
                                idUtente: element.Id,
                                cap: element.CapAllievo,
                                username: element.Utente,
                                matricola: element.Matricola,
                                classe: element.AnnoCorso + ' ' + element.Sezione,
                                idClasse: element.IdClasse,
                                idNazioneNascita: element.IdNazione,
                                idArticolazione: element.IdArticolazione,
                                allievo: element.Cognome + " " + element.Nome,
                                gestioneAlternanza: element.GestioneAlternanza,
                                idDocAutorizzazione: element.IdDocAutorizzazione,
                                idStatoDoc: element.IdStatoDoc,
                                idIstitutoAnnoScolastico: element.IdIstitutoAnnoScolastico,
                                idAzienda: element.IdAzienda,
                                azienda: "",
                                idInfoRichiestaTirFormativo: element.IdRichiestaTirocinioFormativo,
                                idTutorAzienda: element.IdTutorAzienda,
                                tutorAzienda: element.CognomeTutorAzienda + " " + element.NomeTutorAzienda,
                                telefonoTutor: element.TelefonoTutorAziendale,
                                emailTutor: element.EmailTutorAziendale,
                                dataInizioPeriodo: dataInizio.getDate() + "/" + (dataInizio.getMonth() + 1) + "/" + dataInizio.getFullYear(),
                                dataFinePeriodo: dataFine.getDate() + "/" + (dataFine.getMonth() + 1) + "/" + dataFine.getFullYear(),
                                orarioInizioMattino: element.OrarioInizioMattino,
                                orarioFineMattino: element.OrarioFineMattino,
                                orarioInizioPomeriggio: element.OrarioInizioPomeriggio,
                                orarioFinePomeriggio: element.OrarioFinePomeriggio,
                                mansioni: "",
                                idStatoAccettazione: element.IdStatoAccettazione,

                                // idAzienda: element.IdAzienda,
                                denominazioneAzienda: element.NomeAzienda,
                                titolo: element.Titolo,
                                cognomeRappresentanteAzienda: element.CognomeRappresentante,
                                nomeRappresentanteAzienda: element.NomeRappresentante,
                                dataNascitaRappresentante: element.DataNascitaRappresentante,
                                statoNascitaRappresentante: element.PaeseNascitaRappresentante,
                                luogoNascitaRappresentante: element.LuogoNascitaRappresentante,
                                comuneAzienda: element.LocalitaAzienda,
                                idCapComuneAzienda: element.IdCap,
                                provinciaAzienda: element.IdProvinciaAzienda,
                                indirizzoAzienda: element.IndirizzoAzienda,
                                telefono1Azienda: element.Telefono1Azienda,
                                telefono2Azienda: element.Telefono2Azienda,
                                faxAzienda: element.Fax,
                                emailAzienda: element.EMail,
                                pecAzienda: element.EMailPec,
                                sitoAzienda: element.SitoWeb,
                                attivitàAzienda: element.AttivitàSvolta,
                                dipendentiAzienda: element.NumeroDipendenti,
                                committenzaAzienda: element.Committenza,
                                associata: element.Associata,
                                artigiana: element.AziendaArtigiana,
                                pIva: element.PIva,
                                codAzienda: element.CodAzienda,
                                idAteco: element.IdAteco,
                                // idIstat: element.IdIstat,
                                descrizioneAteco: element.CodAteco + "-" + element.DescrizioneAteco,
                                descrizioneIstat: element.CodIstat + "-" + element.DescrizioneIstat,
                                // capAzienda: element.CapAzienda,
                                idNazioneAzienda: element.IdNazioneAzienda,
                                nazioneAzienda: element.NazioneAzienda,

                                lavoratoriSede: element.LavoratoriSede,
                                tirociniSede: element.TirociniSede,
                                tirociniDisabiliSede: element.TirociniDisabiliSede,
                                consulente: element.Consulente,
                                provinciaTirocinio: element.ProvinciaTirocinio,
                                comuneTirocinio: element.ComuneTirocinio,
                                capTirocinio: element.CapTirocinio,
                                indirizzoTirocinio: element.IndirizzoTirocinio,
                                denominazioneConsulente: element.DenominazioneConsulente,
                                referenteConsulente: element.ReferenteConsulente,
                                telefonoConsulente: element.TelefonoConsulente,
                                emailConsulente: element.EmailConsulente,
                                attivitàTirocinio: element.AttivitaTirocinio,
                                indirizzoStudio: element.IndirizzoStudio,
                                cognomeTirocinante: "",
                                nomeTirocinante: "",
                                classeTirocinante: "",
                                usoFuoriSede: usoFuori,
                                ruolo: element.Ruolo,
                                idAziendaIstitutoAnno: element.idAziendaIstitutoAnno,
                                nomeIndirizzoStudio: element.NomeIndirizzoStudio,
                                nomeSettore: element.NomeSettore,
                                idRichiesta: element.IdRichiestaTirocinioFormativo,
                                gestioneTirocinioEstivo: element.GestioneTirocinioEstivo,
                                gestioneTirocinioFormativo: element.GestioneTirocinioFormativo,
                                tutorFormativo: element.CognomeTutorFormativo + " " + element.NomeTutorFormativo,
                                idCPIstat: 0,
                                descrizioneCPIstat: "",
                                idConvenzione: element.IdConvenzione,
                                idProgettoOrientamento: element.IdProgettoOrientamento,

                                responsabilitaCivile: element.ResponsabilitaCivile,
                                assicurazioneAzienda: element.AssicurazioneAzienda,
                                indennitaMensile: element.IndennitaMensile,
                                dataInizioSospensioneUno: dataInizioSospUno,
                                dataFineSospensioneUno: dataFineSospUno,
                                motivazioneSospensioneUno: element.MotivazioneSospensioneUno,
                                dataInizioSospensioneDue: dataInizioSospDue,
                                dataFineSospensioneDue: dataFineSospDue,
                                motivazioneSospensioneDue: element.MotivazioneSospensioneDue,
                                idIscrizioneAllievo: 0,
                                idIscrizioneAttivita: element.IdIscrizioneAttivita,
                                reportVisite: element.ReportVisite,
                                idStatoUtente: element.IdStato,
                                diplomato: false,
                                dataDiploma: '',
                                urlCV: "",
                                apprendistatoCheck: false,
                                tutorArticolazione: "",
                                codRappresentate: element.CFRappresentante,
                                confCommercio: element.ConfCommercio,
                                altraAssociazione: element.HasAltraAssociazione
                            }
                            studentsList.push(student)
                        })
                        resolve(studentsList)
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        getRichiesteTirFormativi(context: DataContext, idIscrizioneAttivita: number) {
            var listaInformazioni: RichiestaTirFormativi[] = [];
            var informazione: RichiestaTirFormativi;
            return new Promise<RichiestaTirFormativi[]>((resolve, reject) => {
                dataService.getRichiesteTirFormativi(idIscrizioneAttivita)
                    .then(response => {
                        response.forEach((element: any) => {
                            informazione = {
                                idAzienda: element.IdAzienda,
                                denominazioneAzienda: element.Denominazione,
                                titolo: element.Titolo,
                                cognomeRappresentanteAzienda: element.CognomeRappresentante,
                                nomeRappresentanteAzienda: element.NomeRappresentante,
                                dataNascitaRappresentante: element.DataNascitaRappresentante,
                                statoNascitaRappresentante: element.PaeseNascitaRappresentante,
                                luogoNascitaRappresentante: element.LuogoNascitaRappresentante,
                                comuneAzienda: element.ComuneAzienda,
                                idCapComuneAzienda: element.IdCap,
                                provinciaAzienda: element.ProvinciaAzienda,
                                indirizzoAzienda: element.Indirizzo,
                                telefono1Azienda: element.Telefono1,
                                telefono2Azienda: element.Telefono2,
                                faxAzienda: element.Fax,
                                emailAzienda: element.EMail,
                                pecAzienda: element.EMailPec,
                                sitoAzienda: element.SitoWeb,
                                attivitàAzienda: element.AttivitàSvolta,
                                dipendentiAzienda: element.NumeroDipendenti,
                                committenzaAzienda: element.Committenza,
                                associata: element.Associata,
                                artigiana: element.AziendaArtigiana,
                                pIva: element.PIva,
                                codAzienda: element.CodiceFiscale,
                                idAteco: element.IdAteco,
                                // idIstat: element.IdIstat,
                                descrizioneAteco: element.CodAteco + "-" + element.DescrizioneAteco,
                                descrizioneIstat: element.CodIstat + "-" + element.DescrizioneIstat,
                                cap: element.Cap,
                                idNazioneAzienda: element.IdNazioneAzienda,
                                nazioneAzienda: element.NazioneAzienda,
                                lavoratoriSede: element.LavoratoriSede,
                                tirociniSede: element.TirociniSede,
                                tirociniDisabiliSede: element.TirociniDisabiliSede,
                                consulente: element.Consulente,
                                provinciaTirocinio: element.ProvinciaTirocinio,
                                comuneTirocinio: element.ComuneTirocinio,
                                capTirocinio: element.CapTirocinio,
                                indirizzoTirocinio: element.IndirizzoTirocinio,
                                denominazioneConsulente: element.DenominazioneConsulente,
                                referenteConsulente: element.ReferenteConsulente,
                                telefonoConsulente: element.TelefonoConsulente,
                                emailConsulente: element.EmailConsulente,
                                attivitàTirocinio: element.AttivitaTirocinio,
                                indirizzoStudio: element.IndirizzoStudio,
                                cognomeTirocinante: element.CognomeTirocinante,
                                nomeTirocinante: element.NomeTirocinante,
                                classeTirocinante: element.ClasseTirocinante,
                                usoFuoriSede: element.UsoFuoriSede,
                                ruolo: element.Ruolo,
                                idAziendaIstitutoAnno: element.idAziendaIstitutoAnno,
                                nomeIndirizzoStudio: element.NomeIndirizzoStudio,
                                nomeSettore: element.NomeSettore,
                                idRichiesta: element.IdRichiestaTirocinioFormativo,
                                idCPIstat: 0,
                                descrizioneCPIstat: "",
                                idIscrizioneAttivita: element.IdIscrizioneAttivita,
                                idStatoUtente: element.IdStato,
                                codRappresentate: element.CFRappresentante,
                                confCommercio: element.ConfCommercio,
                                altraAssociazione: element.HasAltraAssociazione
                            }
                            listaInformazioni.push(informazione)
                        });
                        resolve(listaInformazioni)
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        getStudentsTutorTirFormativi(context: DataContext, payload: { idIstituto: number, idAnnoScolastico: number, idTutor: number }) {
            return new Promise<StudentTutorInfo[]>((resolve, reject) => {
                var studentsList: any[];
                var item: StudentTutorInfo
                var tutorFormativo: string;
                dataService.getStudentsTutorTirFormativi(payload.idIstituto, payload.idAnnoScolastico, payload.idTutor)
                    .then(response => {
                        studentsList = []
                        response.forEach((element: any) => {
                            if (element.CognomeTutorForm === null && element.NomeTutorForm === null) {
                                tutorFormativo = ''
                            } else {
                                tutorFormativo = element.CognomeTutorForm + " " + element.NomeTutorForm
                            }
                            item = {
                                tipoSoggetto: element.IdTipoSoggetto,
                                ruoloUtente: [4],
                                descrizioneRuolo: ['Allievo'],
                                nomeUtente: element.Nome,
                                cognomeUtente: element.Cognome,
                                indirizzoUtente: element.Indirizzo,
                                telefono1Utente: element.Telefono1,
                                telefono2Utente: element.Telefono2,
                                cod: element.CodiceFiscale,
                                dataNascita: element.DataNascita,
                                luogoNascita: element.LuogoNascita,
                                emailUtente: element.Email,
                                pecUtente: element.EmailPec,
                                comuneUtente: element.Localita,
                                provinciaUtente: element.IdProvincia,
                                entità: "element.Denominazione",
                                codEntità: element.IdIstituto,
                                idCap: element.IdCap,
                                idUtente: element.IdUtenteAllievo,
                                cap: element.Cap,
                                username: element.Utente,
                                matricola: element.Matricola,
                                classe: element.AnnoCorso + ' ' + element.Sezione,
                                idClasse: element.IdClasse,
                                idNazioneNascita: element.IdNazione,
                                idArticolazione: element.IdArticolazione,
                                allievo: element.Cognome + " " + element.Nome,
                                gestioneAlternanza: element.GestioneAlternanza,
                                idDocAutorizzazione: element.IdDocAutorizzazione,
                                idStatoDoc: element.IdStatoDoc,
                                idIstitutoAnnoScolastico: element.IdIstitutoAnnoScolastico,
                                idAzienda: element.IdAzienda,
                                azienda: element.Denominazione,
                                gestioneTirocinioEstivo: element.GestioneTirocinioEstivo,
                                gestioneTirocinioFormativo: element.GestioneTirocinioFormativo,
                                tutorFormativo: tutorFormativo,
                                idRichiesta: element.IdRichiestaTirocinioFormativo,
                                comuneTirocinio: element.ComuneTirocinio,
                                provinciaTirocinio: element.ProvinciaTirocinio,
                                idStatoAccettazione: element.IdStatoAccettazione,
                                idIscrizioneAllievo: element.IdIscrizioneAllievo,
                                diplomato: false,
                                dataDiploma: '',
                                urlCV: "",
                                tutorArticolazione: ""
                            }
                            studentsList.push(item)
                        })
                        resolve(studentsList)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        getRichiesteTirFormativiIndirizzoStudio(context: DataContext, payload: { idIndirizzoStudio: number, idAnnoScolastico: number, idIstituto: number }) {
            var listaInformazioni: RichiestaTirFormativi[] = [];
            var informazione: RichiestaTirFormativi;
            return new Promise<RichiestaTirFormativi[]>((resolve, reject) => {
                dataService.getRichiesteTirFormativiIndirizzoStudio(payload.idIndirizzoStudio, payload.idAnnoScolastico, payload.idIstituto)
                    .then(response => {
                        response.forEach((element: any) => {
                            informazione = {
                                idAzienda: element.IdAzienda,
                                denominazioneAzienda: element.Denominazione,
                                titolo: element.Titolo,
                                cognomeRappresentanteAzienda: element.CognomeRappresentante,
                                nomeRappresentanteAzienda: element.NomeRappresentante,
                                dataNascitaRappresentante: element.DataNascitaRappresentante,
                                statoNascitaRappresentante: element.PaeseNascitaRappresentante,
                                luogoNascitaRappresentante: element.LuogoNascitaRappresentante,
                                comuneAzienda: element.ComuneAzienda,
                                idCapComuneAzienda: element.IdCap,
                                provinciaAzienda: element.ProvinciaAzienda,
                                indirizzoAzienda: element.Indirizzo,
                                telefono1Azienda: element.Telefono1,
                                telefono2Azienda: element.Telefono2,
                                faxAzienda: element.Fax,
                                emailAzienda: element.EMail,
                                pecAzienda: element.EMailPec,
                                sitoAzienda: element.SitoWeb,
                                attivitàAzienda: element.AttivitàSvolta,
                                dipendentiAzienda: element.NumeroDipendenti,
                                committenzaAzienda: element.Committenza,
                                associata: element.Associata,
                                artigiana: element.AziendaArtigiana,
                                pIva: element.PIva,
                                codAzienda: element.CodiceFiscale,
                                idAteco: element.IdAteco,
                                // idIstat: element.IdIstat,
                                descrizioneAteco: element.CodAteco + "-" + element.DescrizioneAteco,
                                descrizioneIstat: element.CodIstat + "-" + element.DescrizioneIstat,
                                cap: element.Cap,
                                idNazioneAzienda: element.IdNazioneAzienda,
                                nazioneAzienda: element.NazioneAzienda,
                                lavoratoriSede: element.LavoratoriSede,
                                tirociniSede: element.TirociniSede,
                                tirociniDisabiliSede: element.TirociniDisabiliSede,
                                consulente: element.Consulente,
                                provinciaTirocinio: element.ProvinciaTirocinio,
                                comuneTirocinio: element.ComuneTirocinio,
                                capTirocinio: element.CapTirocinio,
                                indirizzoTirocinio: element.IndirizzoTirocinio,
                                denominazioneConsulente: element.DenominazioneConsulente,
                                referenteConsulente: element.ReferenteConsulente,
                                telefonoConsulente: element.TelefonoConsulente,
                                emailConsulente: element.EmailConsulente,
                                attivitàTirocinio: element.AttivitaTirocinio,
                                indirizzoStudio: element.IndirizzoStudio,
                                cognomeTirocinante: element.CognomeTirocinante,
                                nomeTirocinante: element.NomeTirocinante,
                                classeTirocinante: element.ClasseTirocinante,
                                usoFuoriSede: element.UsoFuoriSede,
                                ruolo: element.Ruolo,
                                idAziendaIstitutoAnno: element.idAziendaIstitutoAnno,
                                nomeIndirizzoStudio: element.NomeIndirizzoStudio,
                                nomeSettore: element.NomeSettore,
                                idRichiesta: element.IdRichiestaTirocinioFormativo,
                                idCPIstat: 0,
                                descrizioneCPIstat: "",
                                idIscrizioneAttivita: element.IdIscrizioneAttivita,
                                idStatoUtente: element.IdStato,
                                codRappresentate: element.CFRappresentante,
                                confCommercio: element.ConfCommercio,
                                altraAssociazione: element.HasAltraAssociazione
                            }
                            listaInformazioni.push(informazione)
                        });
                        resolve(listaInformazioni)
                    }).catch(error => {
                        reject(error)
                    })
            })

        },
        getTirFormativiIstituto(context: DataContext, payload: { idIstituto: number, idAnnoScolastico: number }) {
            var listaInformazioni: RichiestaTirFormativi[] = [];
            var informazione: RichiestaTirFormativi;
            return new Promise<RichiestaTirFormativi[]>((resolve, reject) => {
                dataService.getTirFormativiIstituto(payload.idIstituto, payload.idAnnoScolastico)
                    .then(response => {
                        response.forEach((element: any) => {
                            informazione = {
                                idAzienda: element.IdAzienda,
                                denominazioneAzienda: element.Denominazione,
                                titolo: element.Titolo,
                                cognomeRappresentanteAzienda: element.CognomeRappresentante,
                                nomeRappresentanteAzienda: element.NomeRappresentante,
                                dataNascitaRappresentante: element.DataNascitaRappresentante,
                                statoNascitaRappresentante: element.PaeseNascitaRappresentante,
                                luogoNascitaRappresentante: element.LuogoNascitaRappresentante,
                                comuneAzienda: element.ComuneAzienda,
                                idCapComuneAzienda: element.IdCap,
                                provinciaAzienda: element.ProvinciaAzienda,
                                indirizzoAzienda: element.Indirizzo,
                                telefono1Azienda: element.Telefono1,
                                telefono2Azienda: element.Telefono2,
                                faxAzienda: element.Fax,
                                emailAzienda: element.EMail,
                                pecAzienda: element.EMailPec,
                                sitoAzienda: element.SitoWeb,
                                attivitàAzienda: element.AttivitàSvolta,
                                dipendentiAzienda: element.NumeroDipendenti,
                                committenzaAzienda: element.Committenza,
                                associata: element.Associata,
                                artigiana: element.AziendaArtigiana,
                                pIva: element.PIva,
                                codAzienda: element.CodiceFiscale,
                                idAteco: element.IdAteco,
                                // idIstat: element.IdIstat,
                                descrizioneAteco: element.CodAteco + "-" + element.DescrizioneAteco,
                                descrizioneIstat: element.CodIstat + "-" + element.DescrizioneIstat,
                                cap: element.Cap,
                                idNazioneAzienda: element.IdNazioneAzienda,
                                nazioneAzienda: element.NazioneAzienda,
                                lavoratoriSede: element.LavoratoriSede,
                                tirociniSede: element.TirociniSede,
                                tirociniDisabiliSede: element.TirociniDisabiliSede,
                                consulente: element.Consulente,
                                provinciaTirocinio: element.ProvinciaTirocinio,
                                comuneTirocinio: element.ComuneTirocinio,
                                capTirocinio: element.CapTirocinio,
                                indirizzoTirocinio: element.IndirizzoTirocinio,
                                denominazioneConsulente: element.DenominazioneConsulente,
                                referenteConsulente: element.ReferenteConsulente,
                                telefonoConsulente: element.TelefonoConsulente,
                                emailConsulente: element.EmailConsulente,
                                attivitàTirocinio: element.AttivitaTirocinio,
                                indirizzoStudio: element.IndirizzoStudio,
                                cognomeTirocinante: element.CognomeTirocinante,
                                nomeTirocinante: element.NomeTirocinante,
                                classeTirocinante: element.ClasseTirocinante,
                                usoFuoriSede: element.UsoFuoriSede,
                                ruolo: element.Ruolo,
                                idAziendaIstitutoAnno: element.idAziendaIstitutoAnno,
                                nomeIndirizzoStudio: element.NomeIndirizzoStudio,
                                nomeSettore: element.NomeSettore,
                                idRichiesta: element.IdRichiestaTirocinioFormativo,
                                idCPIstat: element.IdCPIstat,
                                descrizioneCPIstat: "",
                                idIscrizioneAttivita: element.IdIscrizioneAttivita,
                                idStatoUtente: element.IdStato,
                                codRappresentate: element.CFRappresentante,
                                confCommercio: element.ConfCommercio,
                                altraAssociazione: element.HasAltraAssociazione
                            }
                            listaInformazioni.push(informazione)
                        });
                        resolve(listaInformazioni)
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        getAllieviPreAssegnatiTirFormativi(context: DataContext, payload: { idIstituto: number, idAnnoScolastico: number, idTutor: number }) {
            var studentsList: StudentAssignmentCompleteTirFormativo[] = []
            var student: StudentAssignmentCompleteTirFormativo
            var dataInizio: any
            var dataFine: any
            var dataProtocollazione: any = ""
            var dataInizioSospUno: any = ""
            var dataFineSospUno: any = ""
            var dataInizioSospDue: any = ""
            var dataFineSospDue: any = ""
            var usoFuori: string;
            return new Promise<StudentAssignmentCompleteTirFormativo[]>((resolve, reject) => {
                dataService.getAllieviPreAssegnatiTirFormativi(payload.idIstituto, payload.idAnnoScolastico, payload.idTutor)
                    .then(response => {
                        response.forEach((element: any) => {
                            dataProtocollazione = ""
                            dataInizioSospUno = ""
                            dataFineSospUno = ""
                            dataInizioSospDue = ""
                            dataFineSospDue = ""
                            if (element.UsoFuoriSede === false) {
                                usoFuori = "No"
                            } else {
                                usoFuori = "Si"
                            }
                            dataInizio = new Date(element.DataInizioPeriodo)
                            dataFine = new Date(element.DataFinePeriodo)
                            if (element.DataProtocollazione !== null) {
                                dataProtocollazione = new Date(element.DataProtocollazione)
                                dataProtocollazione = dataProtocollazione.getFullYear() + "-" + (dataProtocollazione.getMonth() + 1) + "-" + dataProtocollazione.getDate()
                            }
                            if (element.DataInizioSospensioneUno !== null && element.DataFineSospensioneUno !== null) {
                                dataInizioSospUno = new Date(element.DataInizioSospensioneUno)
                                dataFineSospUno = new Date(element.DataFineSospensioneUno)
                                dataInizioSospUno = dataInizioSospUno.getDate() + "/" + (dataInizioSospUno.getMonth() + 1) + "/" + dataInizioSospUno.getFullYear()
                                dataFineSospUno = dataFineSospUno.getDate() + "/" + (dataFineSospUno.getMonth() + 1) + "/" + dataFineSospUno.getFullYear()
                            }
                            if (element.DataInizioSospensioneDue !== null && element.DataFineSospensioneDue !== null) {
                                dataInizioSospDue = new Date(element.DataInizioSospensioneDue)
                                dataFineSospDue = new Date(element.DataFineSospensioneDue)
                                dataInizioSospDue = dataInizioSospDue.getDate() + "/" + (dataInizioSospDue.getMonth() + 1) + "/" + dataInizioSospDue.getFullYear()
                                dataFineSospDue = dataFineSospDue.getDate() + "/" + (dataFineSospDue.getMonth() + 1) + "/" + dataFineSospDue.getFullYear()
                            }
                            student = {
                                tipoSoggetto: element.IdTipoSoggetto,
                                ruoloUtente: [4],
                                descrizioneRuolo: ['Allievo'],
                                nomeUtente: element.Nome,
                                cognomeUtente: element.Cognome,
                                indirizzoUtente: element.IndirizzoAllievo,
                                telefono1Utente: element.Telefono1Allievo,
                                telefono2Utente: element.Telefono2Allievo,
                                cod: element.CodAllievo,
                                dataNascita: element.DataNascita,
                                luogoNascita: element.LuogoNascita,
                                emailUtente: element.Email,
                                pecUtente: element.EmailPec,
                                comuneUtente: element.LocalitaAllievo,
                                provinciaUtente: element.IdProvinciaAllievo,
                                entità: "element.Denominazione",
                                codEntità: element.IdIstituto,
                                idCap: element.IdCap,
                                idUtente: element.Id,
                                cap: element.CapAllievo,
                                username: element.Utente,
                                matricola: element.Matricola,
                                classe: element.AnnoCorso + ' ' + element.Sezione,
                                idClasse: element.IdClasse,
                                idNazioneNascita: element.IdNazione,
                                idArticolazione: element.IdArticolazione,
                                allievo: element.Cognome + " " + element.Nome,
                                gestioneAlternanza: element.GestioneAlternanza,
                                idDocAutorizzazione: element.IdDocAutorizzazione,
                                idStatoDoc: element.IdStatoDoc,
                                idIstitutoAnnoScolastico: element.IdIstitutoAnnoScolastico,
                                idAzienda: element.IdAzienda,
                                azienda: "",
                                idInfoRichiestaTirFormativo: element.IdRichiestaTirocinioFormativo,
                                idTutorAzienda: element.IdTutorAzienda,
                                tutorAzienda: element.CognomeTutorAzienda + " " + element.NomeTutorAzienda,
                                telefonoTutor: element.TelefonoTutorAziendale,
                                emailTutor: element.EmailTutorAziendale,
                                dataInizioPeriodo: dataInizio.getDate() + "/" + (dataInizio.getMonth() + 1) + "/" + dataInizio.getFullYear(),
                                dataFinePeriodo: dataFine.getDate() + "/" + (dataFine.getMonth() + 1) + "/" + dataFine.getFullYear(),
                                orarioInizioMattino: element.OrarioInizioMattino,
                                orarioFineMattino: element.OrarioFineMattino,
                                orarioInizioPomeriggio: element.OrarioInizioPomeriggio,
                                orarioFinePomeriggio: element.OrarioFinePomeriggio,
                                mansioni: "",
                                idStatoAccettazione: element.IdStatoAccettazione,

                                // idAzienda: element.IdAzienda,
                                denominazioneAzienda: element.NomeAzienda,
                                titolo: element.Titolo,
                                cognomeRappresentanteAzienda: element.CognomeRappresentante,
                                nomeRappresentanteAzienda: element.NomeRappresentante,
                                dataNascitaRappresentante: element.DataNascitaRappresentante,
                                statoNascitaRappresentante: element.PaeseNascitaRappresentante,
                                luogoNascitaRappresentante: element.LuogoNascitaRappresentante,
                                comuneAzienda: element.LocalitaAzienda,
                                idCapComuneAzienda: element.IdCap,
                                provinciaAzienda: element.IdProvinciaAzienda,
                                indirizzoAzienda: element.IndirizzoAzienda,
                                telefono1Azienda: element.Telefono1Azienda,
                                telefono2Azienda: element.Telefono2Azienda,
                                faxAzienda: element.Fax,
                                emailAzienda: element.EMail,
                                pecAzienda: element.EMailPec,
                                sitoAzienda: element.SitoWeb,
                                attivitàAzienda: element.AttivitàSvolta,
                                dipendentiAzienda: element.NumeroDipendenti,
                                committenzaAzienda: element.Committenza,
                                associata: element.Associata,
                                artigiana: element.AziendaArtigiana,
                                pIva: element.PIva,
                                codAzienda: element.CodAzienda,
                                idAteco: element.IdAteco,
                                // idIstat: element.IdIstat,
                                descrizioneAteco: element.CodAteco + "-" + element.DescrizioneAteco,
                                descrizioneIstat: element.CodIstat + "-" + element.DescrizioneIstat,
                                // capAzienda: element.CapAzienda,
                                idNazioneAzienda: element.IdNazioneAzienda,
                                nazioneAzienda: element.NazioneAzienda,

                                lavoratoriSede: element.LavoratoriSede,
                                tirociniSede: element.TirociniSede,
                                tirociniDisabiliSede: element.TirociniDisabiliSede,
                                consulente: element.Consulente,
                                provinciaTirocinio: element.ProvinciaTirocinio,
                                comuneTirocinio: element.ComuneTirocinio,
                                capTirocinio: element.CapTirocinio,
                                indirizzoTirocinio: element.IndirizzoTirocinio,
                                denominazioneConsulente: element.DenominazioneConsulente,
                                referenteConsulente: element.ReferenteConsulente,
                                telefonoConsulente: element.TelefonoConsulente,
                                emailConsulente: element.EmailConsulente,
                                attivitàTirocinio: element.AttivitaTirocinio,
                                indirizzoStudio: element.IndirizzoStudio,
                                cognomeTirocinante: "",
                                nomeTirocinante: "",
                                classeTirocinante: "",
                                usoFuoriSede: usoFuori,
                                ruolo: element.Ruolo,
                                idAziendaIstitutoAnno: element.idAziendaIstitutoAnno,
                                nomeIndirizzoStudio: element.NomeIndirizzoStudio,
                                nomeSettore: element.NomeSettore,
                                idRichiesta: element.IdRichiestaTirocinioFormativo,
                                gestioneTirocinioEstivo: element.GestioneTirocinioEstivo,
                                gestioneTirocinioFormativo: element.GestioneTirocinioFormativo,
                                tutorFormativo: "",
                                idCPIstat: element.CodIstat,
                                descrizioneCPIstat: "",
                                idConvenzione: element.IdConvenzione,
                                idProgettoOrientamento: element.IdProgettoOrientamento,

                                responsabilitaCivile: element.ResponsabilitaCivile,
                                assicurazioneAzienda: element.AssicurazioneAzienda,
                                indennitaMensile: element.IndennitaMensile,
                                dataInizioSospensioneUno: dataInizioSospUno,
                                dataFineSospensioneUno: dataFineSospUno,
                                motivazioneSospensioneUno: element.MotivazioneSospensioneUno,
                                dataInizioSospensioneDue: dataInizioSospDue,
                                dataFineSospensioneDue: dataFineSospDue,
                                motivazioneSospensioneDue: element.MotivazioneSospensioneDue,
                                idIscrizioneAllievo: 0,
                                idIscrizioneAttivita: element.IdIscrizioneAttivita,
                                idConsenso: element.IdConsenso,
                                firmaConvenzioneAz: element.FirmaConvenzioneAzienda,
                                firmaConsensoAz: element.FirmaConsensoAzienda,
                                firmaConsensoTir: element.FirmaConsensoTirocinante,
                                statoDocConvenzione: element.IdStatoDocConvenzione,
                                statoDocConsenso: element.IdStatoDocConsenso,
                                numeroProtocollazione: element.NumeroProtocollazione,
                                dataProtocollazione: dataProtocollazione,
                                reportVisite: element.ReportVisite,
                                idStatoUtente: element.IdStato,
                                diplomato: false,
                                dataDiploma: '',
                                urlCV: "",
                                apprendistatoCheck: element.Appredistato,
                                tutorArticolazione: "",
                                codRappresentate: element.CFRappresentante,
                                confCommercio: element.ConfCommercio,
                                altraAssociazione: element.HasAltraAssociazione
                            }
                            studentsList.push(student)
                        })
                        resolve(studentsList)
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        getAssociazioniTutorFormativoTirFormativi(context: DataContext, payload: { idTutorForm: number, idIstituto: number, idAnnoScolastico: number }) {
            var studentsList: StudentAssignmentTirFormativoInfo[] = []
            var student: StudentAssignmentTirFormativoInfo
            var usoFuori: string;
            var dataInizio: any
            var dataFine: any
            var dataInizioSospUno: any = ""
            var dataFineSospUno: any = ""
            var dataInizioSospDue: any = ""
            var dataFineSospDue: any = ""
            return new Promise<StudentAssignmentTirFormativoInfo[]>((resolve, reject) => {
                dataService.getAssociazioniTutorFormativoTirFormativi(payload.idTutorForm, payload.idIstituto, payload.idAnnoScolastico)
                    .then(result => {
                        result.forEach((element: any) => {
                            dataInizioSospUno = ""
                            dataFineSospUno = ""
                            dataInizioSospDue = ""
                            dataFineSospDue = ""
                            if (element.UsoFuoriSede === false) {
                                usoFuori = "No"
                            } else {
                                usoFuori = "Si"
                            }
                            dataInizio = new Date(element.DataInizioPeriodo)
                            dataFine = new Date(element.DataFinePeriodo)
                            if (element.DataInizioSospensioneUno !== null && element.DataFineSospensioneUno !== null) {
                                dataInizioSospUno = new Date(element.DataInizioSospensioneUno)
                                dataFineSospUno = new Date(element.DataFineSospensioneUno)
                                dataInizioSospUno = dataInizioSospUno.getDate() + "/" + (dataInizioSospUno.getMonth() + 1) + "/" + dataInizioSospUno.getFullYear()
                                dataFineSospUno = dataFineSospUno.getDate() + "/" + (dataFineSospUno.getMonth() + 1) + "/" + dataFineSospUno.getFullYear()
                            }
                            if (element.DataInizioSospensioneDue !== null && element.DataFineSospensioneDue !== null) {
                                dataInizioSospDue = new Date(element.DataInizioSospensioneDue)
                                dataFineSospDue = new Date(element.DataFineSospensioneDue)
                                dataInizioSospDue = dataFineSospUno.getDate() + "/" + (dataFineSospUno.getMonth() + 1) + "/" + dataFineSospUno.getFullYear()
                                dataFineSospDue = dataFineSospDue.getDate() + "/" + (dataFineSospDue.getMonth() + 1) + "/" + dataFineSospDue.getFullYear()
                            }
                            student = {
                                tipoSoggetto: element.IdTipoSoggetto,
                                ruoloUtente: [4],
                                descrizioneRuolo: ['Allievo'],
                                nomeUtente: element.Nome,
                                cognomeUtente: element.Cognome,
                                indirizzoUtente: element.IndirizzoAllievo,
                                telefono1Utente: element.Telefono1Allievo,
                                telefono2Utente: element.Telefono2Allievo,
                                cod: element.CodAllievo,
                                dataNascita: element.DataNascita,
                                luogoNascita: element.LuogoNascita,
                                emailUtente: element.Email,
                                pecUtente: element.EmailPec,
                                comuneUtente: element.LocalitaAllievo,
                                provinciaUtente: element.IdProvinciaAllievo,
                                entità: "element.Denominazione",
                                codEntità: element.IdIstituto,
                                idCap: element.IdCap,
                                idUtente: element.Id,
                                cap: element.CapAllievo,
                                username: element.Utente,
                                matricola: element.Matricola,
                                classe: element.AnnoCorso + ' ' + element.Sezione,
                                idClasse: element.IdClasse,
                                idNazioneNascita: element.IdNazione,
                                idArticolazione: element.IdArticolazione,
                                allievo: element.Cognome + " " + element.Nome,
                                gestioneAlternanza: element.GestioneAlternanza,
                                idDocAutorizzazione: element.IdDocAutorizzazione,
                                idStatoDoc: element.IdStatoDoc,
                                idIstitutoAnnoScolastico: element.IdIstitutoAnnoScolastico,
                                idAzienda: element.IdAzienda,
                                azienda: "",
                                idInfoRichiestaTirFormativo: element.IdRichiestaTirocinioFormativo,
                                idTutorAzienda: element.IdTutorAzienda,
                                tutorAzienda: element.CognomeTutorAzienda + " " + element.NomeTutorAzienda,
                                telefonoTutor: element.TelefonoTutorAziendale,
                                emailTutor: element.EmailTutorAziendale,
                                dataInizioPeriodo: dataInizio.getDate() + "/" + (dataInizio.getMonth() + 1) + "/" + dataInizio.getFullYear(),
                                dataFinePeriodo: dataFine.getDate() + "/" + (dataFine.getMonth() + 1) + "/" + dataFine.getFullYear(),
                                orarioInizioMattino: element.OrarioInizioMattino,
                                orarioFineMattino: element.OrarioFineMattino,
                                orarioInizioPomeriggio: element.OrarioInizioPomeriggio,
                                orarioFinePomeriggio: element.OrarioFinePomeriggio,
                                mansioni: "",
                                idStatoAccettazione: element.IdStatoAccettazione,

                                // idAzienda: element.IdAzienda,
                                denominazioneAzienda: element.NomeAzienda,
                                titolo: element.Titolo,
                                cognomeRappresentanteAzienda: element.CognomeRappresentante,
                                nomeRappresentanteAzienda: element.NomeRappresentante,
                                dataNascitaRappresentante: element.DataNascitaRappresentante,
                                statoNascitaRappresentante: element.PaeseNascitaRappresentante,
                                luogoNascitaRappresentante: element.LuogoNascitaRappresentante,
                                comuneAzienda: element.LocalitaAzienda,
                                idCapComuneAzienda: element.IdCap,
                                provinciaAzienda: element.IdProvinciaAzienda,
                                indirizzoAzienda: element.IndirizzoAzienda,
                                telefono1Azienda: element.Telefono1Azienda,
                                telefono2Azienda: element.Telefono2Azienda,
                                faxAzienda: element.Fax,
                                emailAzienda: element.EMail,
                                pecAzienda: element.EMailPec,
                                sitoAzienda: element.SitoWeb,
                                attivitàAzienda: element.AttivitàSvolta,
                                dipendentiAzienda: element.NumeroDipendenti,
                                committenzaAzienda: element.Committenza,
                                associata: element.Associata,
                                artigiana: element.AziendaArtigiana,
                                pIva: element.PIva,
                                codAzienda: element.CodAzienda,
                                idAteco: element.IdAteco,
                                // idIstat: element.IdIstat,
                                descrizioneAteco: element.CodAteco + "-" + element.DescrizioneAteco,
                                descrizioneIstat: element.CodIstat + "-" + element.DescrizioneIstat,
                                // capAzienda: element.CapAzienda,
                                idNazioneAzienda: element.IdNazioneAzienda,
                                nazioneAzienda: element.NazioneAzienda,

                                lavoratoriSede: element.LavoratoriSede,
                                tirociniSede: element.TirociniSede,
                                tirociniDisabiliSede: element.TirociniDisabiliSede,
                                consulente: element.Consulente,
                                provinciaTirocinio: element.ProvinciaTirocinio,
                                comuneTirocinio: element.ComuneTirocinio,
                                capTirocinio: element.CapTirocinio,
                                indirizzoTirocinio: element.IndirizzoTirocinio,
                                denominazioneConsulente: element.DenominazioneConsulente,
                                referenteConsulente: element.ReferenteConsulente,
                                telefonoConsulente: element.TelefonoConsulente,
                                emailConsulente: element.EmailConsulente,
                                attivitàTirocinio: element.AttivitaTirocinio,
                                indirizzoStudio: element.IndirizzoStudio,
                                cognomeTirocinante: "",
                                nomeTirocinante: "",
                                classeTirocinante: "",
                                usoFuoriSede: usoFuori,
                                ruolo: element.Ruolo,
                                idAziendaIstitutoAnno: element.idAziendaIstitutoAnno,
                                nomeIndirizzoStudio: element.NomeIndirizzoStudio,
                                nomeSettore: element.NomeSettore,
                                idRichiesta: element.IdRichiestaTirocinioFormativo,
                                gestioneTirocinioEstivo: element.GestioneTirocinioEstivo,
                                gestioneTirocinioFormativo: element.GestioneTirocinioFormativo,
                                tutorFormativo: "",
                                idCPIstat: element.CodIstat,
                                descrizioneCPIstat: "",
                                idConvenzione: element.IdConvenzione,
                                idProgettoOrientamento: element.IdProgettoOrientamento,

                                responsabilitaCivile: element.ResponsabilitaCivile,
                                assicurazioneAzienda: element.AssicurazioneAzienda,
                                indennitaMensile: element.IndennitaMensile,
                                dataInizioSospensioneUno: dataInizioSospUno,
                                dataFineSospensioneUno: dataFineSospUno,
                                motivazioneSospensioneUno: element.MotivazioneSospensioneUno,
                                dataInizioSospensioneDue: dataInizioSospDue,
                                dataFineSospensioneDue: dataFineSospDue,
                                motivazioneSospensioneDue: element.MotivazioneSospensioneDue,
                                idIscrizioneAllievo: 0,
                                idIscrizioneAttivita: element.IdIscrizioneAttivita,
                                reportVisite: element.ReportVisite,
                                idStatoUtente: element.IdStato,
                                diplomato: false,
                                dataDiploma: '',
                                urlCV: "",
                                apprendistatoCheck: element.Appredistato,
                                tutorArticolazione: "",
                                codRappresentate: element.CFRappresentante,
                                confCommercio: element.ConfCommercio,
                                altraAssociazione: element.HasAltraAssociazione
                            }
                            studentsList.push(student)
                        });
                        resolve(studentsList)
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        getAssociazioniTutorAziendaleTirEstivo(context: DataContext, payload: { idTutor: number, idAzienda: number, idAnnoScolastico: number }) {
            var studentsList: StudentAssignmentTirEstivoInfo[] = []
            var student: StudentAssignmentTirEstivoInfo
            var usoFuori: string;
            var dataInizio: any
            var dataFine: any
            var dataProtocollo: any;
            return new Promise<StudentAssignmentTirEstivoInfo[]>((resolve, reject) => {
                dataService.getAssociazioniTutorAziendaleTirEstivo(payload.idTutor, payload.idAzienda, payload.idAnnoScolastico)
                    .then(response => {
                        response.forEach((element: any) => {
                            if (element.UsoFuoriSede === false) {
                                usoFuori = "No"
                            } else {
                                usoFuori = "Si"
                            }
                            dataInizio = new Date(element.DataInizioPeriodo)
                            dataFine = new Date(element.DataFinePeriodo)
                            dataProtocollo = new Date(element.DataProtocollo)
                            student = {
                                tipoSoggetto: element.IdTipoSoggetto,
                                ruoloUtente: [4],
                                descrizioneRuolo: ['Allievo'],
                                nomeUtente: element.Nome,
                                cognomeUtente: element.Cognome,
                                indirizzoUtente: element.IndirizzoAllievo,
                                telefono1Utente: element.Telefono1Allievo,
                                telefono2Utente: element.Telefono2Allievo,
                                cod: element.CodAllievo,
                                dataNascita: element.DataNascita,
                                luogoNascita: element.LuogoNascita,
                                emailUtente: element.Email,
                                pecUtente: element.EmailPec,
                                comuneUtente: element.LocalitaAllievo,
                                provinciaUtente: element.IdProvinciaAllievo,
                                entità: "element.Denominazione",
                                codEntità: element.IdIstituto,
                                idCap: element.IdCap,
                                idUtente: element.Id,
                                cap: element.CapAllievo,
                                username: element.Utente,
                                matricola: element.Matricola,
                                classe: element.AnnoCorso + ' ' + element.Sezione,
                                idClasse: element.IdClasse,
                                idNazioneNascita: element.IdNazione,
                                idArticolazione: element.IdArticolazione,
                                allievo: element.Cognome + " " + element.Nome,
                                gestioneAlternanza: element.GestioneAlternanza,
                                idDocAutorizzazione: element.IdDocAutorizzazione,
                                idStatoDoc: element.IdStatoDoc,
                                idIstitutoAnnoScolastico: element.IdIstitutoAnnoScolastico,
                                idAzienda: element.IdAzienda,
                                azienda: "",
                                idInfoRichiestaTirEstivo: element.IdRichiestaTirocinioEstivo,
                                idTutorAzienda: element.IdTutorAzienda,
                                tutorAzienda: element.CognomeTutorAzienda + " " + element.NomeTutorAzienda,
                                telefonoTutor: element.TelefonoTutorAziendale,
                                emailTutor: element.EmailTutorAziendale,
                                dataInizioPeriodo: dataInizio.getDate() + "/" + (dataInizio.getMonth() + 1) + "/" + dataInizio.getFullYear(),
                                dataFinePeriodo: dataFine.getDate() + "/" + (dataFine.getMonth() + 1) + "/" + dataFine.getFullYear(),
                                orarioInizioMattino: element.OrarioInizioMattino,
                                orarioFineMattino: element.OrarioFineMattino,
                                orarioInizioPomeriggio: element.OrarioInizioPomeriggio,
                                orarioFinePomeriggio: element.OrarioFinePomeriggio,
                                mansioni: "",
                                idStatoAccettazione: element.IdStatoAccettazione,

                                // idAzienda: element.IdAzienda,
                                denominazioneAzienda: element.NomeAzienda,
                                titolo: element.Titolo,
                                cognomeRappresentanteAzienda: element.CognomeRappresentante,
                                nomeRappresentanteAzienda: element.NomeRappresentante,
                                dataNascitaRappresentante: element.DataNascitaRappresentante,
                                statoNascitaRappresentante: element.PaeseNascitaRappresentante,
                                luogoNascitaRappresentante: element.LuogoNascitaRappresentante,
                                comuneAzienda: element.LocalitaAzienda,
                                idCapComuneAzienda: element.IdCap,
                                provinciaAzienda: element.IdProvinciaAzienda,
                                indirizzoAzienda: element.IndirizzoAzienda,
                                telefono1Azienda: element.Telefono1Azienda,
                                telefono2Azienda: element.Telefono2Azienda,
                                faxAzienda: element.Fax,
                                emailAzienda: element.EMail,
                                pecAzienda: element.EMailPec,
                                sitoAzienda: element.SitoWeb,
                                attivitàAzienda: element.AttivitàSvolta,
                                dipendentiAzienda: element.NumeroDipendenti,
                                committenzaAzienda: element.Committenza,
                                associata: element.Associata,
                                artigiana: element.AziendaArtigiana,
                                pIva: element.PIva,
                                codAzienda: element.CodAzienda,
                                idAteco: element.IdAteco,
                                // idIstat: element.IdIstat,
                                descrizioneAteco: element.CodAteco + "-" + element.DescrizioneAteco,
                                descrizioneIstat: element.CodIstat + "-" + element.DescrizioneIstat,
                                // capAzienda: element.CapAzienda,
                                idNazioneAzienda: element.IdNazioneAzienda,
                                nazioneAzienda: element.NazioneAzienda,

                                lavoratoriSede: element.LavoratoriSede,
                                tirociniSede: element.TirociniSede,
                                tirociniDisabiliSede: element.TirociniDisabiliSede,
                                consulente: element.Consulente,
                                provinciaTirocinio: element.ProvinciaTirocinio,
                                comuneTirocinio: element.ComuneTirocinio,
                                capTirocinio: element.CapTirocinio,
                                indirizzoTirocinio: element.IndirizzoTirocinio,
                                denominazioneConsulente: element.DenominazioneConsulente,
                                referenteConsulente: element.ReferenteConsulente,
                                telefonoConsulente: element.TelefonoConsulente,
                                emailConsulente: element.EmailConsulente,
                                attivitàTirocinio: element.AttivitaTirocinio,
                                indirizzoStudio: element.IndirizzoStudio,
                                cognomeTirocinante: "",
                                nomeTirocinante: "",
                                classeTirocinante: "",
                                usoFuoriSede: usoFuori,
                                ruolo: element.Ruolo,
                                idAziendaIstitutoAnno: element.idAziendaIstitutoAnno,
                                nomeIndirizzoStudio: element.NomeIndirizzoStudio,
                                nomeSettore: element.NomeSettore,
                                idRichiesta: element.IdRichiestaTirocinioEstivo,
                                gestioneTirocinioEstivo: element.GestioneTirocinioEstivo,
                                gestioneTirocinioFormativo: element.GestioneTirocinioFormativo,
                                tutorFormativo: element.CognomeTutorFormativo + " " + element.NomeTutorFormativo,
                                idCPIstat: 0,
                                descrizioneCPIstat: "",
                                idConvenzione: element.IdConvenzione,
                                idProgettoOrientamento: element.IdProgettoOrientamento,
                                numeroProtocollazione: element.NumeroProtocollo,
                                dataProtocollazione: dataProtocollo.getDate() + "/" + (dataProtocollo.getMonth() + 1) + "/" + dataProtocollo.getFullYear(),
                                idIscrizioneAllievo: 0,
                                idIscrizioneAttivita: element.IdIscrizioneAttivita,
                                reportVisite: element.ReportVisite,
                                idStatoUtente: element.IdStato,
                                diplomato: false,
                                dataDiploma: '',
                                urlCV: "",
                                tutorArticolazione: "",
                                codRappresentate: element.CFRappresentante,
                                confCommercio: element.ConfCommercio,
                                altraAssociazione: element.HasAltraAssociazione
                            }
                            studentsList.push(student)
                        })
                        resolve(studentsList)
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        getAssociazioniTutorAziendaleAlternanza(context: DataContext, payload: { idTutor: number, idAzienda: number, idAnnoScolastico: number }) {
            var studentsList: StudentAssignmentInfo[] = []
            var student: StudentAssignmentInfo
            var usoFuori: string;
            var dataInizio: any
            var dataFine: any
            var dataInizioSecondoPeriodo: any
            var dataFineSecondoPeriodo: any
            var dataProtocollo: any;
            return new Promise<StudentAssignmentInfo[]>((resolve, reject) => {
                dataService.getAssociazioniTutorAziendaleAlternanza(payload.idTutor, payload.idAzienda, payload.idAnnoScolastico)
                    .then(response => {
                        response.forEach((element: any) => {
                            if (element.UsoFuoriSede === false) {
                                usoFuori = "No"
                            } else {
                                usoFuori = "Si"
                            }
                            dataInizio = new Date(element.DataInizioPeriodo)
                            dataFine = new Date(element.DataFinePeriodo)
                            dataInizioSecondoPeriodo = new Date(element.DataInizioPeriodoDue)
                            dataFineSecondoPeriodo = new Date(element.DataFinePeriodoDue)
                            dataProtocollo = new Date(element.DataProtocollo)
                            student = {
                                tipoSoggetto: element.IdTipoSoggetto,
                                ruoloUtente: [4],
                                descrizioneRuolo: ['Allievo'],
                                nomeUtente: element.Nome,
                                cognomeUtente: element.Cognome,
                                indirizzoUtente: element.IndirizzoAllievo,
                                telefono1Utente: element.Telefono1Allievo,
                                telefono2Utente: element.Telefono2Allievo,
                                cod: element.CodAllievo,
                                dataNascita: element.DataNascita,
                                luogoNascita: element.LuogoNascita,
                                emailUtente: element.Email,
                                pecUtente: element.EmailPec,
                                comuneUtente: element.LocalitaAllievo,
                                provinciaUtente: element.IdProvinciaAllievo,
                                entità: "element.Denominazione",
                                codEntità: element.IdIstituto,
                                idCap: element.IdCap,
                                idUtente: element.Id,
                                cap: element.CapAllievo,
                                username: element.Utente,
                                matricola: element.Matricola,
                                classe: element.AnnoCorso + ' ' + element.Sezione,
                                idClasse: element.IdClasse,
                                idNazioneNascita: element.IdNazione,
                                idArticolazione: element.IdArticolazione,
                                allievo: element.Cognome + " " + element.Nome,
                                gestioneAlternanza: element.GestioneAlternanza,
                                idDocAutorizzazione: element.IdDocAutorizzazione,
                                idStatoDoc: element.IdStatoDoc,
                                idIstitutoAnnoScolastico: element.IdIstitutoAnnoScolastico,
                                idAzienda: element.IdAzienda,
                                azienda: "",
                                idInfoAlternanza: element.IdInformazioneAlternanza,
                                idTutorAzienda: element.IdTutorAzienda,
                                tutorAzienda: element.CognomeTutorAzienda + " " + element.NomeTutorAzienda,
                                telefonoTutor: element.TelefonoTutorAziendale,
                                emailTutor: element.EmailTutorAziendale,
                                dataInizioPeriodo: dataInizio.getDate() + "/" + (dataInizio.getMonth() + 1) + "/" + dataInizio.getFullYear(),
                                dataFinePeriodo: dataFine.getDate() + "/" + (dataFine.getMonth() + 1) + "/" + dataFine.getFullYear(),
                                orarioInizioMattino: element.OrarioInizioMattino,
                                orarioFineMattino: element.OrarioFineMattino,
                                orarioInizioPomeriggio: element.OrarioInizioPomeriggio,
                                orarioFinePomeriggio: element.OrarioFinePomeriggio,
                                dataInizioSecondoPeriodo: dataInizioSecondoPeriodo ? dataInizioSecondoPeriodo.getDate() + "/" + (dataInizioSecondoPeriodo.getMonth() + 1) + "/" + dataInizioSecondoPeriodo.getFullYear() : "",
                                dataFineSecondoPeriodo: dataFineSecondoPeriodo ? dataFineSecondoPeriodo.getDate() + "/" + (dataFineSecondoPeriodo.getMonth() + 1) + "/" + dataFineSecondoPeriodo.getFullYear() : "",
                                orarioInizioMattinoSecondoPeriodo: element.OrarioInizioMattinoDue,
                                orarioFineMattinoSecondoPeriodo: element.OrarioFineMattinoDue,
                                orarioInizioPomeriggioSecondoPeriodo: element.OrarioInizioPomeriggioDue,
                                orarioFinePomeriggioSecondoPeriodo: element.OrarioFinePomeriggioDue,
                                mansioni: "",
                                idStatoAccettazione: element.IdStatoAccettazione,
                                idStatoAccettazioneAllievo: element.IdStatoAccettazioneAllievo,
                                rating: element.Rating,
                                notaRating: element.NotaRating,
                                // idAzienda: element.IdAzienda,
                                denominazioneAzienda: element.NomeAzienda,
                                titolo: element.Titolo,
                                cognomeRappresentanteAzienda: element.CognomeRappresentante,
                                nomeRappresentanteAzienda: element.NomeRappresentante,
                                dataNascitaRappresentante: element.DataNascitaRappresentante,
                                statoNascitaRappresentante: element.PaeseNascitaRappresentante,
                                luogoNascitaRappresentante: element.LuogoNascitaRappresentante,
                                comuneAzienda: element.LocalitaAzienda,
                                idCapComuneAzienda: element.IdCap,
                                provinciaAzienda: element.IdProvinciaAzienda,
                                indirizzoAzienda: element.IndirizzoAzienda,
                                telefono1Azienda: element.Telefono1Azienda,
                                telefono2Azienda: element.Telefono2Azienda,
                                faxAzienda: element.Fax,
                                emailAzienda: element.EMail,
                                pecAzienda: element.EMailPec,
                                sitoAzienda: element.SitoWeb,
                                attivitàAzienda: element.AttivitàSvolta,
                                dipendentiAzienda: element.NumeroDipendenti,
                                committenzaAzienda: element.Committenza,
                                associata: element.Associata,
                                artigiana: element.AziendaArtigiana,
                                pIva: element.PIva,
                                codAzienda: element.CodAzienda,
                                idAteco: element.IdAteco,
                                // idIstat: element.IdIstat,
                                descrizioneAteco: element.CodAteco + "-" + element.DescrizioneAteco,
                                descrizioneIstat: element.CodIstat + "-" + element.DescrizioneIstat,
                                // capAzienda: element.CapAzienda,
                                idNazioneAzienda: element.IdNazioneAzienda,
                                nazioneAzienda: element.NazioneAzienda,

                                lavoratoriSede: element.LavoratoriSede,
                                tirociniSede: element.TirociniSede,
                                tirociniDisabiliSede: element.TirociniDisabiliSede,
                                consulente: element.Consulente,
                                provinciaTirocinio: element.ProvinciaTirocinio,
                                comuneTirocinio: element.ComuneTirocinio,
                                capTirocinio: element.CapTirocinio,
                                indirizzoTirocinio: element.IndirizzoTirocinio,
                                denominazioneConsulente: element.DenominazioneConsulente,
                                referenteConsulente: element.ReferenteConsulente,
                                telefonoConsulente: element.TelefonoConsulente,
                                emailConsulente: element.EmailConsulente,
                                attivitàTirocinio: element.AttivitaTirocinio,
                                indirizzoStudio: element.IndirizzoStudio,
                                cognomeTirocinante: "",
                                nomeTirocinante: "",
                                classeTirocinante: "",
                                usoFuoriSede: usoFuori,
                                firmaDigitale: element.FirmaDigitale,
                                ruolo: element.Ruolo,
                                idAziendaIstitutoAnno: element.idAziendaIstitutoAnno,
                                nomeIndirizzoStudio: element.NomeIndirizzoStudio,
                                nomeSettore: element.NomeSettore,
                                idRichiesta: element.IdInformazioneAlternanza,
                                gestioneTirocinioEstivo: element.GestioneTirocinioEstivo,
                                gestioneTirocinioFormativo: element.GestioneTirocinioFormativo,
                                tutorFormativo: element.CognomeTutorFormativo + " " + element.NomeTutorFormativo,
                                idCPIstat: 0,
                                descrizioneCPIstat: "",
                                idConvenzione: element.IdConvenzione,
                                numeroProtocollazione: element.NumeroProtocollo,
                                dataProtocollazione: dataProtocollo.getDate() + "/" + (dataProtocollo.getMonth() + 1) + "/" + dataProtocollo.getFullYear(),
                                idIscrizioneAttivita: element.IdIscrizioneAttivita,
                                idIscrizioneAllievo: 0,
                                reportVisite: element.ReportVisite,
                                utilizzata: element.Utilizzata,
                                idStatoUtente: element.IdStato,
                                diplomato: false,
                                dataDiploma: '',
                                urlCV: "",
                                tutorArticolazione: "",
                                idTirocinante: element.IdAllievo,
                                note: element.Note,
                                usoUfficio: element.UsoUfficio,
                                usoProduzione: element.UsoProduzione,
                                usoCantiere: element.UsoCantiere,
                                usoAltro: element.UsoAltro,
                                sorveglianzaSanitaria: element.SorveglianzaSanitaria,
                                formazione: element.Formazione,
                                colloquio: element.Colloquio,
                                formazioneTutorSicurezza: element.FormazioneTutorSicurezza,
                                tutorFormato: element.TutorFormato,
                                dvr: element.Dvr,
                                dpi: element.Dpi,
                                consensoSopralluogo: element.ConsensoSopralluogo,
                                idIspezione: element.IdIspezione,
                                dataIspezione: element.DataIspezione,
                                idStatoAccettazioneIspezione: element.IdStatoAccettazioneIspezione,
                                codRappresentate: element.CFRappresentante,
                                confCommercio: element.ConfCommercio,
                                altraAssociazione: element.HasAltraAssociazione,
                                emailTutorFormativo: element.EmailTutorFormativo,
                                telefonoTutorFormativo: element.TelefonoTutorFormativo
                            }
                            studentsList.push(student)
                        })
                        resolve(studentsList)
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        getReportVisite(context: DataContext, payload: { idRichiesta: number, attivita: string }) {
            var report: ReportVisiteInfo;
            var reportList: ReportVisiteInfo[] = []
            var dataInizio: any = ""
            var dataFine: any = ""
            var dataReport: any = ""
            var oraReport: any = ""
            var dataVisita: any = null
            return new Promise<ReportVisiteInfo[]>((resolve, reject) => {
                dataService.getReportVisite(payload.idRichiesta, payload.attivita)
                    .then(result => {
                        result.forEach((element: any) => {
                            // if (element.DataInizio !== null) {
                            //     dataInizio = new Date(element.DataInizio)
                            //     dataInizio = dataInizio.getDate() + "/" + (dataInizio.getMonth() + 1) + "/" + dataInizio.getFullYear()
                            // }
                            // if (element.DataFine !== null) {
                            //     dataFine = new Date(element.DataFine)
                            //     dataFine = dataFine.getDate() + "/" + (dataFine.getMonth() + 1) + "/" + dataFine.getFullYear()
                            // }
                            if (element.DataReport) {
                                dataReport = new Date(element.DataReport)
                                dataReport = dataReport.getDate() + "/" + (dataReport.getMonth() + 1) + "/" + dataReport.getFullYear()
                            }
                            if (element.DataReport !== null) {
                                let data: any
                                data = new Date(element.DataReport)
                                oraReport = data.toLocaleTimeString('it-IT')
                            }
                            if (element.DataVisita !== null) {
                                dataVisita = new Date(element.DataVisita)
                                dataVisita = dataVisita.getDate() + "/" + (dataVisita.getMonth() + 1) + "/" + dataVisita.getFullYear()
                            }
                            report = {
                                idReport: element.IdReport,
                                idRichiesta: element.IdRichiesta,
                                denominazioneAzienda: element.DenominazioneAzienda,
                                tirocinante: element.Tirocinante,
                                tutorAziendale: element.TutorAziendale,
                                tutorFormativo: element.TutorFormativo,
                                // dataInizio: dataInizio,
                                dataInizio: element.DataInizio,
                                // dataFine: dataFine,
                                dataFine: element.DataFine,
                                orarioInizioMattina: element.OrarioInizioMattino,
                                orarioFineMattina: element.OrarioFineMattino,
                                orarioInizioPomeriggio: element.OrarioInizioPomeriggio,
                                orarioFinePomeriggio: element.OrarioFinePomeriggio,
                                attivitaTirocinio: element.AttivitaTirocinio,
                                attivitaSvoltaTirocinante: element.AttivitaSvoltaTirocinante,
                                presenzaStagista: element.PresenzaStagista,
                                colloquioStagista: element.ColloquioStagista,
                                note: element.Note,
                                attivitaCoerente: element.AttivitaCoerente,
                                motivazioneNonCoerenza: element.MotivazioneNonCoerenza,
                                firmaTutorFormativo: element.FirmaTutorFormativo,
                                firmaTutorAziendale: element.FirmaTutorAziendale,
                                dataVisita: dataVisita,
                                oraVisita: element.OraVisita,
                                dataReport: dataReport,
                                oraReport: oraReport,
                                personaleContattato: element.PersonaleContattato,
                                tipoVisita: element.TipoVisita,
                                attivita: element.DescrizioneAttivita,
                                idStatoAccettazione: element.IdStatoAccettazione
                                // startDate: element.DataInizio,
                                // finishDate: element.DataFine
                            }
                            reportList.push(report)
                        });
                        resolve(reportList)
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        getReportVisiteAdmin(context: DataContext, payload: { idIstituto: number, idAnnoScolastico: number }) {
            var report: ReportVisiteInfo;
            var reportList: ReportVisiteInfo[] = []
            var dataInizio: any = ""
            var dataFine: any = ""
            var dataReport: any = ""
            var oraReport: any = ""
            var dataVisita: any = null
            var attivitaString: string = ""
            return new Promise<ReportVisiteInfo[]>((resolve, reject) => {
                dataService.getReportVisiteAdmin(payload.idIstituto, payload.idAnnoScolastico)
                    .then(result => {
                        result.forEach((element: any) => {
                            // if (element.DataInizio !== null) {
                            //     dataInizio = new Date(element.DataInizio)
                            //     dataInizio = dataInizio.getDate() + "/" + (dataInizio.getMonth() + 1) + "/" + dataInizio.getFullYear()
                            // }
                            // if (element.DataFine !== null) {
                            //     dataFine = new Date(element.DataFine)
                            //     dataFine = dataFine.getDate() + "/" + (dataFine.getMonth() + 1) + "/" + dataFine.getFullYear()
                            // }
                            if (element.DataReport) {
                                dataReport = new Date(element.DataReport)
                                dataReport = dataReport.getDate() + "/" + (dataReport.getMonth() + 1) + "/" + dataReport.getFullYear()
                            }
                            if (element.DataReport !== null) {
                                let data: any
                                data = new Date(element.DataReport)
                                oraReport = data.toLocaleTimeString('it-IT')
                            }
                            if (element.DataVisita !== null) {
                                dataVisita = new Date(element.DataVisita)
                                dataVisita = dataVisita.getDate() + "/" + (dataVisita.getMonth() + 1) + "/" + dataVisita.getFullYear()
                            }
                            // switch(element.IdTipoAttivita){
                            //     case 1:
                            //         attivitaString = "Tirocini Estivi"
                            //         break;
                            //     case 4:
                            //         attivitaString = "Tirocini Formativi"
                            //         break;
                            // }
                            report = {
                                idReport: element.IdReport,
                                idRichiesta: element.IdRichiesta,
                                denominazioneAzienda: element.DenominazioneAzienda,
                                tirocinante: element.Tirocinante,
                                tutorAziendale: element.TutorAziendale,
                                tutorFormativo: element.TutorFormativo,
                                // dataInizio: dataInizio,
                                dataInizio: element.DataInizio,
                                // dataFine: dataFine,
                                dataFine: element.DataFine,
                                orarioInizioMattina: element.OrarioInizioMattino,
                                orarioFineMattina: element.OrarioFineMattino,
                                orarioInizioPomeriggio: element.OrarioInizioPomeriggio,
                                orarioFinePomeriggio: element.OrarioFinePomeriggio,
                                attivitaTirocinio: element.AttivitaTirocinio,
                                attivitaSvoltaTirocinante: element.AttivitaSvoltaTirocinante,
                                presenzaStagista: element.PresenzaStagista,
                                colloquioStagista: element.ColloquioStagista,
                                note: element.Note,
                                attivitaCoerente: element.AttivitaCoerente,
                                motivazioneNonCoerenza: element.MotivazioneNonCoerenza,
                                firmaTutorFormativo: element.FirmaTutorFormativo,
                                firmaTutorAziendale: element.FirmaTutorAziendale,
                                dataVisita: dataVisita,
                                oraVisita: element.OraVisita,
                                dataReport: dataReport,
                                oraReport: oraReport,
                                personaleContattato: element.PersonaleContattato,
                                tipoVisita: element.TipoVisita,
                                attivita: element.DescrizioneAttivita,
                                idStatoAccettazione: element.IdStatoAccettazione
                                // startDate: element.DataInizio,
                                // finishDate: element.DataFine
                            }
                            reportList.push(report)
                        });
                        resolve(reportList)
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        getConsensoAttivita(context: DataContext, payload: { idRichiesta: number, activityType: string }) {
            var consenso: DocConsenso;
            return new Promise<DocConsenso>((resolve, reject) => {
                dataService.getConsensoAttivita(payload.idRichiesta, payload.activityType)
                    .then(result => {
                        var dataDoc: any
                        dataDoc = new Date(result.DataDocumento)
                        consenso = {
                            idConsenso: result.Id,
                            rappresentanteAzienda: result.RappresentanteAzienda,
                            denominazioneAzienda: result.DenominazioneAzienda,
                            pIvaAzienda: result.PIvaAzienda,
                            comuneAzienda: result.ComuneAzienda,
                            indirizzoAzienda: result.IndirizzoAzienda,
                            tirocinante: result.Tirocinante,
                            indirizzoTirocinante: result.IndirizzoTirocinante,
                            comuneTirocinante: result.ComuneTirocinante,
                            dataDocumento: dataDoc.getDate() + "/" + (dataDoc.getMonth() + 1) + "/" + dataDoc.getFullYear(),
                            idStatoDoc: result.IdStatoDocumento,
                            firmaAzienda: result.FirmaAzienda,
                            firmaTirocinante: result.FirmaTirocinante,
                            firmaIstituto: result.FirmaIstituto,
                            tipoAttivita: payload.activityType,
                            numeroProtocollo: result.NumeroProtocollo,
                            idTemplate: result.IdTemplateDocumento
                        }
                        resolve(consenso)
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        getCurriculumVitae(context: DataContext, payload: { idPdf: number }) {
            return new Promise<string>((resolve, reject) => {
                dataService.getCurriculumVitae(payload.idPdf)
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        getCurriculumAnni(context: DataContext, payload: { idIstituto: number }) {
            return new Promise<any[]>((resolve, reject) => {
                dataService.getCurriculumAnni(payload.idIstituto)
                    .then(resp => {
                        resolve(resp)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        getCurriculumArticolazioni(context: DataContext, payload: { idIstituto: number, idAnnoScolastico: number }) {
            return new Promise<any[]>((resolve, reject) => {
                dataService.getCurriculumArticolazioni(payload.idIstituto, payload.idAnnoScolastico)
                    .then(resp => {
                        resolve(resp)
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        getCurriculumClassi(context: DataContext, payload: { idIstituto: number, idAnnoScolastico: number, idArticolazione: string }) {
            return new Promise<any[]>((resolve, reject) => {
                dataService.getCurriculumClassi(payload.idIstituto, payload.idAnnoScolastico, payload.idArticolazione)
                    .then(resp => {
                        resolve(resp)
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        getCurriculumAllievi(context: DataContext, payload: { idIstituto: number, idAnnoScolastico: number, idArticolazione: string, classe: string }) {
            return new Promise<any[]>((resolve, reject) => {
                dataService.getCurriculumAllievi(payload.idIstituto, payload.idAnnoScolastico, payload.idArticolazione, payload.classe)
                    .then(resp => {
                        resolve(resp)
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        getRichiesteTirFormativiAllievo(context: DataContext, payload: { idAllievo: number, idAnnoScolastico: number }) {
            var richiesta: number;
            var richiesteList: number[] = []
            return new Promise<number[]>((resolve, reject) => {
                dataService.getRichiesteTirFormativiAllievo(payload.idAllievo, payload.idAnnoScolastico)
                    .then(result => {
                        result.forEach((element: any) => {
                            richiesta = element
                            richiesteList.push(richiesta)
                        });
                        resolve(richiesteList)
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        getDetailsAbbinamentoAllievoAzienda(context: DataContext, payload: { idRichiesta: number, attivita: string }) {
            return new Promise<any>((resolve, reject) => {
                dataService.getDetailsAbbinamentoAllievoAzienda(payload.idRichiesta, payload.attivita)
                    .then(result => {
                        resolve(result)
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        getDetailsAbbinamentoTutorAllievo(context: DataContext, payload: { idAllievo: number, idAnnoScolastico: number, idIstituto: number }) {
            return new Promise<any>((resolve, reject) => {
                dataService.getDetailsAbbinamentoTutorAllievo(payload.idAllievo, payload.idAnnoScolastico, payload.idIstituto)
                    .then(result => {
                        resolve(result)
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        getAssociazioniTutorAziendaleTirFormativo(context: DataContext, payload: { idTutor: number, idAzienda: number, idAnnoScolastico: number }) {
            var studentsList: StudentAssignmentTirFormativoInfo[] = []
            var student: StudentAssignmentTirFormativoInfo
            var usoFuori: string;
            var dataInizio: any
            var dataFine: any
            var dataInizioSospUno: any = ""
            var dataFineSospUno: any = ""
            var dataInizioSospDue: any = ""
            var dataFineSospDue: any = ""
            return new Promise<StudentAssignmentTirFormativoInfo[]>((resolve, reject) => {
                dataService.getAssociazioniTutorAziendaleTirFormativo(payload.idTutor, payload.idAzienda, payload.idAnnoScolastico)
                    .then(response => {
                        response.forEach((element: any) => {
                            dataInizioSospUno = ""
                            dataFineSospUno = ""
                            dataInizioSospDue = ""
                            dataFineSospDue = ""
                            if (element.UsoFuoriSede === false) {
                                usoFuori = "No"
                            } else {
                                usoFuori = "Si"
                            }
                            dataInizio = new Date(element.DataInizioPeriodo)
                            dataFine = new Date(element.DataFinePeriodo)
                            if (element.DataInizioSospensioneUno !== null && element.DataFineSospensioneUno !== null) {
                                dataInizioSospUno = new Date(element.DataInizioSospensioneUno)
                                dataFineSospUno = new Date(element.DataFineSospensioneUno)
                                dataInizioSospUno = dataInizioSospUno.getDate() + "/" + (dataInizioSospUno.getMonth() + 1) + "/" + dataInizioSospUno.getFullYear()
                                dataFineSospUno = dataFineSospUno.getDate() + "/" + (dataFineSospUno.getMonth() + 1) + "/" + dataFineSospUno.getFullYear()
                            }
                            if (element.DataInizioSospensioneDue !== null && element.DataFineSospensioneDue !== null) {
                                dataInizioSospDue = new Date(element.DataInizioSospensioneDue)
                                dataFineSospDue = new Date(element.DataFineSospensioneDue)
                                dataInizioSospDue = dataFineSospUno.getDate() + "/" + (dataFineSospUno.getMonth() + 1) + "/" + dataFineSospUno.getFullYear()
                                dataFineSospDue = dataFineSospDue.getDate() + "/" + (dataFineSospDue.getMonth() + 1) + "/" + dataFineSospDue.getFullYear()
                            }
                            student = {
                                tipoSoggetto: element.IdTipoSoggetto,
                                ruoloUtente: [4],
                                descrizioneRuolo: ['Allievo'],
                                nomeUtente: element.Nome,
                                cognomeUtente: element.Cognome,
                                indirizzoUtente: element.IndirizzoAllievo,
                                telefono1Utente: element.Telefono1Allievo,
                                telefono2Utente: element.Telefono2Allievo,
                                cod: element.CodAllievo,
                                dataNascita: element.DataNascita,
                                luogoNascita: element.LuogoNascita,
                                emailUtente: element.Email,
                                pecUtente: element.EmailPec,
                                comuneUtente: element.LocalitaAllievo,
                                provinciaUtente: element.IdProvinciaAllievo,
                                entità: "element.Denominazione",
                                codEntità: element.IdIstituto,
                                idCap: element.IdCap,
                                idUtente: element.Id,
                                cap: element.CapAllievo,
                                username: element.Utente,
                                matricola: element.Matricola,
                                classe: element.AnnoCorso + ' ' + element.Sezione,
                                idClasse: element.IdClasse,
                                idNazioneNascita: element.IdNazione,
                                idArticolazione: element.IdArticolazione,
                                allievo: element.Cognome + " " + element.Nome,
                                gestioneAlternanza: element.GestioneAlternanza,
                                idDocAutorizzazione: element.IdDocAutorizzazione,
                                idStatoDoc: element.IdStatoDoc,
                                idIstitutoAnnoScolastico: element.IdIstitutoAnnoScolastico,
                                idAzienda: element.IdAzienda,
                                azienda: "",
                                idInfoRichiestaTirFormativo: element.IdRichiestaTirocinioFormativo,
                                idTutorAzienda: element.IdTutorAzienda,
                                tutorAzienda: element.CognomeTutorAzienda + " " + element.NomeTutorAzienda,
                                telefonoTutor: element.TelefonoTutorAziendale,
                                emailTutor: element.EmailTutorAziendale,
                                dataInizioPeriodo: dataInizio.getDate() + "/" + (dataInizio.getMonth() + 1) + "/" + dataInizio.getFullYear(),
                                dataFinePeriodo: dataFine.getDate() + "/" + (dataFine.getMonth() + 1) + "/" + dataFine.getFullYear(),
                                orarioInizioMattino: element.OrarioInizioMattino,
                                orarioFineMattino: element.OrarioFineMattino,
                                orarioInizioPomeriggio: element.OrarioInizioPomeriggio,
                                orarioFinePomeriggio: element.OrarioFinePomeriggio,
                                mansioni: "",
                                idStatoAccettazione: element.IdStatoAccettazione,

                                // idAzienda: element.IdAzienda,
                                denominazioneAzienda: element.NomeAzienda,
                                titolo: element.Titolo,
                                cognomeRappresentanteAzienda: element.CognomeRappresentante,
                                nomeRappresentanteAzienda: element.NomeRappresentante,
                                dataNascitaRappresentante: element.DataNascitaRappresentante,
                                statoNascitaRappresentante: element.PaeseNascitaRappresentante,
                                luogoNascitaRappresentante: element.LuogoNascitaRappresentante,
                                comuneAzienda: element.LocalitaAzienda,
                                idCapComuneAzienda: element.IdCap,
                                provinciaAzienda: element.IdProvinciaAzienda,
                                indirizzoAzienda: element.IndirizzoAzienda,
                                telefono1Azienda: element.Telefono1Azienda,
                                telefono2Azienda: element.Telefono2Azienda,
                                faxAzienda: element.Fax,
                                emailAzienda: element.EMail,
                                pecAzienda: element.EMailPec,
                                sitoAzienda: element.SitoWeb,
                                attivitàAzienda: element.AttivitàSvolta,
                                dipendentiAzienda: element.NumeroDipendenti,
                                committenzaAzienda: element.Committenza,
                                associata: element.Associata,
                                artigiana: element.AziendaArtigiana,
                                pIva: element.PIva,
                                codAzienda: element.CodAzienda,
                                idAteco: element.IdAteco,
                                // idIstat: element.IdIstat,
                                descrizioneAteco: element.CodAteco + "-" + element.DescrizioneAteco,
                                descrizioneIstat: element.CodIstat + "-" + element.DescrizioneIstat,
                                // capAzienda: element.CapAzienda,
                                idNazioneAzienda: element.IdNazioneAzienda,
                                nazioneAzienda: element.NazioneAzienda,

                                lavoratoriSede: element.LavoratoriSede,
                                tirociniSede: element.TirociniSede,
                                tirociniDisabiliSede: element.TirociniDisabiliSede,
                                consulente: element.Consulente,
                                provinciaTirocinio: element.ProvinciaTirocinio,
                                comuneTirocinio: element.ComuneTirocinio,
                                capTirocinio: element.CapTirocinio,
                                indirizzoTirocinio: element.IndirizzoTirocinio,
                                denominazioneConsulente: element.DenominazioneConsulente,
                                referenteConsulente: element.ReferenteConsulente,
                                telefonoConsulente: element.TelefonoConsulente,
                                emailConsulente: element.EmailConsulente,
                                attivitàTirocinio: element.AttivitaTirocinio,
                                indirizzoStudio: element.IndirizzoStudio,
                                cognomeTirocinante: "",
                                nomeTirocinante: "",
                                classeTirocinante: "",
                                usoFuoriSede: usoFuori,
                                ruolo: element.Ruolo,
                                idAziendaIstitutoAnno: element.idAziendaIstitutoAnno,
                                nomeIndirizzoStudio: element.NomeIndirizzoStudio,
                                nomeSettore: element.NomeSettore,
                                idRichiesta: element.IdRichiestaTirocinioFormativo,
                                gestioneTirocinioEstivo: element.GestioneTirocinioEstivo,
                                gestioneTirocinioFormativo: element.GestioneTirocinioFormativo,
                                tutorFormativo: element.CognomeTutorFormativo + " " + element.NomeTutorFormativo,
                                idCPIstat: 0,
                                descrizioneCPIstat: "",
                                idConvenzione: element.IdConvenzione,
                                idProgettoOrientamento: element.IdProgettoOrientamento,

                                responsabilitaCivile: element.ResponsabilitaCivile,
                                assicurazioneAzienda: element.AssicurazioneAzienda,
                                indennitaMensile: element.IndennitaMensile,
                                dataInizioSospensioneUno: dataInizioSospUno,
                                dataFineSospensioneUno: dataFineSospUno,
                                motivazioneSospensioneUno: element.MotivazioneSospensioneUno,
                                dataInizioSospensioneDue: dataInizioSospDue,
                                dataFineSospensioneDue: dataFineSospDue,
                                motivazioneSospensioneDue: element.MotivazioneSospensioneDue,
                                idIscrizioneAllievo: 0,
                                idIscrizioneAttivita: element.IdIscrizioneAttivita,
                                reportVisite: element.ReportVisite,
                                idStatoUtente: element.IdStato,
                                diplomato: false,
                                dataDiploma: '',
                                urlCV: "",
                                apprendistatoCheck: element.Appredistato,
                                tutorArticolazione: "",
                                codRappresentate: element.CFRappresentante,
                                confCommercio: element.ConfCommercio,
                                altraAssociazione: element.HasAltraAssociazione
                            }
                            studentsList.push(student)
                        })
                        resolve(studentsList)
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        getAttestatoFinaleInfo(context: DataContext, payload: { idRichiesta: number, activityType: string }) {
            var attestatoFinale: DocAttestatoFinale;
            var dataAttestato: any = "";
            var dataInizioPeriodo: any = "";
            var dataFinePeriodo: any = "";
            var dataProtocollo: any = "";
            return new Promise<DocAttestatoFinale>((resolve, reject) => {
                dataService.getAttestatoFinaleInfo(payload.idRichiesta, payload.activityType)
                    .then(result => {
                        dataAttestato = new Date(result.DataAttestato)
                        dataInizioPeriodo = new Date(result.DataInizioPeriodo)
                        dataFinePeriodo = new Date(result.DataFinePeriodo)
                        dataProtocollo = new Date(result.DataProtocollo)
                        attestatoFinale = {
                            idAttestatoFinale: result.Id,
                            dataAttestato: dataAttestato.getDate() + "/" + (dataAttestato.getMonth() + 1) + "/" + dataAttestato.getFullYear(),
                            luogoAttestato: result.LuogoAttestato,
                            dataInizioPeriodo: dataInizioPeriodo.getDate() + "/" + (dataInizioPeriodo.getMonth() + 1) + "/" + dataInizioPeriodo.getFullYear(),
                            dataFinePeriodo: dataFinePeriodo.getDate() + "/" + (dataFinePeriodo.getMonth() + 1) + "/" + dataFinePeriodo.getFullYear(),
                            totaleOre: result.TotaleOre,
                            denominazioneAzienda: result.DenominazioneAzienda,
                            allievo: result.Allievo,
                            classeAllievo: result.ClasseAllievo,
                            noteAggiuntive: result.NoteAggiuntive,
                            gruppoUno: result.GruppoUno,
                            gruppoDue: result.GruppoDue,
                            gruppoTre: result.GruppoTre,
                            gruppoQuattro: result.GruppoQuattro,
                            gruppoCinque: result.GruppoCinque,
                            gruppoSei: result.GruppoSei,
                            gruppoSette: result.GruppoSette,
                            gruppoOtto: result.GruppoOtto,
                            gruppoNove: result.GruppoNove,
                            gruppoDieci: result.GruppoDieci,
                            firmaTutorAzienda: result.FirmaTutorAzienda,
                            tipoAttivita: result.IdTipoAttivita,
                            idRichiesta: result.IdRichiesta,
                            numeroProtocollo: result.NumeroProtocollo,
                            dataProtocollo: dataProtocollo.getDate() + "/" + (dataProtocollo.getMonth() + 1) + "/" + dataProtocollo.getFullYear(),
                            idTutorAzienda: result.IdTutorAzienda,
                            tutorAzienda: result.TutorAzienda,
                            tutorFormativo: result.TutorFormativo
                        }
                        resolve(attestatoFinale)
                    }).catch(error => {
                        reject(error)
                    })
            })
        },

        getDomandeQuestionario(context: DataContext, payload: { idRichiesta: number, activityType: string, tipoQuestionario: string }) {
            var domande: DomandeQuestionario[] = []
            var domanda: DomandeQuestionario;
            return new Promise<DomandeQuestionario[]>((resolve, reject) => {
                dataService.getDomandeQuestionario(payload.idRichiesta, payload.activityType, payload.tipoQuestionario).then(result => {
                    result.forEach((element: any) => {
                        domanda = {
                            idDomanda: element.IdDomanda,
                            idGruppoDomanda: element.IdGruppoDomanda,
                            idTipoDomanda: element.IdTipoDomanda,
                            rangeRisposta: element.RangeRisposta,
                            descrizioneGruppoDomanda: element.DescrizioneGruppoDomanda,
                            descrizioneDomanda: element.Domanda,
                            opzione1: element.Opzione1,
                            opzione2: element.Opzione2,
                            opzione3: element.Opzione3,
                            opzione4: element.Opzione4,
                            opzione5: element.Opzione5,
                            opzione6: element.Opzione6,
                            opzione7: element.Opzione7,
                            opzione8: element.Opzione8,
                            opzione9: element.Opzione9,
                            opzione10: element.Opzione10,
                            opzione11: element.Opzione11,
                            opzione12: element.Opzione12,
                            opzione13: element.Opzione13,
                            testoNota: element.TestoNota,
                            notaObbligatoria: element.NotaObbligatoria,
                            rispostaMultipla: element.RispostaMultipla
                        }
                        domande.push(domanda)
                    });
                    resolve(domande)
                }).catch(error => {
                    reject(error)
                })
            })
        },
        getRisposteQuestionario(context: DataContext, payload: { idRichiesta: number, activityType: string, tipoQuestionario: string }) {
            var risposta: RispostaQuestionario;
            var listaRisposte: RispostaQuestionario[] = [];
            var dataInizioPeriodo: any = "";
            var dataFinePeriodo: any = "";
            var notaRisp: string = ""
            return new Promise<RispostaQuestionario[]>((resolve, reject) => {
                dataService.getRisposteQuestionario(payload.idRichiesta, payload.activityType, payload.tipoQuestionario).then(result => {
                    result.forEach((element: any) => {
                        if (element.NoteRisposta !== null) {
                            notaRisp = element.NoteRisposta
                        } else {
                            notaRisp = ""
                        }
                        dataInizioPeriodo = new Date(element.DataInizioAttivita)
                        dataFinePeriodo = new Date(element.DataFineAttivita)
                        risposta = {
                            risposta: element.Risposta,
                            idDomanda: element.IdDomanda,
                            idGruppoDomanda: element.IdGruppoDomanda,
                            idTipoDomanda: element.IdTipoDomanda,
                            rangeRisposta: element.RangeRisposta,
                            descrizioneGruppoDomanda: element.DescrizioneGruppoDomanda,
                            descrizioneDomanda: element.Domanda,
                            opzione1: element.Opzione1,
                            opzione2: element.Opzione2,
                            opzione3: element.Opzione3,
                            opzione4: element.Opzione4,
                            opzione5: element.Opzione5,
                            opzione6: element.Opzione6,
                            opzione7: element.Opzione7,
                            opzione8: element.Opzione8,
                            opzione9: element.Opzione9,
                            opzione10: element.Opzione10,
                            opzione11: element.Opzione11,
                            opzione12: element.Opzione12,
                            opzione13: element.Opzione13,
                            testoNota: element.TestoNota,
                            notaObbligatoria: element.NotaObbligatoria,
                            rispostaMultipla: element.RispostaMultipla,
                            azienda: element.DenominazioneAzienda,
                            tirocinante: element.Tirocinante,
                            comuneTirocinio: element.LuogoTirocinio,
                            dataInizio: dataInizioPeriodo.getDate() + "/" + (dataInizioPeriodo.getMonth() + 1) + "/" + dataInizioPeriodo.getFullYear(),
                            dataFine: dataFinePeriodo.getDate() + "/" + (dataFinePeriodo.getMonth() + 1) + "/" + dataFinePeriodo.getFullYear(),
                            attivitaTirocinio: element.AttivitaSvolta,
                            classeTirocinante: element.ClasseTirocinante,
                            idTipoQuestionario: element.IdTipoQuestionario,
                            noteQuestionario: element.NoteQuestionario,
                            noteRisposta: notaRisp
                        }
                        listaRisposte.push(risposta)
                    })
                    resolve(listaRisposte)
                }).catch(error => {
                    reject(error)
                })
            })
        },

        checkStatusQuestionario(context: DataContext, payload: { idRichiesta: number, activityType: string, tipoQuestionario: string }) {
            return new Promise<number>((resolve, reject) => {
                dataService.checkQuestionario(payload.idRichiesta, payload.activityType, payload.tipoQuestionario).then(result => {
                    resolve(result.Id)
                }).catch(error => {
                    reject(error)
                })
            })
        },

        getListaAttivitaIstituto(context: DataContext, payload: { idIstituto: number, idAnnoScolastico: number }) {
            var attivita: AttivitaIstituto;
            var listaAttivita: AttivitaIstituto[] = [];
            var dataInizioPeriodo: any = "";
            var dataFinePeriodo: any = "";
            var dataProtocollazione: any = "";
            return new Promise<AttivitaIstituto[]>((resolve, reject) => {
                dataService.getListaAttivitaIstituto(payload.idIstituto, payload.idAnnoScolastico).then(result => {
                    result.forEach((element: any) => {
                        dataInizioPeriodo = new Date(element.DataInizio)
                        dataFinePeriodo = new Date(element.DataFine)
                        dataProtocollazione = new Date(element.DataProtocollazione)
                        attivita = {
                            idAttivita: element.Id,
                            idTipoAttivita: element.IdTipoAttivita,
                            // dataInizioAttivita:element.DataInizio,
                            // dataFineAttivita:element.DataFine,
                            dataInizioAttivita: dataInizioPeriodo.getDate() + "/" + (dataInizioPeriodo.getMonth() + 1) + "/" + dataInizioPeriodo.getFullYear(),
                            dataFineAttivita: dataFinePeriodo.getDate() + "/" + (dataFinePeriodo.getMonth() + 1) + "/" + dataFinePeriodo.getFullYear(),
                            nomeAttivita: element.NomeAttivita,
                            nomeAssicurazione: element.NomeAssicurazione,
                            numeroAssicurazione: element.NumeroPolizzaAssicurativa,
                            descrizioneTipoAttivita: element.DescrizioneAttivita,
                            statoIscrizione: element.StatoIscrizione,
                            idIstituto: 0,
                            idAnnoScolastico: 0,
                            numeroProtocollazione: element.NumeroProtocollazione,
                            dataProtocollazione: dataProtocollazione.getDate() + "/" + (dataProtocollazione.getMonth() + 1) + "/" + dataProtocollazione.getFullYear(),
                            statoPubblicazione: element.StatoPubblicazione
                        }
                        listaAttivita.push(attivita)
                    });
                    resolve(listaAttivita)
                }).catch(error => {
                    reject(error)
                })
            })
        },

        getListaTipiAttivita() {
            var tipoAttivita: any;
            var listaTipiAttivita: any[] = []
            return new Promise<any[]>((resolve, reject) => {
                dataService.getListaTipiAttivita().then(result => {
                    result.forEach((element: any) => {
                        tipoAttivita = {
                            idTipoAttivita: element.Id,
                            descrizioneTipoAttivita: element.DescrizioneAttivita
                        }
                        listaTipiAttivita.push(tipoAttivita)
                    });
                    resolve(listaTipiAttivita)
                }).catch(error => {
                    reject(error)
                })
            })
        },

        getPercorsoFormativo(context: DataContext, payload: { idRichiesta: number, activityType: string }) {
            var percorsoFormativo: DocPercorsoFormativo;
            var usoFuori: string;
            var dataInizio: any
            var dataFine: any
            var dataDoc: any
            return new Promise<DocPercorsoFormativo>((resolve, reject) => {
                dataService.getPercorsoFormativo(payload.idRichiesta, payload.activityType).then(result => {
                    if (result.UsoFuoriSede === false) {
                        usoFuori = "No"
                    } else {
                        usoFuori = "Si"
                    }
                    dataInizio = new Date(result.DataInizioPeriodo)
                    dataFine = new Date(result.DataFinePeriodo)
                    dataDoc = new Date(result.DataDocumento)

                    percorsoFormativo = {
                        idPercorsoFormativo: result.Id,
                        idRichiesta: result.IdRichiesta,
                        denominazioneIstituto: result.DenominazioneIstituto,
                        denominazioneAzienda: result.DenominazioneAzienda,
                        comuneIstituto: result.ComuneIstituto,
                        tutorFormativo: result.TutorFormativo,
                        emailTutorFormativo: result.EmailTutorFormativo,
                        tutorAziendale: result.TutorAziendale,
                        emailTutorAziendale: result.EmailTutorAziendale,
                        indirizzoTirocinio: result.IndirizzoTirocinio,
                        capTirocinio: result.CapTirocinio,
                        comuneTirocinio: result.ComuneTirocinio,
                        provinciaTirocinio: result.ProvinciaTirocinio,
                        tirocinante: result.Tirocinante,
                        dataNascitaTirocinante: result.DataNascitaTirocinante,
                        luogoNascitaTirocinante: result.LuogoNascitaTirocinante,
                        indirizzoTirocinante: result.IndirizzoTirocinante,
                        comuneTirocinante: result.ComuneTirocinante,
                        provinciaTirocinante: result.ProvinciaTirocinante,
                        telefonoTirocinante: result.TelefonoTirocinante,
                        emailTirocinante: result.EmailTirocinante,
                        codiceFiscaleTirocinante: result.CodiceFiscaleTirocinante,
                        classeTirocinante: result.ClasseTirocinante,
                        durataTirocinio: result.DurataTirocinio,
                        dataInizioPeriodo: dataInizio.getDate() + "/" + (dataInizio.getMonth() + 1) + "/" + dataInizio.getFullYear(),
                        dataFinePeriodo: dataFine.getDate() + "/" + (dataFine.getMonth() + 1) + "/" + dataFine.getFullYear(),
                        orarioInizioMattino: result.OrarioInizioMattino,
                        orarioFineMattino: result.OrarioFineMattino,
                        orarioInizioPomeriggio: result.OrarioInizioPomeriggio,
                        orarioFinePomeriggio: result.OrarioFinePomeriggio,
                        usoFuoriSede: usoFuori,
                        attivitaTirocinio: result.AttivitaTirocinio,
                        posizioneInail: result.PosizioneINAIL,
                        numeroPolizzaAssicurativa: result.NumeroPolizzaAssicurativa,
                        assicurazione: result.Assicurazione,
                        dataDocumento: dataDoc.getDate() + "/" + (dataDoc.getMonth() + 1) + "/" + dataDoc.getFullYear(),
                        idStatoDocumento: result.IdStatoDocumento,
                        firmaTutorIstituto: result.FirmaTutorIstituto,
                        firmaAzienda: result.FirmaAzienda,
                        firmaTirocinante: result.FirmaTirocinante,
                        firmaTutore: result.FirmaEsercentePatriaPotesta,
                        idTipoAttivita: result.IdTipoAttivita,
                        numeroProtocollo: result.NumeroProtocollo,
                        idTemplate: result.IdTemplateDocumento,
                        tutore: result.CognomeTutore + ' ' + result.NomeTutore,
                        rappresentanteAzienda: result.RappresentanteAzienda,
                        pivaAzienda: result.PIvaAzienda,
                        comuneAzienda: result.ComuneAzienda,
                        provinciaAzienda: result.ProvinciaAzienda,
                        indirizzoAzienda: result.IndirizzoAzienda,
                        firmaIstituto: result.FirmaIstituto,
                        firmaAziendaDue: result.FirmaAziendaDue,
                        idStatoFirmaAzienda: result.IdStatoFirmaAzienda,
                        idStatoFirmaTutorIstituto: result.IdStatoFirmaTutorIstituto,
                        idStatoFirmaTirocinante: result.IdStatoFirmaTirocinante,
                        idStatoFirmaTutorArticolazione: result.IdStatoFirmaTutorArticolazione,
                        firmaTutorArticolazione: result.FirmaTutorArticolazione
                    }
                    resolve(percorsoFormativo)
                }).catch(error => {
                    reject(error)
                })
            })
        },

        getPercorsoFormativoDigitale(context: DataContext, payload: { idRichiesta: number, activityType: string }) {
            var percorsoFormativo: any;
            return new Promise<any>((resolve, reject) => {
                dataService.getPercorsoFormativoDigitale(payload.idRichiesta, payload.activityType)
                    .then(result => {
                        result.forEach((element: any) => {
                            percorsoFormativo = {
                                id: element.Id,
                                dataCreazione: element.DataCreazione,
                                firma: element.Firma,
                                idLinkDocumento: element.IdLinkDocumento,
                                idRichiesta: element.IdRichiesta,
                                idTipoDocumento: element.IdTipoDocumento,
                                idTipoSoggetto: element.IdTipoSoggetto,
                                idTipologiaAttivita: element.IdTipologiaAttivita,
                                idStatoDocumento: element.IdStatoDocumento
                            }
                        });
                        resolve(percorsoFormativo)
                    }).catch(error => {
                        reject(error)
                    })
            })
        },

        getPattoFormativo(context: DataContext, payload: { idRichiesta: number, activityType: string }) {
            var pattoFormativo: DocPattoFormativo;
            var dataInizio: any
            var dataFine: any
            var dataDoc: any
            return new Promise<DocPattoFormativo>((resolve, reject) => {
                dataService.getPattoFormativo(payload.idRichiesta, payload.activityType).then(result => {
                    dataInizio = new Date(result.DataInizioPeriodo)
                    dataFine = new Date(result.DataFinePeriodo)
                    dataDoc = new Date(result.DataDocumento)

                    pattoFormativo = {
                        idPattoFormativo: result.Id,
                        idRichiesta: result.IdRichiesta,
                        denominazioneIstituto: result.DenominazioneIstituto,
                        cognomeAllievo: result.CognomeAllievo,
                        nomeAllievo: result.NomeAllievo,
                        codiceFiscaleAllievo: result.CodiceFiscaleAllievo,
                        luogoNascitaAllievo: result.LuogoNascitaAllievo,
                        dataNascitaAllievo: result.DataNascitaAllievo,
                        indirizzoAllievo: result.IndirizzoAllievo,
                        comuneAllievo: result.ComuneAllievo,
                        provinciaAllievo: result.ProvinciaAllievo,
                        capAllievo: result.CapAllievo,
                        telefonoAllievo: result.TelefonoAllievo,
                        emailAllievo: result.EmailAllievo,
                        classe: result.Classe,
                        cognomeTutore: result.CognomeTutore,
                        nomeTutore: result.NomeTutore,
                        relazioneParentale: result.RelazioneParentale,
                        telefonoTutore: result.TelefonoTutore,
                        indirizzoTutore: result.IndirizzoTutore,
                        comuneTutore: result.ComuneTutore,
                        provinciaTutore: result.ProvinciaTutore,
                        capTutore: result.CapTutore,
                        statoDocumento: result.StatoDocumento,
                        firmaAllievo: result.FirmaAllievo,
                        firmaTutore: result.FirmaTutore,
                        dataDocumento: dataDoc.getDate() + "/" + (dataDoc.getMonth() + 1) + "/" + dataDoc.getFullYear(),
                        paeseNascitaAllievo: result.PaeseNascitaAllievo,
                        denominazioneAzienda: result.DenominazioneAzienda,
                        indirizzoAzienda: result.IndirizzoAzienda,
                        capAzienda: result.CapAzienda,
                        comuneAzienda: result.ComuneAzienda,
                        provinciaAzienda: result.ProvinciaAzienda,
                        telefonoAzienda: result.TelefonoAzienda,
                        emailAzienda: result.EmailAzienda,
                        emailPecAzienda: result.EmailPecAzienda,
                        pIvaAzienda: result.PIvaAzienda,
                        indirizzoTirocinio: result.IndirizzoTirocinio,
                        comuneTirocinio: result.ComuneTirocinio,
                        provinciaTirocinio: result.ProvinciaTirocinio,
                        dataInizioPeriodo: dataInizio.getDate() + "/" + (dataInizio.getMonth() + 1) + "/" + dataInizio.getFullYear(),
                        dataFinePeriodo: dataFine.getDate() + "/" + (dataFine.getMonth() + 1) + "/" + dataFine.getFullYear(),
                        idTipoAttivita: result.IdTipoAttivita,
                        idTemplate: result.IdTemplateDocumento,
                        firmaIstituto: result.FirmaIstituto
                    }
                    resolve(pattoFormativo)
                }).catch(error => {
                    reject(error)
                })
            })
        },
        getAnniScolastici(context: DataContext) {
            var anniScolasticiList: any[] = [];
            var annoScolastico: AnnoScolasticoInfo;
            var check: AnnoScolasticoInfo[] | null = readAnniScolasticiList(context)
            return new Promise<any>((resolve, reject) => {
                if (check === null || check === undefined) {
                    dataService.getAnniScolastici().then(result => {
                        result.forEach((element: any) => {
                            annoScolastico = {
                                idAnnoScolastico: element.AnnoScolastico,
                                dataInizio: element.DataInizio,
                                dataFine: element.DataFine,
                                nomeAnnoScolastico: element.AnnoScolastico + "/" + (element.AnnoScolastico + 1)
                            }
                            anniScolasticiList.push(annoScolastico)
                        });
                        commitSetAnniScolasticiList(context, anniScolasticiList)
                        resolve(anniScolasticiList)
                    }).catch(error => {
                        reject(error)
                    })
                } else {
                    resolve(check)
                }
            })
        },
        getStoricoSoggetto(context: DataContext, payload: { idSoggetto: number, soggetto: string, idIstituto: number }) {
            var attivita: StoricoInfo;
            var listaAttivita: StoricoInfo[] = [];
            return new Promise<StoricoInfo[]>((resolve, reject) => {
                dataService.getStoricoSoggetto(payload.idSoggetto, payload.soggetto, payload.idIstituto).then(result => {
                    result.forEach((element: any) => {
                        attivita = {
                            idStorico: element.IdStorico,
                            idAllievo: element.IdAllievo,
                            allievo: element.CognomeAllievo + " " + element.NomeAllievo,
                            idRichiesta: element.IdRichiesta,
                            denominazioneAzienda: element.DenominazioneAzienda,
                            idTutorAzienda: element.IdTutorAzienda,
                            tutorAzienda: element.CognomeTutorAzienda + " " + element.NomeTutorAzienda,
                            idTutorFormativo: element.IdTutorFormativo,
                            tutorFormativo: element.CognomeTutorFormativo + " " + element.NomeTutorFormativo,
                            idStatoAccettazione: element.IdStatoAccettazione,
                            idTipoAttivita: element.IdTipoAttivita,
                            nomeTipoAttivita: element.DescrizioneAttivita,
                            idAttivitaIstituto: element.IdAttivitaIstituto,
                            nomeAttivitaIstituto: element.NomeAttivita,
                            idAnnoScolastico: element.IdAnnoScolastico
                        }
                        listaAttivita.push(attivita)
                    })
                    resolve(listaAttivita)
                }).catch(error => {
                    reject(error)
                })
            })
        },
        getLastYearSubscription(context: DataContext, payload: { idAllievo: number }) {
            return new Promise<number>((resolve, reject) => {
                dataService.getLastYearSubscription(payload.idAllievo).then(result => {
                    resolve(result.IdAnnoScolastico)
                }).catch(error => {
                    reject(error)
                })
            })
        },
        getRichiesteAttivita(context: DataContext, payload: { idIscrizioneAllievo: number }) {
            var listaInformazioni: any[] = []
            var informazione: RichiestaAttivita
            return new Promise<RichiestaAttivita[]>((resolve, reject) => {
                dataService.getRichiesteAttivita(payload.idIscrizioneAllievo).then(response => {
                    response.forEach((element: any) => {
                        informazione = {
                            idAzienda: element.IdAzienda,
                            denominazioneAzienda: element.Denominazione,
                            titolo: element.Titolo,
                            cognomeRappresentanteAzienda: element.CognomeRappresentante,
                            nomeRappresentanteAzienda: element.NomeRappresentante,
                            dataNascitaRappresentante: element.DataNascitaRappresentante,
                            statoNascitaRappresentante: element.PaeseNascitaRappresentante,
                            luogoNascitaRappresentante: element.LuogoNascitaRappresentante,
                            comuneAzienda: element.ComuneAzienda,
                            idCapComuneAzienda: element.IdCap,
                            provinciaAzienda: element.ProvinciaAzienda,
                            indirizzoAzienda: element.Indirizzo,
                            telefono1Azienda: element.Telefono1,
                            telefono2Azienda: element.Telefono2,
                            faxAzienda: element.Fax,
                            emailAzienda: element.EMail,
                            pecAzienda: element.EMailPec,
                            sitoAzienda: element.SitoWeb,
                            attivitàAzienda: element.AttivitàSvolta,
                            dipendentiAzienda: element.NumeroDipendenti,
                            committenzaAzienda: element.Committenza,
                            associata: element.Associata,
                            artigiana: element.AziendaArtigiana,
                            pIva: element.PIva,
                            codAzienda: element.CodiceFiscale,
                            idAteco: element.IdAteco,
                            // idIstat: element.IdIstat,
                            descrizioneAteco: element.CodAteco + "-" + element.DescrizioneAteco,
                            descrizioneIstat: element.CodIstat + "-" + element.DescrizioneIstat,
                            cap: element.Cap,
                            idNazioneAzienda: element.IdNazioneAzienda,
                            nazioneAzienda: element.NazioneAzienda,
                            lavoratoriSede: element.LavoratoriSede,
                            tirociniSede: element.TirociniSede,
                            tirociniDisabiliSede: element.TirociniDisabiliSede,
                            consulente: element.Consulente,
                            provinciaTirocinio: element.ProvinciaTirocinio,
                            comuneTirocinio: element.ComuneTirocinio,
                            capTirocinio: element.CapTirocinio,
                            indirizzoTirocinio: element.IndirizzoTirocinio,
                            denominazioneConsulente: element.DenominazioneConsulente,
                            referenteConsulente: element.ReferenteConsulente,
                            telefonoConsulente: element.TelefonoConsulente,
                            emailConsulente: element.EmailConsulente,
                            attivitàTirocinio: element.AttivitaTirocinio,
                            indirizzoStudio: element.IndirizzoStudio,
                            cognomeTirocinante: element.CognomeTirocinante,
                            nomeTirocinante: element.NomeTirocinante,
                            classeTirocinante: element.ClasseTirocinante,
                            usoFuoriSede: element.UsoFuoriSede,
                            ruolo: element.Ruolo,
                            idAziendaIstitutoAnno: element.idAziendaIstitutoAnno,
                            nomeIndirizzoStudio: element.NomeIndirizzoStudio,
                            nomeSettore: element.NomeSettore,
                            idRichiesta: element.IdRichiesta,
                            idIscrizioneAttivita: element.IdIscrizioneAttivita,
                            idCPIstat: element.IdCPIstat,
                            descrizioneCPIstat: "",
                            idStatoUtente: element.IdStato,
                            codRappresentate: element.CFRappresentante,
                            confCommercio: element.ConfCommercio,
                            altraAssociazione: element.HasAltraAssociazione
                        }
                        listaInformazioni.push(informazione)
                    });
                    resolve(listaInformazioni)
                }).catch(error => {
                    reject(error)
                })
            })
        },
        getStudentsTutorTirReIns(context: DataContext, payload: { idIstituto: number, idAnnoScolastico: number, idTutor: number }) {
            return new Promise<StudentTutorInfo[]>((resolve, reject) => {
                var studentsList: any[];
                var item: StudentTutorInfo
                var tutorFormativo: string;
                dataService.getStudentsTutorTirReIns(payload.idIstituto, payload.idAnnoScolastico, payload.idTutor)
                    .then(response => {
                        studentsList = []
                        response.forEach((element: any) => {
                            if (element.CognomeTutorForm === null && element.NomeTutorForm === null) {
                                tutorFormativo = ''
                            } else {
                                tutorFormativo = element.CognomeTutorForm + " " + element.NomeTutorForm
                            }
                            item = {
                                tipoSoggetto: element.IdTipoSoggetto,
                                ruoloUtente: [4],
                                descrizioneRuolo: ['Allievo'],
                                nomeUtente: element.Nome,
                                cognomeUtente: element.Cognome,
                                indirizzoUtente: element.Indirizzo,
                                telefono1Utente: element.Telefono1,
                                telefono2Utente: element.Telefono2,
                                cod: element.CodiceFiscale,
                                dataNascita: element.DataNascita,
                                luogoNascita: element.LuogoNascita,
                                emailUtente: element.Email,
                                pecUtente: element.EmailPec,
                                comuneUtente: element.Localita,
                                provinciaUtente: element.IdProvincia,
                                entità: "element.Denominazione",
                                codEntità: element.IdIstituto,
                                idCap: element.IdCap,
                                idUtente: element.IdAllievo,
                                cap: element.Cap,
                                username: element.Utente,
                                matricola: element.Matricola,
                                classe: element.AnnoCorso + ' ' + element.Sezione,
                                idClasse: element.IdClasse,
                                idNazioneNascita: element.IdNazione,
                                idArticolazione: element.IdArticolazione,
                                allievo: element.Cognome + " " + element.Nome,
                                gestioneAlternanza: element.GestioneAlternanza,
                                gestioneTirocinioEstivo: element.GestioneTirocinioEstivo,
                                gestioneTirocinioFormativo: element.GestioneTirocinioFormativo,
                                idDocAutorizzazione: element.IdDocAutorizzazione,
                                idStatoDoc: element.IdStatoDoc,
                                idIstitutoAnnoScolastico: element.IdIstitutoAnnoScolastico,
                                idAzienda: element.IdAzienda,
                                azienda: element.Denominazione,
                                tutorFormativo: tutorFormativo,
                                idRichiesta: element.IdRichiestaTirocinioFormativo,
                                comuneTirocinio: element.ComuneTirocinio,
                                provinciaTirocinio: element.ProvinciaTirocinio,
                                idStatoAccettazione: element.IdStatoAccettazione,
                                idIscrizioneAllievo: element.IdIscrizioneAllievo,
                                diplomato: false,
                                dataDiploma: '',
                                urlCV: "",
                                tutorArticolazione: ""
                            }
                            studentsList.push(item)
                        })
                        resolve(studentsList)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        getAllieviPreAssegnatiTirReIns(context: DataContext, payload: { idIstituto: number, idAnnoScolastico: number, idTutor: number }) {
            var studentsList: StudentAssignmentCompleteTirFormativo[] = []
            var student: StudentAssignmentCompleteTirFormativo
            var dataInizio: any
            var dataFine: any
            var dataProtocollazione: any = ""
            var dataInizioSospUno: any = ""
            var dataFineSospUno: any = ""
            var dataInizioSospDue: any = ""
            var dataFineSospDue: any = ""
            var usoFuori: string;
            return new Promise<StudentAssignmentCompleteTirFormativo[]>((resolve, reject) => {
                dataService.getAllieviPreAssegnatiTirReIns(payload.idIstituto, payload.idAnnoScolastico, payload.idTutor)
                    .then(response => {
                        response.forEach((element: any) => {
                            dataProtocollazione = ""
                            dataInizioSospUno = ""
                            dataFineSospUno = ""
                            dataInizioSospDue = ""
                            dataFineSospDue = ""
                            if (element.UsoFuoriSede === false) {
                                usoFuori = "No"
                            } else {
                                usoFuori = "Si"
                            }
                            dataInizio = new Date(element.DataInizioPeriodo)
                            dataFine = new Date(element.DataFinePeriodo)
                            if (element.DataProtocollazione !== null) {
                                dataProtocollazione = new Date(element.DataProtocollazione)
                                dataProtocollazione = dataProtocollazione.getFullYear() + "-" + (dataProtocollazione.getMonth() + 1) + "-" + dataProtocollazione.getDate()
                            }
                            if (element.DataInizioSospensioneUno !== null && element.DataFineSospensioneUno !== null) {
                                dataInizioSospUno = new Date(element.DataInizioSospensioneUno)
                                dataFineSospUno = new Date(element.DataFineSospensioneUno)
                                dataInizioSospUno = dataInizioSospUno.getDate() + "/" + (dataInizioSospUno.getMonth() + 1) + "/" + dataInizioSospUno.getFullYear()
                                dataFineSospUno = dataFineSospUno.getDate() + "/" + (dataFineSospUno.getMonth() + 1) + "/" + dataFineSospUno.getFullYear()
                            }
                            if (element.DataInizioSospensioneDue !== null && element.DataFineSospensioneDue !== null) {
                                dataInizioSospDue = new Date(element.DataInizioSospensioneDue)
                                dataFineSospDue = new Date(element.DataFineSospensioneDue)
                                dataInizioSospDue = dataInizioSospDue.getDate() + "/" + (dataInizioSospDue.getMonth() + 1) + "/" + dataInizioSospDue.getFullYear()
                                dataFineSospDue = dataFineSospDue.getDate() + "/" + (dataFineSospDue.getMonth() + 1) + "/" + dataFineSospDue.getFullYear()
                            }
                            student = {
                                tipoSoggetto: element.IdTipoSoggetto,
                                ruoloUtente: [4],
                                descrizioneRuolo: ['Allievo'],
                                nomeUtente: element.Nome,
                                cognomeUtente: element.Cognome,
                                indirizzoUtente: element.IndirizzoAllievo,
                                telefono1Utente: element.Telefono1Allievo,
                                telefono2Utente: element.Telefono2Allievo,
                                cod: element.CodAllievo,
                                dataNascita: element.DataNascita,
                                luogoNascita: element.LuogoNascita,
                                emailUtente: element.Email,
                                pecUtente: element.EmailPec,
                                comuneUtente: element.LocalitaAllievo,
                                provinciaUtente: element.IdProvinciaAllievo,
                                entità: "element.Denominazione",
                                codEntità: element.IdIstituto,
                                idCap: element.IdCap,
                                idUtente: element.Id,
                                cap: element.CapAllievo,
                                username: element.Utente,
                                matricola: element.Matricola,
                                classe: element.AnnoCorso + ' ' + element.Sezione,
                                idClasse: element.IdClasse,
                                idNazioneNascita: element.IdNazione,
                                idArticolazione: element.IdArticolazione,
                                allievo: element.Cognome + " " + element.Nome,
                                gestioneAlternanza: element.GestioneAlternanza,
                                idDocAutorizzazione: element.IdDocAutorizzazione,
                                idStatoDoc: element.IdStatoDoc,
                                idIstitutoAnnoScolastico: element.IdIstitutoAnnoScolastico,
                                idAzienda: element.IdAzienda,
                                azienda: "",
                                idInfoRichiestaTirFormativo: element.IdRichiestaTirocinioFormativo,
                                idTutorAzienda: element.IdTutorAzienda,
                                tutorAzienda: element.CognomeTutorAzienda + " " + element.NomeTutorAzienda,
                                telefonoTutor: element.TelefonoTutorAziendale,
                                emailTutor: element.EmailTutorAziendale,
                                dataInizioPeriodo: dataInizio.getDate() + "/" + (dataInizio.getMonth() + 1) + "/" + dataInizio.getFullYear(),
                                dataFinePeriodo: dataFine.getDate() + "/" + (dataFine.getMonth() + 1) + "/" + dataFine.getFullYear(),
                                orarioInizioMattino: element.OrarioInizioMattino,
                                orarioFineMattino: element.OrarioFineMattino,
                                orarioInizioPomeriggio: element.OrarioInizioPomeriggio,
                                orarioFinePomeriggio: element.OrarioFinePomeriggio,
                                mansioni: "",
                                idStatoAccettazione: element.IdStatoAccettazione,

                                // idAzienda: element.IdAzienda,
                                denominazioneAzienda: element.NomeAzienda,
                                titolo: element.Titolo,
                                cognomeRappresentanteAzienda: element.CognomeRappresentante,
                                nomeRappresentanteAzienda: element.NomeRappresentante,
                                dataNascitaRappresentante: element.DataNascitaRappresentante,
                                statoNascitaRappresentante: element.PaeseNascitaRappresentante,
                                luogoNascitaRappresentante: element.LuogoNascitaRappresentante,
                                comuneAzienda: element.LocalitaAzienda,
                                idCapComuneAzienda: element.IdCap,
                                provinciaAzienda: element.IdProvinciaAzienda,
                                indirizzoAzienda: element.IndirizzoAzienda,
                                telefono1Azienda: element.Telefono1Azienda,
                                telefono2Azienda: element.Telefono2Azienda,
                                faxAzienda: element.Fax,
                                emailAzienda: element.EMail,
                                pecAzienda: element.EMailPec,
                                sitoAzienda: element.SitoWeb,
                                attivitàAzienda: element.AttivitàSvolta,
                                dipendentiAzienda: element.NumeroDipendenti,
                                committenzaAzienda: element.Committenza,
                                associata: element.Associata,
                                artigiana: element.AziendaArtigiana,
                                pIva: element.PIva,
                                codAzienda: element.CodAzienda,
                                idAteco: element.IdAteco,
                                // idIstat: element.IdIstat,
                                descrizioneAteco: element.CodAteco + "-" + element.DescrizioneAteco,
                                descrizioneIstat: element.CodIstat + "-" + element.DescrizioneIstat,
                                // capAzienda: element.CapAzienda,
                                idNazioneAzienda: element.IdNazioneAzienda,
                                nazioneAzienda: element.NazioneAzienda,

                                lavoratoriSede: element.LavoratoriSede,
                                tirociniSede: element.TirociniSede,
                                tirociniDisabiliSede: element.TirociniDisabiliSede,
                                consulente: element.Consulente,
                                provinciaTirocinio: element.ProvinciaTirocinio,
                                comuneTirocinio: element.ComuneTirocinio,
                                capTirocinio: element.CapTirocinio,
                                indirizzoTirocinio: element.IndirizzoTirocinio,
                                denominazioneConsulente: element.DenominazioneConsulente,
                                referenteConsulente: element.ReferenteConsulente,
                                telefonoConsulente: element.TelefonoConsulente,
                                emailConsulente: element.EmailConsulente,
                                attivitàTirocinio: element.AttivitaTirocinio,
                                indirizzoStudio: element.IndirizzoStudio,
                                cognomeTirocinante: "",
                                nomeTirocinante: "",
                                classeTirocinante: "",
                                usoFuoriSede: usoFuori,
                                ruolo: element.Ruolo,
                                idAziendaIstitutoAnno: element.idAziendaIstitutoAnno,
                                nomeIndirizzoStudio: element.NomeIndirizzoStudio,
                                nomeSettore: element.NomeSettore,
                                idRichiesta: element.IdRichiestaTirocinioFormativo,
                                gestioneTirocinioEstivo: element.GestioneTirocinioEstivo,
                                gestioneTirocinioFormativo: element.GestioneTirocinioFormativo,
                                tutorFormativo: "",
                                idCPIstat: element.CodIstat,
                                descrizioneCPIstat: "",
                                idConvenzione: element.IdConvenzione,
                                idProgettoOrientamento: element.IdProgettoOrientamento,

                                responsabilitaCivile: element.ResponsabilitaCivile,
                                assicurazioneAzienda: element.AssicurazioneAzienda,
                                indennitaMensile: element.IndennitaMensile,
                                dataInizioSospensioneUno: dataInizioSospUno,
                                dataFineSospensioneUno: dataFineSospUno,
                                motivazioneSospensioneUno: element.MotivazioneSospensioneUno,
                                dataInizioSospensioneDue: dataInizioSospDue,
                                dataFineSospensioneDue: dataFineSospDue,
                                motivazioneSospensioneDue: element.MotivazioneSospensioneDue,
                                idIscrizioneAllievo: 0,
                                idIscrizioneAttivita: element.IdIscrizioneAttivita,
                                idConsenso: element.IdConsenso,
                                firmaConvenzioneAz: element.FirmaConvenzioneAzienda,
                                firmaConsensoAz: element.FirmaConsensoAzienda,
                                firmaConsensoTir: element.FirmaConsensoTirocinante,
                                statoDocConvenzione: element.IdStatoDocConvenzione,
                                statoDocConsenso: element.IdStatoDocConsenso,
                                numeroProtocollazione: element.NumeroProtocollazione,
                                dataProtocollazione: dataProtocollazione,
                                reportVisite: element.ReportVisite,
                                idStatoUtente: element.IdStato,
                                diplomato: false,
                                dataDiploma: '',
                                urlCV: "",
                                apprendistatoCheck: element.Appredistato,
                                tutorArticolazione: "",
                                codRappresentate: element.CFRappresentante,
                                confCommercio: element.ConfCommercio,
                                altraAssociazione: element.HasAltraAssociazione
                            }
                            studentsList.push(student)
                        })
                        resolve(studentsList)
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        getAllieviAssegnatiAziendaTirReIns(context: DataContext, payload: { idAnnoScolastico: number, idAzienda: number }) {
            var studentsList: StudentAssignmentTirFormativoInfo[] = []
            var student: StudentAssignmentTirFormativoInfo
            var dataInizio: any
            var dataFine: any
            var dataInizioSospUno: any = ""
            var dataFineSospUno: any = ""
            var dataInizioSospDue: any = ""
            var dataFineSospDue: any = ""
            var usoFuori: string;
            return new Promise<StudentAssignmentTirFormativoInfo[]>((resolve, reject) => {
                dataService.getAllieviAssegnatiAziendaTirReIns(payload.idAnnoScolastico, payload.idAzienda)
                    .then(response => {
                        response.forEach((element: any) => {
                            dataInizioSospUno = ""
                            dataFineSospUno = ""
                            dataInizioSospDue = ""
                            dataFineSospDue = ""
                            if (element.UsoFuoriSede === false) {
                                usoFuori = "No"
                            } else {
                                usoFuori = "Si"
                            }
                            dataInizio = new Date(element.DataInizioPeriodo)
                            dataFine = new Date(element.DataFinePeriodo)
                            if (element.DataInizioSospensioneUno !== null && element.DataFineSospensioneUno !== null) {
                                dataInizioSospUno = new Date(element.DataInizioSospensioneUno)
                                dataFineSospUno = new Date(element.DataFineSospensioneUno)
                                dataInizioSospUno = dataInizioSospUno.getDate() + "/" + (dataInizioSospUno.getMonth() + 1) + "/" + dataInizioSospUno.getFullYear()
                                dataFineSospUno = dataFineSospUno.getDate() + "/" + (dataFineSospUno.getMonth() + 1) + "/" + dataFineSospUno.getFullYear()
                            }
                            if (element.DataInizioSospensioneDue !== null && element.DataFineSospensioneDue !== null) {
                                dataInizioSospDue = new Date(element.DataInizioSospensioneDue)
                                dataFineSospDue = new Date(element.DataFineSospensioneDue)
                                dataInizioSospDue = dataFineSospDue.getDate() + "/" + (dataFineSospDue.getMonth() + 1) + "/" + dataFineSospDue.getFullYear()
                                dataFineSospDue = dataFineSospDue.getDate() + "/" + (dataFineSospDue.getMonth() + 1) + "/" + dataFineSospDue.getFullYear()
                            }

                            student = {
                                tipoSoggetto: element.IdTipoSoggetto,
                                ruoloUtente: [4],
                                descrizioneRuolo: ['Allievo'],
                                nomeUtente: element.Nome,
                                cognomeUtente: element.Cognome,
                                indirizzoUtente: element.IndirizzoAllievo,
                                telefono1Utente: element.Telefono1Allievo,
                                telefono2Utente: element.Telefono2Allievo,
                                cod: element.CodAllievo,
                                dataNascita: element.DataNascita,
                                luogoNascita: element.LuogoNascita,
                                emailUtente: element.Email,
                                pecUtente: element.EmailPec,
                                comuneUtente: element.LocalitaAllievo,
                                provinciaUtente: element.IdProvinciaAllievo,
                                entità: "element.Denominazione",
                                codEntità: element.IdIstituto,
                                idCap: element.IdCap,
                                idUtente: element.Id,
                                cap: element.CapAllievo,
                                username: element.Utente,
                                matricola: element.Matricola,
                                classe: element.AnnoCorso + ' ' + element.Sezione,
                                idClasse: element.IdClasse,
                                idNazioneNascita: element.IdNazione,
                                idArticolazione: element.IdArticolazione,
                                allievo: element.Cognome + " " + element.Nome,
                                gestioneAlternanza: element.GestioneAlternanza,
                                idDocAutorizzazione: element.IdDocAutorizzazione,
                                idStatoDoc: element.IdStatoDoc,
                                idIstitutoAnnoScolastico: element.IdIstitutoAnnoScolastico,
                                idAzienda: element.IdAzienda,
                                azienda: "",
                                idInfoRichiestaTirFormativo: element.IdRichiestaTirocinioFormativo,
                                idTutorAzienda: element.IdTutorAzienda,
                                tutorAzienda: element.CognomeTutorAzienda + " " + element.NomeTutorAzienda,
                                telefonoTutor: element.TelefonoTutorAziendale,
                                emailTutor: element.EmailTutorAziendale,
                                dataInizioPeriodo: dataInizio.getDate() + "/" + (dataInizio.getMonth() + 1) + "/" + dataInizio.getFullYear(),
                                dataFinePeriodo: dataFine.getDate() + "/" + (dataFine.getMonth() + 1) + "/" + dataFine.getFullYear(),
                                orarioInizioMattino: element.OrarioInizioMattino,
                                orarioFineMattino: element.OrarioFineMattino,
                                orarioInizioPomeriggio: element.OrarioInizioPomeriggio,
                                orarioFinePomeriggio: element.OrarioFinePomeriggio,
                                mansioni: "",
                                idStatoAccettazione: element.IdStatoAccettazione,

                                // idAzienda: element.IdAzienda,
                                denominazioneAzienda: element.NomeAzienda,
                                titolo: element.Titolo,
                                cognomeRappresentanteAzienda: element.CognomeRappresentante,
                                nomeRappresentanteAzienda: element.NomeRappresentante,
                                dataNascitaRappresentante: element.DataNascitaRappresentante,
                                statoNascitaRappresentante: element.PaeseNascitaRappresentante,
                                luogoNascitaRappresentante: element.LuogoNascitaRappresentante,
                                comuneAzienda: element.LocalitaAzienda,
                                idCapComuneAzienda: element.IdCap,
                                provinciaAzienda: element.IdProvinciaAzienda,
                                indirizzoAzienda: element.IndirizzoAzienda,
                                telefono1Azienda: element.Telefono1Azienda,
                                telefono2Azienda: element.Telefono2Azienda,
                                faxAzienda: element.Fax,
                                emailAzienda: element.EMail,
                                pecAzienda: element.EMailPec,
                                sitoAzienda: element.SitoWeb,
                                attivitàAzienda: element.AttivitàSvolta,
                                dipendentiAzienda: element.NumeroDipendenti,
                                committenzaAzienda: element.Committenza,
                                associata: element.Associata,
                                artigiana: element.AziendaArtigiana,
                                pIva: element.PIva,
                                codAzienda: element.CodAzienda,
                                idAteco: element.IdAteco,
                                // idIstat: element.IdIstat,
                                descrizioneAteco: element.CodAteco + "-" + element.DescrizioneAteco,
                                descrizioneIstat: element.CodIstat + "-" + element.DescrizioneIstat,
                                // capAzienda: element.CapAzienda,
                                idNazioneAzienda: element.IdNazioneAzienda,
                                nazioneAzienda: element.NazioneAzienda,

                                lavoratoriSede: element.LavoratoriSede,
                                tirociniSede: element.TirociniSede,
                                tirociniDisabiliSede: element.TirociniDisabiliSede,
                                consulente: element.Consulente,
                                provinciaTirocinio: element.ProvinciaTirocinio,
                                comuneTirocinio: element.ComuneTirocinio,
                                capTirocinio: element.CapTirocinio,
                                indirizzoTirocinio: element.IndirizzoTirocinio,
                                denominazioneConsulente: element.DenominazioneConsulente,
                                referenteConsulente: element.ReferenteConsulente,
                                telefonoConsulente: element.TelefonoConsulente,
                                emailConsulente: element.EmailConsulente,
                                attivitàTirocinio: element.AttivitaTirocinio,
                                indirizzoStudio: element.IndirizzoStudio,
                                cognomeTirocinante: "",
                                nomeTirocinante: "",
                                classeTirocinante: "",
                                usoFuoriSede: usoFuori,
                                ruolo: element.Ruolo,
                                idAziendaIstitutoAnno: element.idAziendaIstitutoAnno,
                                nomeIndirizzoStudio: element.NomeIndirizzoStudio,
                                nomeSettore: element.NomeSettore,
                                idRichiesta: element.IdRichiestaTirocinioFormativo,
                                gestioneTirocinioEstivo: element.GestioneTirocinioEstivo,
                                gestioneTirocinioFormativo: element.GestioneTirocinioFormativo,
                                tutorFormativo: element.CognomeTutorFormativo + " " + element.NomeTutorFormativo,
                                idCPIstat: 0,
                                descrizioneCPIstat: "",
                                idConvenzione: element.IdConvenzione,
                                idProgettoOrientamento: element.IdProgettoOrientamento,

                                responsabilitaCivile: element.ResponsabilitaCivile,
                                assicurazioneAzienda: element.AssicurazioneAzienda,
                                indennitaMensile: element.IndennitaMensile,
                                dataInizioSospensioneUno: dataInizioSospUno,
                                dataFineSospensioneUno: dataFineSospUno,
                                motivazioneSospensioneUno: element.MotivazioneSospensioneUno,
                                dataInizioSospensioneDue: dataInizioSospDue,
                                dataFineSospensioneDue: dataFineSospDue,
                                motivazioneSospensioneDue: element.MotivazioneSospensioneDue,
                                idIscrizioneAllievo: 0,
                                idIscrizioneAttivita: element.IdIscrizioneAttivita,
                                reportVisite: element.ReportVisite,
                                idStatoUtente: element.IdStato,
                                diplomato: false,
                                dataDiploma: '',
                                urlCV: "",
                                apprendistatoCheck: element.Appredistato,
                                tutorArticolazione: "",
                                codRappresentate: element.CFRappresentante,
                                confCommercio: element.ConfCommercio,
                                altraAssociazione: element.HasAltraAssociazione
                            }
                            studentsList.push(student)
                        })
                        resolve(studentsList)
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        getRichiesteTirReInsAllievo(context: DataContext, payload: { idAllievo: number, idAnnoScolastico: number }) {
            var richiesta: number;
            var richiesteList: number[] = []
            return new Promise<number[]>((resolve, reject) => {
                dataService.getRichiesteTirReInsAllievo(payload.idAllievo, payload.idAnnoScolastico)
                    .then(result => {
                        result.forEach((element: any) => {
                            richiesta = element.IdRichiestaTirocinioFormativo
                            richiesteList.push(richiesta)
                        });
                        resolve(richiesteList)
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        getPreferenzeWorkshopAzienda(context: DataContext, idIscrizione: number) {
            var preferenza: any;
            var listaPreferenze: any[] = []
            return new Promise<any[]>((resolve, reject) => {
                dataService.getPreferenzeWorkshopAzienda(idIscrizione).then(result => {
                    result.forEach((element: any) => {
                        preferenza = {
                            idInformazioneWorkshop: element.IdInformazioneWorkshop,
                            idArticolazione: element.IdArticolazione,
                            scelta: element.Scelta,
                            cognomeReferente: element.CognomeReferente,
                            nomeReferente: element.NomeReferente,
                            emailReferente: element.EmailReferente,
                            giorno: userUtils.parseDate(element.Giorno),
                            turno: element.Turno,
                            linkWorkshop: element.LinkStanza,
                        }
                        listaPreferenze.push(preferenza)
                    });
                    resolve(listaPreferenze)
                }).catch(error => {
                    reject(error)
                })
            })
        },
        getListaIscrizioniWorkshop(context: DataContext, payload: { idIstituto: number, idAnnoScolastico: number }) {
            var iscrizione: any;
            var listaIscrizioni: any[] = []
            return new Promise<any[]>((resolve, reject) => {
                dataService.getListaIscrizioniWorkshop(payload.idIstituto, payload.idAnnoScolastico).then(result => {
                    result.forEach((element: any) => {
                        iscrizione = {
                            denominazioneAzienda: element.Denominazione,
                            idInformazioneWorkshop: element.Id,
                            idIscrizioneAttivita: element.IdIscrizioneAttivita,
                            idArticolazione: element.IdArticolazione,
                            nomeArticolazione: element.NomeArticolazione,
                            scelta: element.Scelta,
                            referente: element.CognomeReferente + " " + element.NomeReferente,
                            cognomeReferente: element.CognomeReferente,
                            nomeReferente: element.NomeReferente,
                            emailReferente: element.EmailReferente,
                            linkWorkshop: element.LinkStanza,
                            turno: element.Turno,
                            idTurno: element.IDTurno,
                            giorno: userUtils.parseDate(element.Giorno),
                            idGiorno: element.IDGiorno,
                            presenzaWorkshop: element.Presente,
                            comuneAzienda: element.Localita,
                            emailAzienda: element.EmailAzienda
                        }
                        listaIscrizioni.push(iscrizione)
                    });
                    resolve(listaIscrizioni)
                }).catch(error => {
                    reject(error)
                })
            })
        },
        getTipiContrattoList(context: DataContext) {
            var tipoContratto: TipoContrattoInfo;
            var listaTipiContratto: TipoContrattoInfo[] = []
            var check: TipoContrattoInfo[] | null = readTipiContrattoList(context)
            return new Promise<TipoContrattoInfo[]>((resolve, reject) => {
                if (check === null || check === undefined) {
                    dataService.getTipiContratto().then(result => {
                        result.forEach((element: any) => {
                            tipoContratto = {
                                idTipoContratto: element.Id,
                                nomeTipoContratto: element.DescrizioneTipoContratto
                            }
                            listaTipiContratto.push(tipoContratto)
                        });
                        commitSetTipoContrattoList(context, listaTipiContratto)
                        resolve(listaTipiContratto)
                    }).catch(error => {
                        reject(error)
                    })
                } else {
                    resolve(check)
                }

            })
        },
        getListaProposteLavoroAzienda(context: DataContext, payload: { idAzienda: number }) {
            var proposta: PropostaLavoroInfo;
            var listaProposte: PropostaLavoroInfo[] = []
            var data: any;
            return new Promise<PropostaLavoroInfo[]>((resolve, reject) => {
                dataService.getListaProposteLavoroAzienda(payload.idAzienda).then(result => {
                    result.forEach((element: any) => {
                        data = new Date(element.DataCreazione)
                        proposta = {
                            idProposta: element.Id,
                            idAzienda: element.IdAzienda,
                            denominazioneAzienda: element.DenominazioneAzienda,
                            denominazioneAziendaMan: element.DenominazioneAziendaMan,
                            denominazioneAziendaVisibile: element.DenominazioneAziendaVisibile,
                            nomeProposta: element.NomeProposta,
                            tipoContratto: element.TipoContratto,
                            descrizioneContratto: element.DescrizioneTipoContratto,
                            descrizioneProposta: element.DescrizioneProposta,
                            idCapProposta: element.IdCapProposta,
                            comuneProposta: element.ComuneProposta,
                            provinciaProposta: element.ProvinciaProposta,
                            indirizzoProposta: element.IndirizzoProposta,
                            disponibile: element.Disponibile,
                            ruolo: element.Ruolo,
                            competenze: element.Competenze,
                            sede: element.ComuneProposta + "(" + element.ProvinciaProposta + ")",
                            emailContattoAzienda: element.EmailContattoAzienda,
                            telefonoContattoAzienda: element.TelefonoContatto,
                            idIstituto: element.IdIstituto,
                            idArticolazione: element.IdArticolazione,
                            nomeIstituto: element.NomeIstituto,
                            nomeArticolazione: element.NomeArticolazione,
                            candidature: element.Candidature,
                            dataCreazione: data.toISOString(),
                            dsDataCreazione: data.getDate() + "/" + (data.getMonth() + 1) + "/" + data.getFullYear()
                        }
                        listaProposte.push(proposta)
                    });
                    resolve(listaProposte)
                }).catch(error => {
                    reject(error)
                })
            })
        },
        getListaProposteLavoroIstituto(context: DataContext, payload: { idIstituto: number }) {
            var proposta: PropostaLavoroInfo;
            var listaProposte: PropostaLavoroInfo[] = []
            var data: any;
            return new Promise<PropostaLavoroInfo[]>((resolve, reject) => {
                dataService.getListaProposteLavoroIstituto(payload.idIstituto).then(result => {
                    result.forEach((element: any) => {
                        data = new Date(element.DataCreazione)
                        proposta = {
                            idProposta: element.Id,
                            idAzienda: element.IdAzienda,
                            denominazioneAzienda: element.DenominazioneAzienda,
                            denominazioneAziendaMan: element.DenominazioneAziendaMan,
                            nomeProposta: element.NomeProposta,
                            tipoContratto: element.TipoContratto,
                            descrizioneContratto: element.DescrizioneTipoContratto,
                            descrizioneProposta: element.DescrizioneProposta,
                            idCapProposta: element.IdCapProposta,
                            comuneProposta: element.ComuneProposta,
                            provinciaProposta: element.ProvinciaProposta,
                            indirizzoProposta: element.IndirizzoProposta,
                            disponibile: element.Disponibile,
                            ruolo: element.Ruolo,
                            competenze: element.Competenze,
                            sede: element.ComuneProposta + "(" + element.ProvinciaProposta + ")",
                            emailContattoAzienda: element.EmailContattoAzienda,
                            telefonoContattoAzienda: element.TelefonoContatto,
                            idIstituto: element.IdIstituto,
                            idArticolazione: element.IdArticolazione,
                            nomeIstituto: element.NomeIstituto,
                            nomeArticolazione: element.NomeArticolazione,
                            candidature: element.Candidature,
                            dataCreazione: data.toISOString(),
                            dsDataCreazione: data.getDate() + "/" + (data.getMonth() + 1) + "/" + data.getFullYear()
                        }
                        listaProposte.push(proposta)
                    });
                    resolve(listaProposte)
                }).catch(error => {
                    reject(error)
                })
            })
        },
        getListaProposteLavoroAllievi(context: DataContext, idAllievo: number) {
            var proposta: PropostaLavoroAllievo;
            var listaProposte: PropostaLavoroAllievo[] = [];
            var data: any;
            return new Promise<PropostaLavoroAllievo[]>((resolve, reject) => {
                dataService.getListaProposteLavoroAllievo(idAllievo).then(result => {
                    result.forEach((element: any) => {
                        data = new Date(element.DataCreazione)
                        proposta = {
                            idProposta: element.Id,
                            idAzienda: element.IdAzienda,
                            denominazioneAzienda: element.DenominazioneAzienda,
                            denominazioneAziendaMan: element.DenominazioneAziendaMan,
                            nomeProposta: element.NomeProposta,
                            tipoContratto: element.TipoContratto,
                            descrizioneContratto: element.DescrizioneTipoContratto,
                            descrizioneProposta: element.DescrizioneProposta,
                            idCapProposta: element.IdCapProposta,
                            comuneProposta: element.ComuneProposta,
                            provinciaProposta: element.ProvinciaProposta,
                            indirizzoProposta: element.IndirizzoProposta,
                            disponibile: element.Disponibile,
                            ruolo: element.Ruolo,
                            competenze: element.Competenze,
                            sede: element.ComuneProposta + "(" + element.ProvinciaProposta + ")",
                            emailContattoAzienda: element.EmailContattoAzienda,
                            telefonoContattoAzienda: element.TelefonoContatto,
                            idCandidatura: element.IdCandidatura,
                            idIstituto: element.IdIstituto,
                            idArticolazione: element.IdArticolazione,
                            nomeIstituto: element.NomeIstituto,
                            nomeArticolazione: element.NomeArticolazione,
                            candidature: false,
                            dataCreazione: data.toISOString(),
                            dsDataCreazione: data.getDate() + "/" + (data.getMonth() + 1) + "/" + data.getFullYear()
                        }
                        listaProposte.push(proposta)
                    });
                    resolve(listaProposte)
                }).catch(error => {
                    reject(error)
                })
            })
        },
        getQuestionariWorkshopAziende(context: DataContext, payload: { idIstituto: number, idAnnoScolastico: number, idTipoQuestionario: number }) {
            var questionario: any;
            var listaQuestionari: any[] = []
            var dataQuestionario: any = ""
            return new Promise<any[]>((resolve, reject) => {
                dataService.getQuestionariWorkshopAziende(payload.idIstituto, payload.idAnnoScolastico, payload.idTipoQuestionario).then(result => {
                    result.forEach((element: any) => {
                        dataQuestionario = new Date(element.DataQuestionario)
                        questionario = {
                            idQuestionario: element.Id,
                            idRichiesta: element.IdRichiesta,
                            denominazioneAzienda: element.Denominazione,
                            dataQuestionario: dataQuestionario.getDate() + "/" + (dataQuestionario.getMonth() + 1) + "/" + dataQuestionario.getFullYear()
                        }
                        listaQuestionari.push(questionario)
                    });
                    resolve(listaQuestionari)
                }).catch(error => {
                    reject(error)
                })
            })
        },
        getQuestionariWorkshopAllievi(context: DataContext, payload: { idIstituto: number, idAnnoScolastico: number, idTipoQuestionario: number }) {
            var questionario: any;
            var listaQuestionari: any[] = []
            var dataQuestionario: any = ""
            return new Promise<any[]>((resolve, reject) => {
                dataService.getQuestionariWorkshopAllievi(payload.idIstituto, payload.idAnnoScolastico, payload.idTipoQuestionario).then(result => {
                    result.forEach((element: any) => {
                        dataQuestionario = new Date(element.DataQuestionario)
                        questionario = {
                            idQuestionario: element.Id,
                            idRichiesta: element.IdRichiesta,
                            allievo: element.Cognome + " " + element.Nome,
                            classe: element.AnnoCorso + " " + element.Sezione,
                            idArticolazione: element.IdArticolazione,
                            dataQuestionario: dataQuestionario.getDate() + "/" + (dataQuestionario.getMonth() + 1) + "/" + dataQuestionario.getFullYear()
                        }
                        listaQuestionari.push(questionario)
                    });
                    resolve(listaQuestionari)
                }).catch(error => {
                    reject(error)
                })
            })
        },
        getTemplateDoc(context: DataContext, idTemplate: number) {
            return new Promise<any>((resolve, reject) => {
                dataService.getTemplateDoc(idTemplate).then(result => {
                    resolve(result)
                }).catch(error => {
                    reject(error)
                })
            })
        },
        getCandidaturePropostaLavoro(context: DataContext, payload: { idProposta: number }) {
            var candidatura: CandidaturaPropostaLavoro;
            var listaCandidature: CandidaturaPropostaLavoro[] = [];
            var dataCandidatura: any;
            return new Promise<CandidaturaPropostaLavoro[]>((resolve, reject) => {
                dataService.getCandidaturePropostaLavoro(payload.idProposta).then(result => {
                    result.forEach((element: any) => {
                        dataCandidatura = new Date(element.DataCandidatura)
                        candidatura = {
                            idCandidatura: element.Id,
                            idAllievo: element.IdAllievo,
                            idPropostaLavoro: element.IdPropostaLavoro,
                            dataCandidatura: dataCandidatura.getDate() + "/" + (dataCandidatura.getMonth() + 1) + "/" + dataCandidatura.getFullYear(),
                            colloquioAvvenuto: element.ColloquioAvvenuto,
                            nomeAllievo: element.Nome,
                            cognomeAllievo: element.Cognome,
                            telefono: element.Telefono1,
                            allievo: element.Cognome + " " + element.Nome,
                            urlCV: element.Url
                        }
                        listaCandidature.push(candidatura)
                    });
                    resolve(listaCandidature)
                }).catch(error => {
                    reject(error)
                })
            })
        },
        getGiorniWorkshop(context: DataContext, payload: { idIstituto: number, idAnnoScolastico: number }) {
            var listaGiorni: any[] = [];
            var giorno: any;
            return new Promise<any>((resolve, reject) => {
                dataService.getGiorniWorkshop(payload.idIstituto, payload.idAnnoScolastico).then(result => {
                    result.forEach((element: any) => {
                        giorno = {
                            idGiorno: element.IdGiorno,
                            descrizioneGiorno: userUtils.parseDate(element.Giorno)
                        }
                        listaGiorni.push(giorno);
                    });
                    resolve(listaGiorni)
                }).catch(error => {
                    reject(error)
                })
            })
        },
        getTurniWorkshop(context: DataContext, payload: { idIstituto: number, idAnnoScolastico: number }) {
            var listaTurni: any[] = []
            var turno: any;
            return new Promise<any>((resolve, reject) => {
                dataService.getTurniWorkshop(payload.idIstituto, payload.idAnnoScolastico).then(result => {
                    result.forEach((element: any) => {
                        turno = {
                            idTurno: element.IdTurno,
                            descrizioneTurno: element.Turno
                        }
                        listaTurni.push(turno)
                    });
                    resolve(listaTurni)
                }).catch(error => {
                    reject(error)
                })
            })
        },
        getAllieviAssegnatiTutor(context: DataContext, payload: { idIstituto: number, idAnnoScolastico: number, idTutor: number }) {
            return new Promise<any[]>((resolve, reject) => {
                var studentsList: any[];
                var item: any
                var tutorFormativo: string;
                dataService.getAllieviAssegnatiTutor(payload.idIstituto, payload.idAnnoScolastico, payload.idTutor)
                    .then(response => {
                        studentsList = []
                        response.forEach((element: any) => {
                            item = {
                                tipoSoggetto: element.IdTipoSoggetto,
                                ruoloUtente: [4],
                                descrizioneRuolo: ['Allievo'],
                                nomeUtente: element.Nome,
                                cognomeUtente: element.Cognome,
                                indirizzoUtente: element.Indirizzo,
                                telefono1Utente: element.Telefono1,
                                telefono2Utente: element.Telefono2,
                                cod: element.CodiceFiscale,
                                dataNascita: element.DataNascita,
                                luogoNascita: element.LuogoNascita,
                                emailUtente: element.Email,
                                pecUtente: element.EmailPec,
                                comuneUtente: element.Localita,
                                provinciaUtente: element.IdProvincia,
                                entità: "element.Denominazione",
                                codEntità: element.IdIstituto,
                                idCap: element.IdCap,
                                idUtente: element.IdAllievo,
                                cap: element.Cap,
                                username: element.Utente,
                                matricola: element.Matricola,
                                classe: element.AnnoCorso + ' ' + element.Sezione,
                                idClasse: element.IdClasse,
                                idNazioneNascita: element.IdNazione,
                                idArticolazione: element.IdArticolazione,
                                allievo: element.Cognome + " " + element.Nome,
                                gestioneAlternanza: element.GestioneAlternanza,
                                gestioneTirocinioEstivo: element.GestioneTirocinioEstivo,
                                gestioneTirocinioFormativo: element.GestioneTirocinioFormativo,
                                idDocAutorizzazione: element.IdDocAutorizzazione,
                                idStatoDoc: element.IdStatoDoc,
                                idIstitutoAnnoScolastico: element.IdIstitutoAnnoScolastico,
                                // idAzienda: element.IdAzienda,
                                // azienda: element.Denominazione,
                                // tutorFormativo: tutorFormativo,
                                // idRichiesta: element.IdInformazioneAlternanza,
                                // comuneTirocinio: element.ComuneTirocinio,
                                // provinciaTirocinio: element.ProvinciaTirocinio,
                                // idStatoAccettazione: element.IdStatoAccettazione,
                                // idIscrizioneAllievo: element.IdIscrizioneAllievo
                            }
                            studentsList.push(item)
                        })
                        resolve(studentsList)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        getClassiArticolazioneIstitutoAnno(context: DataContext, payload: { idIstituto: number, idAnnoScolastico: number, idArticolazione: string }) {
            var classe: ClasseInfo
            var classiList: ClasseInfo[] = []
            return new Promise<ClasseInfo[]>((resolve, reject) => {
                dataService.getClassiArticolazioneIstitutoAnno(payload.idIstituto, payload.idAnnoScolastico, payload.idArticolazione)
                    .then(result => {
                        result.forEach((element: any) => {
                            classe = {
                                idClasse: element.IdClasse,
                                classe: element.AnnoCorso + " " + element.Sezione,
                                annoCorso: element.AnnoCorso,
                                sezioneClasse: element.Sezione
                            }
                            classiList.push(classe)
                        });
                        resolve(classiList)
                    })
                    .catch(error => {
                        reject(error)
                    })
            })
        },
        getContattiAzienda(context: DataContext, payload: { idAzienda: number, idIstituto: number }) {
            var contatto: ContattoAziendaInfo;
            var listaContatti: ContattoAziendaInfo[] = [];
            return new Promise<ContattoAziendaInfo[]>((resolve, reject) => {
                dataService.getContattiAzienda(payload.idAzienda, payload.idIstituto)
                    .then(result => {
                        result.forEach((element: any) => {
                            contatto = {
                                idContatto: element.Id,
                                idAzienda: element.IdAzienda,
                                idIstituto: element.IdIstituto,
                                nominativo: element.Nominativo,
                                telefonoUno: element.Telefono1,
                                telefonoDue: element.Telefono2,
                                fax: element.Fax,
                                email: element.EMail,
                                emailPec: element.EMailPec,
                                mansione: element.Mansione,
                                note: element.Note
                            }
                            listaContatti.push(contatto)
                        });
                        resolve(listaContatti)
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        getNoteAzienda(context: DataContext, payload: { idAzienda: number, idIstituto: number }) {
            var nota: NotaAzienda;
            var listaNote: NotaAzienda[] = [];
            return new Promise<NotaAzienda[]>((resolve, reject) => {
                dataService.getNoteAzienda(payload.idAzienda, payload.idIstituto)
                    .then(result => {
                        result.forEach((element: any) => {
                            nota = {
                                idNota: element.Id,
                                idAzienda: element.IdAzienda,
                                idIstituto: element.IdIstituto,
                                nota: element.Nota,
                                idUtenteIstituto: element.IdUtenteIstituto,
                                utenteIstituto: {
                                    idUtente: element.UtenteIstituto.Id,
                                    nome: element.UtenteIstituto.Nome,
                                    cognome: element.UtenteIstituto.Cognome
                                },
                                dataCreazione: new Date(element.DataCreazione).toLocaleString()
                            }
                            listaNote.push(nota)
                        });
                        resolve(listaNote)
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        getPreferenzeColloquio(context: DataContext, idIscrizione: number) {
            var preferenza: any;
            var listaPreferenze: any[] = []
            return new Promise<any[]>((resolve, reject) => {
                dataService.getPreferenzeColloquioAzienda(idIscrizione).then(result => {
                    result.forEach((element: any) => {
                        preferenza = {
                            idInformazioneColloquio: element.IdColloquioCV,
                            idArticolazione: element.IdArticolazione
                        }
                        listaPreferenze.push(preferenza)
                    });
                    resolve(listaPreferenze)
                }).catch(error => {
                    reject(error)
                })
            })
        },
        checkPattoCorresponsabilitaAllievo(context: DataContext, payload: { idAllievo: number, idAnnoScolastico: number, idIstituto: number }) {
            var exists: boolean = false;
            return new Promise<boolean>((resolve, reject) => {
                dataService.checkPattoCorresponsabilitaAllievo(payload.idAllievo, payload.idAnnoScolastico, payload.idIstituto).then(result => {
                    if (result.length > 0) {
                        exists = true;
                    } else {
                        exists = false
                    }
                    resolve(exists)
                }).catch(error => {
                    reject(error)
                })
            })
        },
        getAllieviIscrittiTipoAttivita(context: DataContext, payload: { idIstituto: number, idAnnoScolastico: number, tipoAttivita: string }) {
            return new Promise<StudentSubscription[]>((resolve, reject) => {
                var studentsList: any[];
                var item: StudentSubscription;
                dataService.getAllieviIscrittiTipoAttivita(payload.idIstituto, payload.idAnnoScolastico, payload.tipoAttivita)
                    .then(response => {
                        studentsList = []
                        response.forEach(function (element: any) {
                            item = {
                                tipoSoggetto: element.IdTipoSoggetto,
                                ruoloUtente: [4],
                                descrizioneRuolo: ['Allievo'],
                                nomeUtente: element.Nome,
                                cognomeUtente: element.Cognome,
                                indirizzoUtente: element.Indirizzo,
                                telefono1Utente: element.Telefono1,
                                telefono2Utente: element.Telefono2,
                                cod: element.CodiceFiscale,
                                dataNascita: element.DataNascita,
                                luogoNascita: element.LuogoNascita,
                                emailUtente: element.Email,
                                pecUtente: element.EmailPec,
                                comuneUtente: element.Localita,
                                provinciaUtente: element.IdProvincia,
                                entità: "element.Denominazione",
                                codEntità: element.IdIstituto,
                                idCap: element.IdCap,
                                idUtente: element.Id,
                                cap: element.Cap,
                                username: element.Utente,
                                matricola: element.Matricola,
                                classe: element.AnnoCorso + ' ' + element.Sezione,
                                idClasse: element.IdClasse,
                                idNazioneNascita: element.IdNazione,
                                idDocAutorizzazione: element.IdAutorizzazione,
                                idStatoDoc: element.IdStatoDoc,
                                idIstitutoAnnoScolastico: element.IdIstitutoAnnoScolastico,
                                idArticolazione: element.IdArticolazione,
                                idIscrizioneAllievo: element.IdIscrizioneAllievo,
                                gestioneAlternanza: element.GestioneAlternanza,
                                gestioneTirocinioEstivo: element.GestioneTirocinioEstivo,
                                gestioneTirocinioFormativo: element.GestioneTirocinioFormativo,
                                nomeAttivita: element.NomeAttivita,
                                diplomato: false,
                                dataDiploma: '',
                                urlCV: ""
                            }
                            studentsList.push(item)
                        })
                        resolve(studentsList)
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        getAssegnazioniAreeAziende(context: DataContext, payload: { idIstituto: number, idAnnoScolastico: number }) {
            var assegnazione: any;
            var listaAssegnazioni: any[] = []
            var dataIscrizione: any;
            return new Promise<any[]>((resolve, reject) => {
                dataService.getAssegnazioniAreeAziende(payload.idIstituto, payload.idAnnoScolastico).then(result => {
                    result.forEach((element: any) => {
                        dataIscrizione = new Date(element.DataIscrizione)
                        assegnazione = {
                            denominazioneAzienda: element.Denominazione,
                            idInformazioneCV: element.IdColloquioCV,
                            idIscrizioneAttivita: element.IdIscrizioneAttivita,
                            idArticolazione: element.IdArticolazione,
                            nomeArticolazione: element.NomeArticolazione,
                            idArea: element.IdArea,
                            nomeArea: element.Descrizione,
                            comune: element.Localita,
                            provincia: element.IdProvincia,
                            sede: element.Localita + ' (' + element.IdProvincia + ')',
                            email: element.EMail,
                            telefono: element.Telefono1,
                            dataIscrizione: dataIscrizione.getDate() + "/" + (dataIscrizione.getMonth() + 1) + "/" + dataIscrizione.getFullYear()
                        }
                        listaAssegnazioni.push(assegnazione)
                    });
                    resolve(listaAssegnazioni)
                }).catch(error => {
                    reject(error)
                })
            })
        },
        getAssegnazioniAreeAllievi(context: DataContext, payload: { idIstituto: number, idAnnoScolastico: number }) {
            var assegnazione: any;
            var listaAssegnazioni: any[] = []
            var dataIscrizione: any;
            return new Promise<any[]>((resolve, reject) => {
                dataService.getAssegnazioniAreeAllievi(payload.idIstituto, payload.idAnnoScolastico).then(result => {
                    result.forEach((element: any) => {
                        dataIscrizione = new Date(element.DataIscrizione)
                        assegnazione = {
                            allievo: element.Cognome + ' ' + element.Nome,
                            idIscrizioneAttivita: element.IdIscrizioneAttivita,
                            idArticolazione: element.IdArticolazione,
                            nomeArticolazione: element.NomeArticolazione,
                            idArea: element.IdArea,
                            nomeArea: element.Descrizione,
                            classe: element.AnnoCorso + ' ' + element.Sezione,
                            annoCorso: element.AnnoCorso,
                            sezione: element.Sezione,
                            comune: element.Localita,
                            provincia: element.IdProvincia,
                            residenza: element.Localita + ' (' + element.IdProvincia + ')',
                            email: element.Email,
                            dataIscrizione: dataIscrizione.getDate() + "/" + (dataIscrizione.getMonth() + 1) + "/" + dataIscrizione.getFullYear()
                        }
                        listaAssegnazioni.push(assegnazione)
                    });
                    resolve(listaAssegnazioni)
                }).catch(error => {
                    reject(error)
                })
            })
        },
        getAssegnazioniAllieviAttivitaSettore(context: DataContext, payload: { idIstituto: number, idAnnoScolastico: number, idSettore: number, activityType: string }) {
            return new Promise<any[]>((resolve, reject) => {
                var studentsList: any[];
                var item: any;
                var tutor: string = ""
                var tutorForm: string = ""
                dataService.getAssegnazioniAllieviAttivitaSettore(payload.idIstituto, payload.idAnnoScolastico, payload.idSettore, payload.activityType)
                    .then(response => {
                        studentsList = []
                        response.forEach(function (element: any) {
                            tutor = ""
                            tutorForm = ""
                            if (element.CognomeTutor !== null) {
                                tutor = element.CognomeTutor + " " + element.NomeTutor
                            }
                            if (element.CognomeTutorFormativo !== null) {
                                tutorForm = element.CognomeTutorFormativo + " " + element.NomeTutorFormativo
                            }
                            item = {
                                tipoSoggetto: element.IdTipoSoggetto,
                                ruoloUtente: [4],
                                descrizioneRuolo: ['Allievo'],
                                nomeUtente: element.Nome,
                                cognomeUtente: element.Cognome,
                                indirizzoUtente: element.Indirizzo,
                                telefono1Utente: element.Telefono1,
                                telefono2Utente: element.Telefono2,
                                cod: element.CodiceFiscale,
                                dataNascita: element.DataNascita,
                                luogoNascita: element.LuogoNascita,
                                emailUtente: element.Email,
                                pecUtente: element.EmailPec,
                                comuneUtente: element.Localita,
                                provinciaUtente: element.IdProvincia,
                                entità: "element.Denominazione",
                                codEntità: element.IdIstituto,
                                idCap: element.IdCap,
                                idUtente: element.Id,
                                cap: element.Cap,
                                username: element.Utente,
                                matricola: element.Matricola,
                                classe: element.AnnoCorso + ' ' + element.Sezione,
                                idClasse: element.IdClasse,
                                idNazioneNascita: element.IdNazione,
                                // idDocAutorizzazione: 0,
                                // idStatoDoc: 0,
                                // idIstitutoAnnoScolastico: 0,
                                idArticolazione: element.IdArticolazione,
                                allievo: element.Cognome + " " + element.Nome,
                                tutor: tutor,
                                idTutor: element.IdTutor,
                                gestioneAlternanza: element.GestioneAlternanza,
                                gestioneTirocinioEstivo: element.GestioneTirocinioEstivo,
                                gestioneTirocinioFormativo: element.GestioneTirocinioFormativo,
                                idDocAutorizzazione: element.IdDocAutorizzazione,
                                idStatoDoc: element.IdStatoDoc,
                                idIstitutoAnnoScolastico: element.IdIstitutoAnnoScolastico,
                                tutorFormativo: tutorForm,
                                azienda: element.Denominazione,
                                comuneTirocinio: element.ComuneTirocinio
                            }
                            studentsList.push(item)
                        })
                        resolve(studentsList)
                    }).catch(error => {
                        reject(error)
                    })
            })
        },
        getGiorniColloquiAzienda(context: DataContext, payload: { idAzienda: number, idAnnoScolastico: number, idIstituto: number }) {
            var listaGiorni: any[] = [];
            var giorno: any;
            return new Promise<any[]>((resolve, reject) => {
                dataService.getGiorniColloquiAzienda(payload.idAzienda, payload.idAnnoScolastico, payload.idIstituto).then(result => {
                    result.forEach((element: any) => {
                        giorno = {
                            dataColloquio: element.DataColloquio,
                            idArticolazione: element.IdArticolazione
                        }
                        listaGiorni.push(giorno)
                    });
                    resolve(listaGiorni)
                }).catch(error => {
                    reject(error)
                })
            })
        },
        getTurniColloquiCV(context: DataContext, payload: { idIstituto: number, idAnnoScolastico: number }) {
            var listaTurni: any[] = [];
            var turno: any;
            return new Promise<any[]>((resolve, reject) => {
                dataService.getTurniColloquiCV(payload.idIstituto, payload.idAnnoScolastico).then(result => {
                    result.forEach((element: any) => {
                        turno = {
                            turno: element.Turno,
                            idTurno: element.IdTurno
                        }
                        listaTurni.push(turno)
                    });
                    resolve(listaTurni)
                }).catch(error => {
                    reject(error)
                })
            })
        },
        getElencoFirme(context: DataContext, payload: { idRichiesta: number, activityType: string }) {
            var listaFirme: any[] = []
            var firma: any;
            var data: any;
            var timeStartMattino: any;
            var timeEndMattino: any;
            var timeStartPome: any;
            var timeEndPome: any;
            var oraInizioMattinoTmp: string;
            var oraFineMattinoTmp: string;
            var oraInizioPomeTmp: string;
            var oraFinePomeTmp: string;
            var oreMattino: any;
            var orePome: any;
            var totOre: any;
            return new Promise<any[]>((resolve, reject) => {
                dataService.getElencoFirme(payload.idRichiesta, payload.activityType).then(result => {
                    result.forEach((element: any) => {
                        data = new Date(element.DataFirma)
                        oraInizioMattinoTmp = element.OrarioInizioMattino + ":00";
                        oraFineMattinoTmp = element.OrarioFineMattino + ":00";
                        oraInizioPomeTmp = element.OrarioInizioPomeriggio + ":00";
                        oraFinePomeTmp = element.OrarioFinePomeriggio + ":00";

                        timeStartMattino = new Date("01/01/2000 " + oraInizioMattinoTmp)
                        timeEndMattino = new Date("01/01/2000 " + oraFineMattinoTmp)
                        timeStartPome = new Date("01/01/2000 " + oraInizioPomeTmp)
                        timeEndPome = new Date("01/01/2000 " + oraFinePomeTmp)

                        if (element.OrarioInizioMattino !== null && element.OrarioInizioMattino !== '') {
                            oreMattino = timeEndMattino - timeStartMattino;
                        } else {
                            oreMattino = 0;
                        }

                        if (element.OrarioInizioPomeriggio !== null && element.OrarioInizioPomeriggio !== '') {
                            orePome = timeEndPome - timeStartPome;
                        } else {
                            orePome = 0;
                        }

                        oreMattino = oreMattino / 60 / 60 / 1000;
                        orePome = orePome / 60 / 60 / 1000;

                        var truncateDecimals = function (number: any, digits: any) {
                            var multiplier = Math.pow(10, digits),
                                adjustedNum = number * multiplier,
                                truncatedNum = Math[adjustedNum < 0 ? 'ceil' : 'floor'](adjustedNum);

                            return truncatedNum / multiplier;
                        }

                        totOre = oreMattino + orePome;
                        totOre = truncateDecimals(totOre, 1);

                        firma = {
                            idFirma: element.IdFirma,
                            idRichiesta: element.IdRichiesta,
                            idTipoAttivita: element.IdTipoAttivita,
                            dataFirma: data.getDate() + "/" + (data.getMonth() + 1) + "/" + data.getFullYear(),
                            orarioInizioMattino: element.OrarioInizioMattino,
                            orarioFineMattino: element.OrarioFineMattino,
                            orarioInizioPomeriggio: element.OrarioInizioPomeriggio,
                            orarioFinePomeriggio: element.OrarioFinePomeriggio,
                            firmaAllievo: element.FirmaAllievo,
                            firmaTutorAziendale: element.FirmaTutorAziendale,
                            idStatoAccettazione: element.IdStatoAccettazione,
                            denominazioneAzienda: element.DenominazioneAzienda,
                            denominazioneIstituto: element.DenominazioneIstituto,
                            tirocinante: element.Tirocinante,
                            tutorAziendale: element.TutorAziendale,
                            cfTirocinante: element.CodiceFiscaleTirocinante,
                            firmaTutorAzienda: element.FirmaTutorAzienda,

                            orarioMattino: element.OrarioInizioMattino + " - " + element.OrarioFineMattino,
                            orarioPomeriggio: element.OrarioInizioPomeriggio + " - " + element.OrarioFinePomeriggio,
                            oreGiornaliere: totOre
                        }
                        listaFirme.push(firma)
                    });
                    resolve(listaFirme)
                }).catch(error => {
                    reject(error)
                })
            })
        },
        getIspezioneAzienda(context: DataContext, payload: { idAzienda: number, idIstituto: number }) {
            var ispezione: any;
            return new Promise<any>((resolve, reject) => {
                dataService.getIspezioneAzienda(payload.idAzienda, payload.idIstituto).then(result => {
                    var data = new Date(result.DataIspezione)
                    ispezione = {
                        dataIspezione: data.getDate() + "/" + (data.getMonth() + 1) + "/" + data.getFullYear(),
                        idIspezione: result.Id,
                        idStatoAccettazione: result.IdStatoAccettazione
                    }
                    resolve(ispezione)
                }).catch(error => {
                    reject(error)
                })
            })
        },

        getIspezione(context: DataContext, payload: { idIspezione: number }) {
            var ispezione: any;
            return new Promise<any>((resolve, reject) => {
                dataService.getIspezione(payload.idIspezione).then(result => {
                    var data = new Date(result.DataIspezione)
                    ispezione = {
                        idIspezione: payload.idIspezione,
                        dataIspezione: data.getDate() + "/" + (data.getMonth() + 1) + "/" + data.getFullYear(),
                        oraIspezione: result.OraIspezione,
                        idAzienda: result.IdAzienda,
                        idStatoAccettazione: result.IdStatoAccettazione,
                        checkUffici: result.CheckUffici,
                        ambienteUfficiIdoneo: result.AmbienteUfficiIdoneo,
                        attrezUfficiIdonea: result.AttrezUfficiIdonea,
                        checkRepLavorazione: result.CheckRepLavorazione,
                        ambienteRepLavorazioneIdoneo: result.AmbienteRepLavorazioneIdoneo,
                        attrezRepLAvorazioneIdonea: result.AttrezRepLAvorazioneIdonea,
                        checkRepAssemblaggio: result.CheckRepAssemblaggio,
                        ambienteRepAssemblaggioIdoneo: result.AmbienteRepAssemblaggioIdoneo,
                        attrezRepAssemblaggioIdonea: result.AttrezRepAssemblaggioIdonea,
                        checkMagazzino: result.CheckMagazzino,
                        ambienteMagazzinoIdoneo: result.AmbienteMagazzinoIdoneo,
                        attrezMagazzinnoIdonea: result.AttrezMagazzinnoIdonea,
                        checkSpedizioni: result.CheckSpedizioni,
                        ambienteSpedizioniIdoneo: result.AmbienteSpedizioniIdoneo,
                        attrezSpedizioniIdonea: result.AttrezSpedizioniIdonea,
                        checkCantiere: result.CheckCantiere,
                        ambienteCantiereIdoneo: result.AmbienteCantiereIdoneo,
                        attrezCantiereIdonea: result.AttrezCantiereIdonea,
                        ambientiVisitati: result.AmbientiVisitati,
                        noteAmbientiVisitati: result.NoteAmbientiVisitati,
                        osservazioniFinali: result.OsservazioniFinali,
                        valutazioneFinale: result.ValutazioneFinale,
                        firmaIspettore: result.FirmaIspettore,
                        firmaRappresentanteAzienda: result.FirmaRappresentanteAzienda,
                        dataCreazioneReport: result.DataCreazioneReport,
                        personaleUno: result.PersonaleUno,
                        personaleDue: result.PersonaleDue,
                        ruoloUno: result.RuoloUno,
                        ruoloDue: result.RuoloDue,
                        idUtenteIstituto: result.IdUtenteIstituto,
                        idIstituto: result.IdIstituto,
                        denominazioneAzienda: result.Denominazione,
                        osservatore: result.CognomeOsservatore + ' ' + result.NomeOsservatore
                    }
                    resolve(ispezione)
                }).catch(error => {
                    reject(error)
                })
            })
        },

        getAttivitaFromIscrizioneAzienda(context: DataContext, payload: { idIscrizioneAzienda: number }) {
            var attivita: any;
            return new Promise<any>((resolve, reject) => {
                dataService.getAttivitaFromIscrizioneAzienda(payload.idIscrizioneAzienda).then(result => {
                    attivita = {
                        idAttivita: result.Id,
                        idTipoAttivita: result.IdTipoAttivita,
                        dataInizio: result.DataInizio,
                        dataFine: result.DataFine,
                        nomeAttivita: result.NomeAttivita
                    }
                    resolve(attivita)
                }).catch(error => {
                    reject(error)
                })
            })
        },

        getDocDVR(context: DataContext, idRichiesta: number) {
            var docDVR: any;
            return new Promise<any>((resolve, reject) => {
                dataService.getDocDVR(idRichiesta).then(result => {
                    docDVR = {
                        idDocDVR: result.Id,
                        idStatoDocumento: result.IdStatoDocumento,
                        allegato: result.Allegato
                    }
                    resolve(docDVR)
                }).catch(error => {
                    reject(error)
                })
            })
        },
        createAbbinamentoAlternanza(context: DataContext, payload: { idAllievo: number, idIstitutoAnnoScolastico: number, idInformazioneAlternanza: number, idTutorFormativo: number }) {
            return new Promise<void>((resolve, reject) => {
                dataService.createAbbinamentoAlternanza(payload.idAllievo, payload.idIstitutoAnnoScolastico, payload.idInformazioneAlternanza, payload.idTutorFormativo).then(() => {
                    resolve()
                }).catch(error => {
                    reject(error)
                })
            })
        },
        downloadAttivitaReport(context: DataContext, payload: { idIstituto: number, idAnnoScolastico: number }) {
            return new Promise<any>((resolve, reject) => {
                dataService.downloadAttivitaReport(payload.idIstituto, payload.idAnnoScolastico).then(result => {
                    resolve(result)
                }).catch(error => {
                    reject(error)
                })
            })
        },
        downloadRendicontazionePCTOReport(context: DataContext, payload: { idIstituto: number, idAnnoScolastico: number }) {
            return new Promise<any>((resolve, reject) => {
                dataService.downloadRendicontazionePCTOReport(payload.idIstituto, payload.idAnnoScolastico).then(result => {
                    resolve(result)
                }).catch(error => {
                    reject(error)
                })
            })
        },
        getApprendistati(context: DataContext, payload: { idIstituto: number, idAnnoScolastico: number }) {
            var listaApprendistati: any[] = [];
            var dataInizio: any
            var dataFine: any
            var dataInizioTirocinio: any
            var dataFineTirocinio: any
            var dataDiploma: any
            return new Promise<any>((resolve, reject) => {
                dataService.getApprendistati(payload.idIstituto, payload.idAnnoScolastico).then(result => {
                    result.forEach((element: any) => {
                        dataInizio = element.DataInizio ? new Date(element.DataInizio) : null
                        dataFine = element.DataFine ? new Date(element.DataFine) : null
                        dataInizioTirocinio = element.DataInizioTirocinio ? new Date(element.DataInizioTirocinio) : null
                        dataFineTirocinio = element.DataFineTirocinio ? new Date(element.DataFineTirocinio) : null
                        dataDiploma = element.DataDiploma ? new Date(element.DataDiploma) : null

                        const apprendistato = {
                            idApprendistato: element.IdApprendistato,
                            idIstitutoAnnoScolastico: element.IdIstituto_AnnoScolastico,
                            annoSolare: element.AnnoSolare,
                            profiling: element.Profiling,
                            tipoContratto: element.TipoContratto,
                            idAnnoScolastico: element.IdAnnoScolastico,
                            dsAnnoScolastico: element.IdAnnoScolastico + "/" + (element.IdAnnoScolastico + 1),
                            dataInizio: element.DataInizio,
                            dataFine: element.DataFine,
                            dsDataInizio: dataInizio ? dataInizio.getDate() + "/" + (dataInizio.getMonth() + 1) + "/" + dataInizio.getFullYear() : "",
                            dsDataFine: dataFine ? dataFine.getDate() + "/" + (dataFine.getMonth() + 1) + "/" + dataFine.getFullYear() : "",
                            passaggioDaTirocinio: element.PassaggioDaTirocinio,
                            dataInizioTirocinio: element.DataInizioTirocinio,
                            dataFineTirocinio: element.DataFineTirocinio,
                            dsDataInizioTirocinio: dataInizioTirocinio ? dataInizioTirocinio.getDate() + "/" + (dataInizioTirocinio.getMonth() + 1) + "/" + dataInizioTirocinio.getFullYear() : "",
                            dsDataFineTirocinio: dataFineTirocinio ? dataFineTirocinio.getDate() + "/" + (dataFineTirocinio.getMonth() + 1) + "/" + dataFineTirocinio.getFullYear() : "",
                            proroga: element.Proroga,
                            cob: element.Cob,
                            tipoContrattoPostTirocinio: element.TipoContrattoPostTirocinio,
                            note: element.Note,

                            idAllievo: element.IdAllievoApprendistato,
                            tipoSoggetto: element.IdTipoSoggetto,
                            ruoloUtente: [4],
                            descrizioneRuolo: ['Allievo'],
                            nomeUtente: element.Nome,
                            cognomeUtente: element.Cognome,
                            indirizzoUtente: element.IndirizzoAllievo,
                            telefono1Utente: element.Telefono1Allievo,
                            telefono2Utente: element.Telefono2Allievo,
                            cod: element.CodAllievo,
                            dataNascita: element.DataNascita,
                            luogoNascita: element.LuogoNascita,
                            emailUtente: element.Email,
                            pecUtente: element.EmailPec,
                            comuneUtente: element.LocalitaAllievo,
                            provinciaUtente: element.IdProvinciaAllievo,
                            entità: "element.Denominazione",
                            codEntità: element.IdIstituto,
                            idCap: element.IdCap,
                            idUtente: element.Id,
                            cap: element.CapAllievo,
                            username: element.Utente,
                            matricola: element.Matricola,
                            classe: element.AnnoCorso + ' ' + element.Sezione,
                            idClasse: element.IdClasse,
                            idNazioneNascita: element.IdNazione,
                            idArticolazione: element.IdArticolazione,
                            nomeArticolazione: element.NomeArticolazione,
                            allievo: element.Cognome + " " + element.Nome,
                            dataDiploma: element.DataDiploma,
                            dsDataDiploma: dataDiploma ? dataDiploma.getDate() + "/" + (dataDiploma.getMonth() + 1) + "/" + dataDiploma.getFullYear() : "",
                            annoDiploma: dataDiploma ? dataDiploma.getFullYear() : '',

                            idAzienda: element.IdAziendaApprendistato,   
                            denominazioneAzienda: element.Denominazione,
                            titolo: element.Titolo,
                            cognomeRappresentanteAzienda: element.CognomeRappresentante,
                            nomeRappresentanteAzienda: element.NomeRappresentante,
                            dataNascitaRappresentante: element.DataNascitaRappresentante,
                            statoNascitaRappresentante: element.PaeseNascitaRappresentante,
                            luogoNascitaRappresentante: element.LuogoNascitaRappresentante,
                            codRappresentate: element.CFRappresentante,
                            comuneAzienda: element.LocalitaAzienda,
                            idCapComuneAzienda: element.IdCap,
                            provinciaAzienda: element.IdProvinciaAzienda,
                            indirizzoAzienda: element.IndirizzoAzienda,
                            capAzienda: element.CapAzienda,
                            telefono1Azienda: element.Telefono1Azienda,
                            telefono2Azienda: element.Telefono2Azienda,
                            faxAzienda: element.Fax,
                            emailAzienda: element.EMail,
                            pecAzienda: element.EMailPec,
                            sitoAzienda: element.SitoWeb,
                            attivitàAzienda: element.AttivitàSvolta,
                            dipendentiAzienda: element.NumeroDipendenti,
                            committenzaAzienda: element.Committenza,
                            associata: element.Associata,
                            artigiana: element.AziendaArtigiana,
                            pIva: element.PIva,
                            codAzienda: element.CodAzienda,
                            idAteco: element.IdAteco,
                            descrizioneAteco: element.CodAteco + "-" + element.DescrizioneAteco,
                            descrizioneIstat: element.CodIstat + "-" + element.DescrizioneIstat,
                            idNazioneAzienda: element.IdNazioneAzienda,
                            nazioneAzienda: element.NazioneAzienda,
                        }

                        listaApprendistati.push(apprendistato)
                    });
                    resolve(listaApprendistati)
                }).catch(error => {
                    reject(error)
                })
            })
        },
        // getTurniColloquiCV(context: DataContext, payload: { idIstituto: number, idAnnoScolastico: number }){
        //     var listaTurni: any[] = [];
        //     var turno: any;
        //     return new Promise<any[]>((resolve, reject) =>{
        //         dataService.getTurniColloquiCV(payload.idIstituto, payload.idAnnoScolastico).then(result =>{
        //             result.forEach((element: any) => {
        //                 turno = {
        //                     turno: element.Turno,
        //                     idTurno: element.IdTurno
        //                 }
        //                 listaTurni.push(turno)
        //             });
        //             resolve(listaTurni)
        //         }).catch(error =>{
        //             reject(error)
        //         })
        //     })
        // },
        // ***********Funzione di Test***********************
        getTest() {
            var id: number = 1
            return new Promise<string>((resolve, reject) => {
                dataService.getTest(id)
                    .then(response => {
                        resolve(response.data)
                    }).catch(error => {
                        reject(error)
                    })
            })
        }
    }
}

const { commit, read, dispatch } = getStoreAccessors<DataState, RootState>("data");
const getters = data.getters;

export const readComuniList = read(getters.getComuniList);
export const readAtecoList = read(getters.getAtecoList);
export const readIstatList = read(getters.getIstatList);
export const readDocNominaRespInfo = read(getters.getDocNominaResponsabile);
export const readDocAutorizzazioneStudente = read(getters.getDocAutorizzazioneStudente);
export const readStatiList = read(getters.getStatiList);
export const readAnniScolasticiList = read(getters.getAnniScolasticiList)
export const readTipiContrattoList = read(getters.getTipiContrattoList)

const actions = data.actions;

export const dispatchUsersList = dispatch(actions.getUsersList)
export const dispatchStatiList = dispatch(actions.getStatiList)
export const dispatchComuniList = dispatch(actions.getComuniList)
export const dispatchEnterprisesList = dispatch(actions.getEnterprisesList)
export const dispatchStudentsList = dispatch(actions.getStudentsList)
export const dispatchAtecoList = dispatch(actions.getAtecoList)
export const dispatchIstatList = dispatch(actions.getIstatList)
export const dispatchInstituteInfo = dispatch(actions.getInstituteInfo)
export const dispatchDocAutorizzazioneInfo = dispatch(actions.getDocAutorizzazioneInfo)
export const dispatchDocNominaRespInfo = dispatch(actions.getDocNominaRespInfo)
export const dispatchCollaborationInstitutes = dispatch(actions.getCollaborationInstitutes)
export const dispatchEnterpriseDoc = dispatch(actions.getEnterpriseDoc)
export const dispatchStudentDoc = dispatch(actions.getStudentDoc)
export const dispatchListaIndirizziStudi = dispatch(actions.getListaIndirizziStudi)
export const dispatchRichiesteAlternanza = dispatch(actions.getRichiesteAlternanza)
export const dispatchEmailFromIdDoc = dispatch(actions.getEmailFromIdDoc)
export const dispatchRespDoc = dispatch(actions.getRespDoc)
export const dispatchArticolazioni = dispatch(actions.getArticolazioni)
export const dispatchInformazioniAlternanza = dispatch(actions.getInformazioniAlternanza)
export const dispatchAssegnazioneIndirizzoStudio = dispatch(actions.getAssegnazioneIndirizzoStudio)
export const dispatchAssegnazioneArticolazione = dispatch(actions.getAssegnazioneArticolazione)
export const dispatchArticolazioniSettore = dispatch(actions.getArticolazioniSettore)
export const dispatchStudentsSettore = dispatch(actions.getStudentsSettore)
export const dispatchTutorSettore = dispatch(actions.getTutorSettore)
export const dispatchStudentsTutor = dispatch(actions.getStudentsTutor)
export const dispatchIndirizziStudioTutorArticolazione = dispatch(actions.getIndirizziStudioTutorArticolazione)
export const dispatchRichiesteAlternanzaIndirizzoStudio = dispatch(actions.getRichiesteAlternanzaIndirizzoStudio)
export const dispatchAllieviPreAssegnati = dispatch(actions.getAllieviPreAssegnati)
export const dispatchAllieviAssegnatiAzienda = dispatch(actions.getAllieviAssegnatiAzienda)
export const dispatchTutorAzienda = dispatch(actions.getTutorAzienda)
export const dispatchAreeIstituto = dispatch(actions.getAreeIstituto)
export const dispacthAllieviArea = dispatch(actions.getAllieviArea)
export const dispatchAziendeArea = dispatch(actions.getAziendeArea)
export const dispatchColloquiAzienda = dispatch(actions.getColloquiAzienda)
export const dispatchColloquiIstituto = dispatch(actions.getColloquiIstituto)
export const dispatchAllieviColloquiCV = dispatch(actions.getAllieviColloquiCV)
export const dispatchAziendeColloquiCV = dispatch(actions.getAziendeColloquiCV)
export const dispatchRichiesteTirEstivi = dispatch(actions.getRichiesteTirEstivi)
export const dispatchAllieviAssegnatiAziendaTirEstivo = dispatch(actions.getAllieviAssegnatiAziendaTirEstivo)
export const dispatchAllieviPreAssegnatiTirEstivi = dispatch(actions.getAllieviPreAssegnatiTirEstivi)
export const dispacthRichiesteTirEstiviIndirizzoStudio = dispatch(actions.getRichiesteTirEstiviIndirizzoStudio)
export const dispatchStudentsTutorTirEstivi = dispatch(actions.getStudentsTutorTirEstivi)
export const dispatchTirEstivistituto = dispatch(actions.getTirEstiviIstituto)
export const dispatchEnterpriseTutors = dispatch(actions.getEnterpriseTutors)
export const dispatchTutorFormativi = dispatch(actions.getTutorFormativi)
export const dispatchAssociazioniTutorFormativoTirEstivi = dispatch(actions.getAssociazioniTutorFormativoTirEstivi)
export const dispatchClassiIstitutoAnno = dispatch(actions.getClassiIstitutoAnno)
export const dispatchConvenzioneAttivita = dispatch(actions.getConvenzioneAttivita)
export const dispatchProgettoOrientamento = dispatch(actions.getProgettoOrientamento)
export const dispatchRichiesteTirEstiviAllievo = dispatch(actions.getRichiesteTirEstiviAllievo)
export const dispatchAllieviAssegnatiAziendaTirFormativo = dispatch(actions.getAllieviAssegnatiAziendaTirFormativo)
export const dispatchRichiesteTirFormativi = dispatch(actions.getRichiesteTirFormativi)
export const dispatchStudentsTutorTirFormativi = dispatch(actions.getStudentsTutorTirFormativi)
export const dispatchRichiesteTirFormativiIndirizzoStudio = dispatch(actions.getRichiesteTirFormativiIndirizzoStudio)
export const dispatchTirFormativiIstituto = dispatch(actions.getTirFormativiIstituto)
export const dispatchAllieviPreAssegnatiTirFormativi = dispatch(actions.getAllieviPreAssegnatiTirFormativi)
export const dispatchAssociazioniTutorFormativoTirFormativi = dispatch(actions.getAssociazioniTutorFormativoTirFormativi)
export const dispatchAssociazioniTutorAziendaleTirEstivo = dispatch(actions.getAssociazioniTutorAziendaleTirEstivo)
export const dispatchReportVisite = dispatch(actions.getReportVisite)
export const dispatchReportVisiteAdmin = dispatch(actions.getReportVisiteAdmin)
export const dispatchConsensoAttivita = dispatch(actions.getConsensoAttivita)
export const dispatchCurriculumVitae = dispatch(actions.getCurriculumVitae)
export const dispatchCurriculumAnni = dispatch(actions.getCurriculumAnni)
export const dispatchCurriculumArticolazioni = dispatch(actions.getCurriculumArticolazioni)
export const dispatchCurriculumClassi = dispatch(actions.getCurriculumClassi)
export const dispatchCurriculumAllievi = dispatch(actions.getCurriculumAllievi)
export const dispatchRichiesteTirFormativiAllievo = dispatch(actions.getRichiesteTirFormativiAllievo)
export const dispatchDetailsAbbinamentoAllievoAzienda = dispatch(actions.getDetailsAbbinamentoAllievoAzienda)
export const dispatchDetailsAbbinamentoTutorAllievo = dispatch(actions.getDetailsAbbinamentoTutorAllievo)
export const dispatchAssociazioniTutorAziendaleTirFormativo = dispatch(actions.getAssociazioniTutorAziendaleTirFormativo)
export const dispatchAttestatoFinaleInfo = dispatch(actions.getAttestatoFinaleInfo)
export const dispatchDomandeQuestionario = dispatch(actions.getDomandeQuestionario)
export const dispatchStatusQuestionario = dispatch(actions.checkStatusQuestionario)
export const dispatchRisposteQuestionario = dispatch(actions.getRisposteQuestionario)
export const dispatchListaAttivitaIstituto = dispatch(actions.getListaAttivitaIstituto)
export const dispatchListaTipiAttivita = dispatch(actions.getListaTipiAttivita)
export const dispatchConvenzioneAttivitaFromId = dispatch(actions.getConvenzioneAttivitaFromId)
export const dispatchPercorsoFormativo = dispatch(actions.getPercorsoFormativo)
export const dispatchPattoFormativo = dispatch(actions.getPattoFormativo)
export const dispatchAssociazioniTutorAziendaleAlternanza = dispatch(actions.getAssociazioniTutorAziendaleAlternanza)
export const dispatchRichiesteAlternanzaAllievo = dispatch(actions.getRichiesteAlternanzaAllievo)
export const dispatchAssociazioniTutorFormativoAlternanza = dispatch(actions.getAssociazioniTutorFormativoAlternanza)
export const dispatchAnniScolastici = dispatch(actions.getAnniScolastici)
export const dispatchStoricoSoggetto = dispatch(actions.getStoricoSoggetto)
export const dispatchLastYearSubscription = dispatch(actions.getLastYearSubscription)
export const dispatchRichiesteAttivita = dispatch(actions.getRichiesteAttivita)
export const dispatchStudentsTutorTirReIns = dispatch(actions.getStudentsTutorTirReIns)
export const dispatchAllieviPreAssegnatiTirReIns = dispatch(actions.getAllieviPreAssegnatiTirReIns)
export const dispatchAllieviAssegnatiAziendaTirReIns = dispatch(actions.getAllieviAssegnatiAziendaTirReIns)
export const dispatchRichiesteTirReInsAllievo = dispatch(actions.getRichiesteTirReInsAllievo)
export const dispatchPreferenzeWorkshopAzienda = dispatch(actions.getPreferenzeWorkshopAzienda)
export const dispatchListaIscrizioniWorkshop = dispatch(actions.getListaIscrizioniWorkshop)
export const dispatchTipiContrattoList = dispatch(actions.getTipiContrattoList)
export const dispatchListaProposteLavoroAzienda = dispatch(actions.getListaProposteLavoroAzienda)
export const dispatchListaProposteLavoroAllievi = dispatch(actions.getListaProposteLavoroAllievi)
export const dispatchQuestionariWorkshopAziende = dispatch(actions.getQuestionariWorkshopAziende)
export const dispatchQuestionariWorkshopAllievi = dispatch(actions.getQuestionariWorkshopAllievi)
export const dispatchTemplateDoc = dispatch(actions.getTemplateDoc)
export const dispatchCandidaturePropostaLavoro = dispatch(actions.getCandidaturePropostaLavoro)
export const dispatchGiorniWorkshop = dispatch(actions.getGiorniWorkshop)
export const dispatchTurniWorkshop = dispatch(actions.getTurniWorkshop)
export const dispatchAllieviAssegnatiTutor = dispatch(actions.getAllieviAssegnatiTutor)
export const dispatchClassiArticolazioneIstitutoAnno = dispatch(actions.getClassiArticolazioneIstitutoAnno)
export const dispatchListaProposteLavoroIstituto = dispatch(actions.getListaProposteLavoroIstituto)
export const dispatchContattiAzienda = dispatch(actions.getContattiAzienda)
export const dispatchNoteAzienda = dispatch(actions.getNoteAzienda)
export const dispatchPreferenzeColloquio = dispatch(actions.getPreferenzeColloquio)
export const dispatchCheckPattoCorresponsabilitaAllievo = dispatch(actions.checkPattoCorresponsabilitaAllievo)
export const dispatchAllieviIscrittiTipoAttivita = dispatch(actions.getAllieviIscrittiTipoAttivita)
export const dispatchAssegnazioniAreeAziende = dispatch(actions.getAssegnazioniAreeAziende)
export const dispatchAssegnazioniAreeAllievi = dispatch(actions.getAssegnazioniAreeAllievi)
export const dispatchAssegnazioniAllieviAttivitaSettore = dispatch(actions.getAssegnazioniAllieviAttivitaSettore)
export const dispatchGiorniColloquiAzienda = dispatch(actions.getGiorniColloquiAzienda)
export const dispatchTurniColloquiCV = dispatch(actions.getTurniColloquiCV)
export const dispatchElencoFirme = dispatch(actions.getElencoFirme)
export const dispatchIspezioneAzienda = dispatch(actions.getIspezioneAzienda)
export const dispatchIspezione = dispatch(actions.getIspezione)
export const dispatchConvenzioneDigitale = dispatch(actions.getConvenzioneDigitale)
export const dispatchDocDigitaleById = dispatch(actions.getDocDigitaleById)
export const dispatchPercorsoFormativoDigitale = dispatch(actions.getPercorsoFormativoDigitale)
export const dispatchGetAttivitaFromIscrizioneAzienda = dispatch(actions.getAttivitaFromIscrizioneAzienda)
export const dispatchDocDVR = dispatch(actions.getDocDVR)
export const dispatchCreateAbbinamentoAlternanza = dispatch(actions.createAbbinamentoAlternanza)
export const dispatchDownloadAttivitaReport = dispatch(actions.downloadAttivitaReport)
export const dispatchDownloadRendicontazionePCTOReport = dispatch(actions.downloadRendicontazionePCTOReport)
export const dispatchGetApprendistati = dispatch(actions.getApprendistati)

// ***********Funzione di Test***********************
export const dispatchTest = dispatch(actions.getTest)

const mutations = data.mutations;

export const commitSetComuniList = commit(mutations.setComuniList);
export const commitSetAtecoList = commit(mutations.setAtecoList);
export const commitSetIstatList = commit(mutations.setIstatList);
export const commitDocNominaResp = commit(mutations.setDocNominaResp);
export const commitDocAutorizzazioneStudente = commit(mutations.setDocAutorizzazioneStudente);
export const commitSetStatiList = commit(mutations.setStatiList);
export const commitSetAnniScolasticiList = commit(mutations.setAnniScolasticiList)
export const commitSetTipoContrattoList = commit(mutations.setTipiContrattoList)